<template>
  <div class="form-wrap">
    <form id="mainForm" class="project-form" >
        <input type="hidden" v-model="reseter.counter">
        <section class="project-details" v-if="step == 'selection'">
            <table class="ses-project">
                <template v-if="isSU()">
                    <tr class="ses-row">
                        <td class="ses-label">Status</td>
                        <td class="static">
                            <select v-model="model.go_custom" required ref="customer" @change="handleStatusChange($event)">
                                <option value="">Standard</option>
                                <option value="CUSTOM">Custom</option>
                            </select>
                        </td>
                    </tr>
                </template>
                <tr class="ses-row">
                    <template v-if="isSU()">
                        <td class="ses-label">Customer</td>
                        <td class="static">
                            <!-- <select v-model="model.project.customer_id" required ref="customer" @change="handleItemsListByCustomer">
                                <option :value="customer.id" v-for="(customer,k) in customers" :key="k">{{ customer.username }}</option>
                            </select> -->
                            <input 
                                type="text" 
                                v-model="customer"
                                required
                                ref="customer"
                                list="customerlist"
                                :disabled="isedit"
                                @keydown.enter="customerSelect(customer)"
                                v-on:input="changingCustomer($event)"
                            >
                            <datalist id="customerlist">
                                <option v-for="(customer,k) in customers" :key="k" :value="customer.username">{{ customer.company }}</option>
                            </datalist>
                        </td>
                    </template>
                    <template v-else>
                        <td class="ses-label">Company Name</td>
                        <td class="static">{{ model.project.company_name }}</td>
                    </template>

                    <td class="ses-label">Date of Survey</td>
                    <td class="static">{{ model.project.date_of_survey }}</td>
                </tr>
                <tr class="ses-row">
                    <td class="ses-label">Your Name</td>
                    <td>
                        <div class="name-wrap">
                            <input 
                                type="text" 
                                v-model="model.project.customer_name"
                                required
                                ref="customer_name"
                                list="namelist"
                                @keydown.enter="nameSelect(model.project.customer_name)"
                                v-on:input="changingName($event)"
                            >
                            <datalist id="namelist">
                                <option v-for="(row, key) in user.other_names" :key="key">{{ row.name }}</option>
                            </datalist>
                            <!-- <base-dropdown position="right">
                                <span class="dropdown-item" @click="set_name('other')">Other</span>
                                <span class="dropdown-item" v-for="(row, key) in user.other_names" :key="key" @click="set_name(row)">{{ row.name }}</span>
                            </base-dropdown> -->
                        </div>
                    </td>
                    <td class="ses-label">Consultant Name</td>
                    <td><input type="text" v-model="model.project.consultant_name" ref="consultant_name"></td>
                </tr>
                <tr class="ses-row">
                    <td class="ses-label">Your Email</td>
                    <td><input type="email" v-model="model.project.customer_email" required ref="customer_email"></td>

                    <td class="ses-label">Your Phone</td>
                    <td>
                        <div class="phone-wrap">
                            <masked-input mask="\+11" v-model="phone.code" class="phone_code" ref="phone_code" autocomplete="disabled"/>
                            <masked-input mask="(111) 111-1111" v-model="phone.number" class="phone_number" ref="phone_number" autocomplete="disabled"/>
                        </div>
                    </td>
                </tr>
                <tr class="ses-row">
                    <td class="ses-label"><strong>Project Name</strong></td>
                    <td><input type="text" v-model="model.project.project_name" ref="project_name" required @keydown="errors.project_name=false" maxlength="100"></td>

                    <td class="ses-label">Seismic Provisions Required</td>
                    <td>
                        <select v-model="model.project.seismic" required ref="seismic" class="select-full">
                            <option value="TRUE">Yes</option>
                            <option value="FALSE" selected>No</option>
                        </select>
                    </td>
                </tr>
                <tr class="ses-row">
                    <td class="ses-label" rowspan="2"><strong>Project Address</strong></td>
                    <td colspan="2"><input type="text" placeholder="Address" v-model="model.project.address" class="proj-address" ref="address"></td>
                    <td><input type="text" placeholder="City" v-model="model.project.city" ref="city"></td>
                </tr>
                <tr class="ses-row">
                    <td>
                        <select v-model="model.project.country" required ref="country" @change="countryChange">
                            <option value="">Country</option>
                            <template v-if="user.country == 'US' || user.country == 'USA'">
                                <option value="USA">USA</option>
                                <option value="Canada">Canada</option>
                                <option value="Mexico">Mexico</option>
                                <option value="Puerto Rico">Puerto Rico</option>
                                <option value="Turks and Caicos Islands">Turks and Caicos Islands</option>
                                <option value="Cayman Islands">Cayman Islands</option>
                            </template>
                            <template v-else-if="user.country">
                                <option :value="user.country">{{ user.country }}</option>
                            </template>
                            <template v-else>
                                <option value="Canada">Canada</option>
                                <option value="Mexico">Mexico</option>
                                <option value="Puerto Rico">Puerto Rico</option>
                                <option value="Turks and Caicos Islands">Turks and Caicos Islands</option>
                                <option value="Cayman Islands">Cayman Islands</option>
                            </template>
                        </select>
                    </td>
                    <td>
                        <select v-model="model.project.state" required ref="state" v-if="model.project.country == 'USA' || model.project.country == 'Canada'" @change="stateChange">
                            <optgroup label="States:" v-if="model.project.country == 'USA'">
                                <option :value="state" v-for="(state,k) in states" :key="k">{{ state }}</option>
                            </optgroup>
                            <optgroup label="Provinces:" v-if="model.project.country == 'Canada'">
                                <option :value="province" v-for="(province,k) in provinces" :key="k">{{ province }}</option>
                            </optgroup>
                        </select>
                        <input type="text" placeholder="State" v-model="model.project.state" required ref="state" v-else>
                    </td>
                    <td><input type="text" placeholder="Zip Code" v-model="model.project.zip" class="proj-zip" ref="zip"></td>
                </tr>
                <tr class="ses-row">
                    <td class="ses-label">Number of Cars <small>(range: 1-26)</small></td>
                    <td><input type="number" v-model="num_cars" required ref="num_cars" @keyup="setCars" @blur="setCars" :disabled="model.project.form_type == 'selection'"></td>

                    <td class="ses-label">Contract Number</td>
                    <td><input type="text" v-model="model.project.contract_number"></td>
                </tr>
                <tr class="ses-row">
                    <td class="ses-label">Car ID Number(s)</td>
                    <td colspan="3" class="ses-flex-wrap">
                        <div class="ses-flex">
                            <div class="ses-col" v-for="(car,cn) in model.cars" :key="cn">
                                <input type="text" v-model="car.car_id_number" ref="car_id_number" class="col" placeholder="Car #" :data-cn="cn" required :disabled="model.project.form_type == 'selection'">
                            </div>
                        </div>
                    </td>
                </tr>
                <tr class="ses-row" v-if="false">
                    <td class="ses-label">Machine Type</td>
                    <td colspan="3">
                        <select v-model="model.project.machine_type" required ref="machine_type" class="select-full" @change="machChange">
                            <option value="traction">Traction</option>
                            <option value="hydraulic">Hydraulic Power Unit</option>
                        </select>
                    </td>
                </tr>
                <tr class="ses-row" v-if="rtype == 'construction'">
                    <td class="ses-label">Traction Machine System</td>
                    <td colspan="3">
                        <div class="form_type">
                            <label><input type="radio" name="form_type" v-model="model.project.form_type" @change="formChange" value="survey_form" checked> Survey Form</label> 
                            <label><input type="radio" name="form_type" v-model="model.project.form_type" @change="formChange" value="selection" > I Know the Part #</label>
                        </div>
                    </td>
                </tr>
            </table>
            <template v-if="false">
                <br><br>
                <div class="proj-set proj-flex proj-set-lg">
                    <label>Company Name</label>
                    <div><input type="text" v-model="model.project.company_name" readonly></div>
                </div>
                <div class="proj-set proj-flex">
                    <label>Date of Survey</label>
                    <div><input type="text" v-model="model.project.date_of_survey" readonly></div>
                </div>
                <div class="proj-set proj-flex proj-set-lg">
                    <label>Your Name</label>
                    <div><input type="text" v-model="model.project.customer_name" required ref="customer_name"></div>
                </div>
                <div class="proj-set proj-flex">
                    <label>Consultant name</label>
                    <div><input type="text" v-model="model.project.consultant_name" required ref="consultant_name"></div>
                </div>
                <div class="proj-set proj-flex proj-set-lg">
                    <label>Your Email</label>
                    <div><input type="email" v-model="model.project.customer_email" required ref="customer_email"></div>
                </div>
                <div class="proj-set proj-flex proj-set">
                    <label>Your Phone</label>
                    <div><masked-input mask="\+\0\1 (111) 111-1111" v-model="model.project.customer_phone" class="vc" ref="customer_phone" autocomplete="disabled"/></div>
                </div>
                <div class="proj-set proj-flex proj-set-full">
                    <label class="proj-label-lg"><strong>Project Name</strong></label>
                    <div><input type="text" v-model="model.project.project_name" ref="project_name" required></div>
                </div>
                <div class="proj-set proj-flex proj-set-location">
                    <label class="proj-label-lg"><strong>Project Address</strong></label>
                    <div><input type="text" placeholder="Address" v-model="model.project.address" class="proj-address" required ref="address"></div>
                    <div><input type="text" placeholder="City" v-model="model.project.city" required ref="city"></div>
                    <div style="display: block;"></div>
                    <div>
                        <select v-model="model.project.country" required @change="countryChange">
                            <option value="USA">USA</option>
                            <option value="Canada">Canada</option>
                            <option value="Mexico">Mexico</option>
                            <option value="Puerto Rico">Puerto Rico</option>
                            <option value="Turks and Caicos Islands">Turks and Caicos Islands</option>
                            <option value="Cayman Islands">Cayman Islands</option>
                        </select>
                    </div>
                    <div>
                        <select v-model="model.project.state" required v-if="model.project.country == 'USA' || model.project.country == 'Canada'" ref="country" style="width: 199px;" @change="stateChange">
                            <optgroup label="States:" v-if="model.project.country == 'USA'">
                                <option :value="state" v-for="(state,k) in states" :key="k">{{ state }}</option>
                            </optgroup>
                            <optgroup label="Provinces:" v-if="model.project.country == 'Canada'">
                                <option :value="province" v-for="(province,k) in provinces" :key="k">{{ province }}</option>
                            </optgroup>
                        </select>
                        <input type="text" placeholder="State" v-model="model.project.state" required v-else style="width: 200px;">
                    </div>
                    <div><input type="text" placeholder="Zip Code" v-model="model.project.zip" class="proj-zip" ref="zip" style="margin-top: 1px;"></div>
                </div>
                <div class="proj-set proj-flex proj-set-lg">
                    <label>Number of Cars</label>
                    <div><input type="number" v-model="num_cars" required ref="num_cars" @keyup="setCars"></div>
                </div>
                <div class="proj-set proj-flex proj-set">
                    <label>Contract Number</label>
                    <div><input type="text" v-model="model.project.contract_number"></div>
                </div>

                <div class="proj-set proj-set-full">
                    <label>Car ID Number(s)</label>
                    <div class="row">
                        <div class="col" v-for="(car,cn) in model.cars" :key="cn">
                            <input type="text" v-model="car.car_id_number" ref="car_id_number" class="col" placeholder="Car #" :data-cn="cn" required>
                        </div>
                    </div>
                </div>
                <div class="proj-set proj-flex proj-set-full">
                    <label class="proj-label-lg">Seismic Provisions Required</label>
                    <div>
                        <select v-model="model.project.seismic" required ref="seismic" class="select-full">
                            <option value="TRUE">Yes</option>
                            <option value="FALSE" selected>No</option>
                        </select>
                    </div>
                </div>

                <div class="proj-set proj-set-full" v-if="rtype == 'construction'">
                    <label>Traction Machine System</label>
                    <div class="row">
                        <div class="col form_type">
                            <label><input type="radio" name="form_type" v-model="model.project.form_type" @change="formChange" value="survey_form" checked> Survey Form</label> 
                            <label><input type="radio" name="form_type" v-model="model.project.form_type" @change="formChange" value="selection" > I Know the Part #</label>
                        </div>
                    </div>
                </div>
            </template>
        </section>

        <section class="project-selections" v-if="step == 'selection' && model.project.form_type == 'survey_form'">
            <div class="row">
                <div class="col-md-6 selection">
                    <label :style="'background-image: url(/api/public/img/form/machine.jpg?v=3);background-position: 110px 15px;'">
                        <template v-if="rtype === 'modernization'" >
                            <input name="machine_type" type="radio" v-model="model.project.machine_type" value="traction" :checked="model.project.machine_type == 'traction'" @change="machChange">
                        </template>
                        <template v-else>
                          <input type="checkbox" v-model="steps['machine_system']" :value="1" ref="'machine_system'" @change="stepChange('machine_system', $event)">
                        </template>
                        Traction Machine System
                    </label>
                    <template>
                        <div class="doc-wrap">
                            <a class="link" href="/api/sp/view/WebsiteAsset/Standard Catalog Final.pdf?dir=Brochure/Machines" target="_blank">DOC</a>
                        </div>
                    </template>
                    <ul>
                        <li v-for="(sub,x) in machine_subs" :key="x">{{ sub }}</li>
                    </ul>
                </div>
                <div class="col-md-6 selection">
                    <label :style="'background-image: url(/api/public/img/form/hydraulic.jpg?v=3);background-position: 110px 15px;border-right: 1px solid black;'">
                        <input name="machine_type" type="radio" v-model="model.project.machine_type" value="hydraulic" :checked="model.project.machine_type == 'hydraulic'" @change="machChange">
                        Hydraulic Power Unit
                    </label>
                    <template>
                        <div class="doc-wrap">
                            <a class="link" href="/api/sp/view/WebsiteAsset/submersible_power_units_2018.pdf?dir=Brochure/Elevator Components/Hydraulic Power Unit" target="_blank">DOC</a>
                        </div>
                    </template>
                </div>
                <template v-for="(sel,s) in selections">
                    <div class="col-md-4 selection" :key="s" v-if="!sel.hidden">
                        <label :style="'background-image: url(/api/public/img/form/'+sel.icon+'?v=3)'">
                            <input type="checkbox" v-model="steps[sel.key]" :value="s+1" :ref="sel.key" @change="stepChange(sel.key,$event)">
                            {{ sel.label }}
                        </label>
                        <template v-if="Array.isArray(sel.doc)">
                            <div class="doc-wrap">
                                <base-dropdown title="DOC" position="right">
                                    <a class="dropdown-item" v-for="(doc, key) in sel.doc" :key="key" :href="doc.path" :target="[doc.path != '#' ? '_blank' : '']">{{ doc.name }}</a>
                                </base-dropdown>
                            </div>
                        </template>
                        <template v-else-if="sel.doc">
                            <div class="doc-wrap">
                                <a class="link" :href="sel.doc" :target="[sel.doc != '#' ? '_blank' : '']">DOC</a>
                            </div>
                        </template>
                        <ul v-if="sel.subs">
                            <li v-for="(sub,x) in sel.subs" :key="x">{{ sub }}</li>
                        </ul>
                        <div v-if="!sel.selectable" class="invi-cover"></div>
                    </div>
                </template>
            </div>
        </section>

        <section class="project-section project-section-1" v-if="step == 'machine_system'">

            <div class="warning" v-if="model.project.form_type == 'selection'">
                Warning: If you want to order wire rope, compensation chain or safety gear, please fill the survey form to order.
            </div>
            <div class="sform selform" v-if="model.project.form_type == 'selection'">
                <div class="selection-car row" v-for="(car,c) in model.cars" :key="c">
                    <div class="col-md-7">
                        <div class="car-selection">
                            <h3>Select Items</h3>
                            <select v-model="car.category" @change="searchItems(car)">
                                <option value="" selected>Select Category</option>
                                <option value="Machines">Machines</option>
                                <option value="Systems">Systems</option>
                                <option value="Door System">Door System</option>
                                <option value="Components">Components</option>
                                <option value="Parts">Parts</option>
                                <option value="Service">Service</option>
                            </select>
                            <div class="sel-filter" v-if="car.category">
                                <input type="text" v-model="car.search" @keyup="searchItems(car)" onkeydown="return event.key != 'Enter';" placeholder="Search">
                                <ul v-if="car.category && car.list" class="selection_items">
                                    <li class="selection_item" v-for="(item,i) in car.list" :key="i">
                                        {{ item.item }} <span>$ {{ sesCurr(item.price) }}</span><a @click="addItem(c,item)">Add Item</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <div class="car-items">
                            <h3>Items</h3>
                            <div class="car-item-list">
                                <div class="car-item car-item-head">
                                    <label class="car-item">Item</label>
                                    <label class="car-price">Price</label>
                                    <label class="car-qty">Qty</label>
                                </div>
                                <div class="car-item" v-for="(item,i) in car.items" :key="i">
                                    <label>{{ item.item }}</label>
                                    <span>
                                        $ {{ sesCurr(item.price) }} &times;
                                        <input type="number" v-model="item.qty" class="sel-item-qty">
                                    </span>
                                    <a @click="removeItem(c,i)">&times;</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="sform" v-else>
            <h2 class="proj-s1">SECTION #1 - For Bidding</h2>

            <div class="top-scroll">
                <div class="top-scroll-body"></div>
            </div>

            <div class="proj-labels">
                <div class="proj-section1 proj-group">
                    <div class="proj-s1" v-if="model.cars[2]"><label> Copy From</label></div>
                    <div class="proj-nn"><label> Car ID Number <small>(One car per column)</small></label></div>
                    <div :class="`proj-r${requiredRowsSpan}`" class="proj-s1 no-pt no-pl">
                        <div class="proj-split-lbl">
                            <div class="vertical-text">
                                <div class="v-required"></div>
                            </div>
                            <div class="split-left-align split-labels">
                                <div class="bb bl text-bold">
                                    <label>Geared or Gearless</label>
                                </div>
                                <div class="bb bl text-bold">
                                    <label>Machine Location</label>
                                </div>
                                <div class="bb bl text-bold">
                                    <label>Roping Ratio</label>
                                </div>
                                <div class="bb bl text-bold">
                                    <label>Elevator Capacity <small>(lb)</small></label>
                                </div>
                                <div class="bb bl text-bold">
                                    <label>Elevator Speed <small>(fpm)</small></label>
                                </div>
                                <div class="bl text-bold" :class="{ 'bb': hasNonOHMR }">
                                    <label> Travel <small>(ft) (range: 10-2999) <a :title="`Assume 12' per landing if unknown during bidding.`" style="font-size:11px;font-weight:normal;"><span class="bg-diamond"><i>(?)</i></span></a></label>
                                </div>
                                <div :hidden="hidableRows.machine_shape" class="bl text-bold" :class="{ 'bb': !hidableRows.basement_layout || !hidableRows.tpm_flat_mount }">
                                    <label> Machine Shape </label>
                                </div>
                                <div :hidden="hidableRows.basement_layout" class="bl text-bold" :class="{ 'bb': !hidableRows.tpm_flat_mount }">
                                    <label class="ilbot"> Basement Machine Room Layout <ses-tooltip type="illu-B4"></ses-tooltip>: <small>(select option A, B, C or other)</small></label>
                                </div>
                                <div :hidden="hidableRows.tpm_flat_mount" class="bl text-bold">
                                    <label> Is the Pancake Installed Flat </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div :hidden="hidableRows.machine_shape" class="proj-s1"><label> Machine Shape </label></div>
                    <div :hidden="hidableRows.basement_layout" class="proj-s1 siw"><label class="ilbot"> Basement Machine Room Layout <ses-tooltip type="illu-B4"></ses-tooltip>:<br><small>(select option A, B, C or other)</small></label></div>
                    <div :hidden="hidableRows.tpm_flat_mount" class="proj-s1"><label> Is the Pancake Installed Flat </label></div> -->
                    <div class="proj-s1"><label> Existing Rope Diameter Size </label></div>
                    <div class="proj-s1"><label> Will New Rope Diameter Need to Match Existing? </label></div>
                    <div class="proj-s1"><label> Drive Output Voltage </label></div>
                    <div class="proj-s1"><label> Drive Manufacturer <a :title="`Required for drive compatibility, Yaskawa/Magnetek and KEB have identical pricing for reference quotes. Must be verified before ordering.`" style="font-size:11px;"><span class="bg-diamond"><i>(?)</i></span></a></label></div>
                    <div :hidden="hidableRows.encoder_cable" class="proj-s1"><label> Encoder Cable Length </label></div>
                    
                    <div class="proj-s1 proj-h2"><label> <h2>System Options</h2></label></div>
                    <div class="proj-s1"><label> Empty Car Weight <small>(lbs) (range: 1000-50000)</label></div>
                    <div class="proj-s1"><label> Preferred Counterweight <small>(%) (range: 40-50)</label></div>
                    <div class="proj-s1 proj-r2 no-pt no-pl">
                        <div class="proj-split-lbl">
                            <div class="">
                                <label>
                                    Emergency Brake Option<br>
                                    <small>(Check One, list preferred HW model if selected)</small>
                                </label>
                            </div>
                            <div class="split-left-align">
                                <div class="bb bl" style="padding-top:1px;">
                                    <label>TDNA Standard</label>
                                </div>
                                <div class="bb bl">
                                    <label>HW Rope Gripper</label>
                                </div>
                                <!-- <div class="bl">
                                    <label>TDNA Rope Brake</label>
                                </div> -->
                            </div>
                        </div>
                    </div>

                    <div class="proj-s1"><label> {{ strExt() }} Compensation Density <small>(range: 0-9)</small></label></div>
                    <div :hidden="hidableRows.weight_comp_sheave" class="proj-s1"><label> Weight of {{ strExt() }} Compensation Sheave <small>(lbs)<br>(range: 0-9999)</small> </label></div>
                    <div class="proj-s1"><label> Double Wrap Roping Required? </label></div>
                    <div class="proj-s1"><label> Specified Acceleration Rate <small>(ft/s2) (range: 1-5)</small> </label></div>
                    <div class="proj-s1 proj-r5 no-pt no-pl s1-end">
                        <div class="proj-split-lbl">
                            <div class="">
                                <label>
                                    Items to Quote:<br>
                                    <small>(Check All Required)</small> 
                                </label>
                            </div>
                            <div class="split-left-align">
                                <div class="bb bl">
                                    <label>Machine</label>
                                </div>
                                <div class="bb bl">
                                    <label>Bedplate</label>
                                </div>
                                <div class="bb bl">
                                    <label>Rope Guard</label>
                                </div>
                                <div class="bb bl">
                                    <label>Deflector</label>
                                </div>
                                <div class=" bl">
                                    <label>Encoder Cable</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="proj-section1 proj-group" v-if="step == 'yes'">
                </div>
                <div class="proj-section2 proj-group" v-if="model.project.is_final == 'yes'">
                    <div class="proj-s2 proj-h2"><label> <h2>SECTION #2 - For Drawings</h2> </label></div>
                    <div class="proj-s2 proj-h2 proj-h2-field">
                        <label class="rb2"> {{ lead_stw }}-Week Lead Time Option Preferred? <a title="Stock machine can be more expensive than regular machine."><span class="bg-diamond"><i>!</i></span></a></label>
                        <select v-model="model.project.use_stock" ref="use_stock" @change="typeChange" :disabled="customerNoStock === 1">
                            <option value="yes">Yes</option>
                            <option value="no">No</option>
                        </select>
                    </div>
                    <div class="proj-s2 proj-h2 proj-h2-field">
                        <label class="rb2"> Estimated Project Start Date <a :title="'Earliest ship date is today plus '+lead_stw+' weeks.'" style="font-size:15px;"><span class="bg-diamond"><i>?</i></span></a></label>
                        <div class="start_date_wrap">
                            <date-picker 
                                v-model="start_date"
                                :input-attr="{required:'required',ref:'start_date'}"
                                :disabled-date="(date) => date <= disabledBefore"
                                :default-value="disabledBefore"
                                :value-type="'format'"
                                type="date"
                                class="s2"
                                ref="start_date"
                                required
                                @change="startDateChange"
                            ></date-picker>
                        </div>
                    </div>
                    <div :hidden="hidableRows.right_left_machine" class="proj-s2 siw"><label> Right or Left Hand Machine? <ses-tooltip type="illu-1"></ses-tooltip></label></div>
                    <div class="proj-s1"><label> If compensation is required, do you prefer 1 or 2 chains? </label></div>
                    <div :hidden="hidableRows.onsite_assembly" class="proj-s2"><label> On-Site Reassembly Service<br><small>(Only Available for Large Gearless TGL Machines)</small></label></div>
                    <!-- <div class="proj-s2 siw"><label> Number of Floors above Lobby</label></div> -->
                    <div :hidden="hidableRows.rope_drop_distance" class="proj-s2 siw"><label> Rope Drop Distance <small>(in) (range: 10-99)</small> <ses-tooltip type="illu-2"></ses-tooltip></label></div>
                    <div :hidden="hidableRows.rope_to_machine_wall" class="proj-s2 siw"><label> Rope to Machine Room Wall <small>(in) (range: 0-99)</small> <ses-tooltip type="illu-2"></ses-tooltip></label></div>
                    <div :hidden="hidableRows.machine_room_height_clearance" class="proj-s2 siw"><label> Machine Room Height Clearance <small>(in) (range: 20-300)</small> <ses-tooltip type="illu-2"></ses-tooltip></label></div>
                    <div :hidden="hidableRows.existing_machine_beam_location" class="proj-s2 siw"><label> {{ strExt() }} Machine Beam Location <ses-tooltip type="illu-3" align="top"></ses-tooltip></label></div>
                    <div :hidden="hidableRows.ct" class="proj-s2 siw"><label> CT - Concrete Slab Thickness <small>(in) (range: 0-20 and 0-Ww)</small> <ses-tooltip type="illu-3" align="top"></ses-tooltip></label></div>
                    <div :hidden="hidableRows.wf_beam_width" class="proj-s2 siw"><label> Wf - Beam Width <small>(in) (range: 0-20)</small> <ses-tooltip type="illu-3" align="top"></ses-tooltip></label></div>
                    <div :hidden="hidableRows.ww_beam_height" class="proj-s2 siw"><label> Ww - Beam Height <small>(in) (range: 0-20 and CT-20)</small> <ses-tooltip type="illu-3" align="top"></ses-tooltip></label></div>
                    <div :hidden="hidableRows.z1" class="proj-s2 siw"><label> Z1 <small>(in) (range: 0-50) (Outermost Beam)</small> <ses-tooltip type="illu-2" align="top"></ses-tooltip></label></div>
                    <div :hidden="hidableRows.z2" class="proj-s2 siw"><label> Z2 <small>(in) (range: 0-50 or 72 - Z1) (Outermost Beam)</small> <ses-tooltip type="illu-2" align="top"></ses-tooltip></label></div>

                    <div :hidden="hidableRows.deflector_in_overhead && (!showPadsOnFloors || hidableRows.pads_on_floors)" class="proj-s2 proj-h2"><label> <h2>Special Bedplate Configurations (Optional)</h2> </label></div>
                    <div v-if="showPadsOnFloors" :hidden="hidableRows.pads_on_floors" class="proj-s2"><label> Isolation on Floor Option </label></div>
                    <div :hidden="hidableRows.deflector_in_overhead" class="proj-s2"><label> Prefer Deflector Mounted Below Slab <ses-tooltip type="illu-def-slab" align="top"></ses-tooltip></label></div>
                    <template v-if="model.project.phase=='modernization'">
                        <!-- for new dflector in overhead -->
                        <div :hidden="hidableRows.existing_deflector_sheave" class="proj-s2"><label> Keep Existing Deflector or Replace with New? </label></div>
                        <div :hidden="hidableRows.deflector_sheave_diameter || hidableRows.number_of_ropes || hidableRows.groove_pitch || hidableRows.ys" class="proj-s2"><label> If retaining Deflector: </label></div>
                        <div :hidden="hidableRows.deflector_sheave_diameter" class="proj-s2"><label> <i class="ind"></i>Ddef - Deflector Sheave Diameter <small>(in) (range: 0-99)</small></label></div>
                        <div :hidden="hidableRows.number_of_ropes" class="proj-s2"><label> <i class="ind"></i>Number of Existing Deflector Grooves <small>(range: 0-99)</small></label></div>
                        <div :hidden="hidableRows.groove_pitch" class="proj-s2"><label> <i class="ind"></i>Groove Pitch (Center of rope to rope) <small>(in)<br>(range: 0-9)</small> </label></div>
                        <div :hidden="hidableRows.ys" class="proj-s2 siw"><label class="ilbot"> <i class="ind"></i>Ys - Bottom of Slab to Deflector Centerline <small>(in) (range: 0-30)</small> <ses-tooltip type="illu-3" align="top"></ses-tooltip></label></div>
                    </template>

                    <div :hidden="hidableRows.angled_bedplate" class="proj-s2"><label> Rope Drop Square to the Wall <ses-tooltip type="illu-ab1" align="top"></ses-tooltip></label></div>
                    <div :hidden="hidableRows.angle_profile" class="proj-s2"><label> <i class="ind"></i>Angle Profile <ses-tooltip type="illu-ab1" align="top"></ses-tooltip></label></div>
                    <div :hidden="hidableRows.car_rope_x1" class="proj-s2"><label> <i class="ind"></i>X1 - Car Rope to Wall <small>(in) (range: 0-99)</small> <ses-tooltip type="illu-ab1" align="top"></ses-tooltip></label></div>
                    <div :hidden="hidableRows.car_rope_x2" class="proj-s2"><label> <i class="ind"></i>X2 - Car Rope to Wall <small>(Perpendicular) (in) (range: 0-99)</small> <ses-tooltip type="illu-ab1" align="top"></ses-tooltip></label></div>
                    <div :hidden="hidableRows.car_rope_x3" class="proj-s2"><label> <i class="ind"></i>X3 - Car Rope to Wall 2 <small>(Perpendicular) (in) (range: 0-99)</small> <ses-tooltip type="illu-ab1" align="top"></ses-tooltip></label></div>
                    
                    <template v-if="model.project.phase=='modernization'">
                        <div :hidden="hidableRows.basement_config" class="proj-s2 proj-h2"><label> <h2>Basement Inputs</h2></label></div>
                        <div :hidden="hidableRows.basement_config" class="proj-s2"><label> Basement Configuration <ses-tooltip type="illu-B4"></ses-tooltip></label></div>
                        <div :hidden="hidableRows.basement_pattern" class="proj-s2"><label> Existing Machine / Anchor Pattern</label></div>
                        <div :hidden="hidableRows.basement_anchor" class="proj-s2"><label> Anchor Bolt Height Above Floor <small>(in)</small></label></div>
                        <div :hidden="hidableRows.basement_thread" class="proj-s2"><label> Thread Length of Anchor Bolts <small>(in)</small></label></div>
                        <div :hidden="hidableRows.basement_sheave_diameter" class="proj-s2"><label> Existing Sheave Diameter <small>(range: 0-99)</small></label></div>
                        <div :hidden="hidableRows.basement_rope_diameter" class="proj-s2"><label> Existing Rope Diameter</label></div>
                        <div :hidden="hidableRows.basement_rope_number" class="proj-s2"><label> Existing Rope Number <small>(range: 0-20)</small></label></div>
                        <div :hidden="hidableRows.basement_pitch" class="proj-s2"><label> Existing Pitch <small>(range: 0-10)</small></label></div>

                        <div :hidden="hidableRows.basement_mr1" class="proj-s2 proj-h2"><label> <h2>Basement A Configuration Inputs</h2></label></div>
                        <div :hidden="hidableRows.basement_mr1" class="proj-s2"><label> MR1 <small>(range: 0-999)</small> &nbsp; <ses-tooltip type="illu-B8" align="top"></ses-tooltip></label></div>
                        <div :hidden="hidableRows.basement_mr1" class="proj-s2"><label> MR2 <small>(range: 0-999)</small> &nbsp; <ses-tooltip type="illu-B8" align="top"></ses-tooltip></label></div>
                        <div :hidden="hidableRows.basement_mr1" class="proj-s2"><label> MR3 <small>(range: 0-999)</small> &nbsp; <ses-tooltip type="illu-B8" align="top"></ses-tooltip></label></div>
                        <div :hidden="hidableRows.basement_mr1" class="proj-s2"><label> MR4 <small>(range: 0-999)</small> &nbsp; <ses-tooltip type="illu-B8" align="top"></ses-tooltip></label></div>

                        <div :hidden="hidableRows.basement_mr1b" class="proj-s2 proj-h2"><label> <h2>Basement B Configuration Inputs</h2></label></div>
                        <div :hidden="hidableRows.basement_mr1b" class="proj-s2"><label> MR1 <small>(range: 0-999)</small> &nbsp; <ses-tooltip type="illu-B9" align="top"></ses-tooltip></label></div>
                        <div :hidden="hidableRows.basement_mr1b" class="proj-s2"><label> MR2 <small>(range: 0-999)</small> &nbsp; <ses-tooltip type="illu-B9" align="top"></ses-tooltip></label></div>
                        <div :hidden="hidableRows.basement_mr1b" class="proj-s2"><label> MR3 <small>(range: 0-999)</small> &nbsp; <ses-tooltip type="illu-B9" align="top"></ses-tooltip></label></div>
                        <div :hidden="hidableRows.basement_mr1b" class="proj-s2"><label> DF1 <small>(range: 0-999)</small> &nbsp; <ses-tooltip type="illu-B9" align="top"></ses-tooltip></label></div>
                        <div :hidden="hidableRows.basement_mr1b" class="proj-s2"><label> DF2 <small>(range: 0-999)</small> &nbsp; <ses-tooltip type="illu-B9" align="top"></ses-tooltip></label></div>
                        <div :hidden="hidableRows.basement_mr1b" class="proj-s2"><label> RD <small>(range: 0-999)</small> &nbsp; <ses-tooltip type="illu-B9" align="top"></ses-tooltip></label></div>

                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2 proj-h2"><label> <h2>Basement C Configuration Inputs</h2></label></div>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2"><label> MR1 <small>(range: 0-999)</small> &nbsp; <ses-tooltip type="illu-B10" align="top"></ses-tooltip></label></div>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2"><label> MR2 <small>(range: 0-999)</small> &nbsp; <ses-tooltip type="illu-B10" align="top"></ses-tooltip></label></div>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2"><label> MR3 <small>(range: 0-999)</small> &nbsp; <ses-tooltip type="illu-B10" align="top"></ses-tooltip></label></div>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2"><label> DF1 <small>(range: 0-999)</small> &nbsp; <ses-tooltip type="illu-B10" align="top"></ses-tooltip></label></div>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2"><label> DF2 <small>(range: 0-999)</small> &nbsp; <ses-tooltip type="illu-B10" align="top"></ses-tooltip></label></div>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2"><label> DF3 <small>(range: 0-999)</small> &nbsp; <ses-tooltip type="illu-B10" align="top"></ses-tooltip></label></div>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2"><label> DF4 <small>(range: 0-999)</small> &nbsp; <ses-tooltip type="illu-B10" align="top"></ses-tooltip></label></div>
                    
                    </template>
                </div>
            </div>

            <div class="proj-cars"><div class="proj-car" v-for="(car,cn) in model.cars" :key="cn">
                <div class="proj-section1 proj-group">
                    <!-- <div class="proj-s1 hidden">
                        <div class="proj-split">
                            <a class="btn btn-primary" @click="duplicate(cn)">Duplicate</a>
                            <a class="btn btn-danger" @click="remove(cn)">Remove</a>
                            <a class="btn btn-success" @click="newCar(cn)">New</a>
                        </div>
                        <input type="hidden" v-model="car.excluded_components" class="excluded_components">
                    </div> -->
                    <div class="proj-s1" v-if="model.cars[2]">
                        <select v-model="car.copier" required  @change="copyInput(car.copier,cn,0)">
                            <template v-for="(ccar,ccn) in model.cars">
                                <option :value="ccn" :key="ccn" v-if="cn != ccn">Car #{{ ccar.car_id_number }}</option>
                            </template>
                        </select>
                    </div>
                    <div class="proj-nn"><input type="text" v-model="car.car_id_number" placeholder="Car ID Number" required readonly></div>
                    <div class="proj-s1">
                        <select v-model="car.gear" required @change="carChange('gear',cn)" :ref="cn+'__gear'">
                            <option value="TRUE" v-if="car.machine_location != 'MRL' && car.double_wrap != 'TRUE'">Geared</option>
                            <option value="FALSE">Gearless</option>
                        </select>
                    </div>
                    <div class="proj-s1">
                        <select v-model="car.machine_location" required  @change="carChange('machine_location',cn)" ref="machine_location">
                            <option value="MRL">MRL</option>
                            <option value="OHMR">Overhead MR</option>
                            <option value="BASEMENT">Basement</option>
                        </select>
                    </div>
                    <div class="proj-s1">
                        <select v-model="car.roping" required ref="roping" @change="carChange('roping',cn)">
                            <option value="1">1 to 1</option>
                            <option value="2">2 to 1</option>
                            <option value="3">3 to 1</option>
                            <option value="4">4 to 1</option>
                        </select>
                    </div>
                    <div class="proj-s1">
                        <select v-model="car.capacitysel" required @change="carChange('capacitysel',cn)" ref="capacitysel">
                            <option value="1500">1500</option>
                            <option value="2000">2000</option>
                            <option value="2500">2500</option>
                            <option value="3000">3000</option>
                            <option value="3500">3500</option>
                            <option value="4000">4000</option>
                            <option value="4500">4500</option>
                            <option value="5000">5000</option>
                            <option value="5500">5500</option>
                            <option value="6000">6000</option>
                            <option value="8000">8000</option>
                            <option value="10000">10000</option>
                            <option value="12000">12000</option>
                            <option value="Other">Other</option>
                        </select>
                        <input :type="car.capacitysel == 'Other'?'number':'hidden'" v-model="car.capacity" @change="carChange('capacity',cn)">
                    </div>
                    <div class="proj-s1">
                        <select v-model="car.speedsel" required @change="carChange('speedsel',cn)" ref="speedsel">
                            <option value="50">50</option>
                            <option value="75">75</option>
                            <option value="100">100</option>
                            <option value="150">150</option>
                            <option value="200">200</option>
                            <option value="250">250</option>
                            <option value="300">300</option>
                            <option value="350">350</option>
                            <option value="400">400</option>
                            <option value="450">450</option>
                            <option value="500">500</option>
                            <option value="600">600</option>
                            <option value="700">700</option>
                            <option value="800">800</option>
                            <option value="1000">1000</option>
                            <option value="1200">1200</option>
                            <option value="1400">1400</option>
                            <option value="Other">Other</option>
                        </select>
                        <input :type="car.speedsel == 'Other'?'number':'hidden'" v-model="car.speed" @change="carChange('speed',cn)" @blur="carChange('speed',cn)">
                    </div>
                    <div class="proj-s1">
                        <input 
                            type="number" 
                            v-model="car.travel" 
                            required
                            @change="carChange('travel',cn)" 
                            @blur="rangeSub(cn,0,'travel',10,2999)"
                            ref="travel"
                        >
                    </div>
                    <div :hidden="hidableRows.machine_shape" class="proj-s1">
                        <select v-model="car.machine_shape" :disabled="car.machine_location != 'MRL'" required ref="machine_shape" :data-cn="cn" @change="carChange('machine_shape',cn)">
                            <option value="Barrel">Barrel</option>
                            <option value="Pancake">Pancake</option>
                        </select>
                    </div>
                    <div :hidden="hidableRows.basement_layout" class="proj-s1">
                        <select
                            v-model="car.basement_layout"
                            :disabled="car.machine_location != 'BASEMENT' || car.bedplate == 'FALSE'"
                            required
                            @change="carChange('basement_layout',cn)"
                            ref="basement_layout"
                        >
                            <option value="A">A</option>
                            <option value="B">B</option>
                            <option value="C">C</option>
                            <option value="Other">Other</option>
                        </select>
                    </div>
                    <div :hidden="hidableRows.tpm_flat_mount" class="proj-s1">
                        <select v-model="car.tpm_flat_mount" :disabled="car.machine_shape != 'Pancake'" required ref="tpm_flat_mount">
                            <option></option>
                            <option value="100">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </div>
                    <div class="proj-s1">
                        <select
                            ref="rope_diameter"
                            v-model="car.rope_diameter"
                            required
                            class="proj-rope-diameter"
                            @change="carChange('rope_diameter', cn)">
                                <option value="1/2">1/2</option>
                                <option value="5/8">5/8</option>
                                <option value="3/4">3/4</option>
                                <option value="8mm">8mm</option>
                                <option value="10mm">10mm</option>
                                <option value="Unknown">Unknown</option>
                        </select>
                    </div>
                    <div class="proj-s1 j-center">
                        <!-- <label :for="`rope_diameter_required_${cn}`">
                            <input
                                ref="rope_diameter_required"
                                :checked="car.rope_diameter_required === 'Y'"
                                :id="`rope_diameter_required_${cn}`"
                                :name="`rope_diameter_required_${cn}`"
                                type="checkbox"
                                @change="ropeDiameterToggle(cn, 'rope_diameter_required')">
                        </label> -->
                        <select
                            ref="rope_diameter_required"
                            :id="`rope_diameter_required_${cn}`"
                            v-model="car.rope_diameter_required"
                            :disabled="car.rope_diameter === 'Unknown'"
                            required
                            @change="carChange('rope_diameter_required', cn)">
                                <option value=""></option>
                                <option value="Y">Yes</option>
                                <option value="N">No</option>
                        </select>
                    </div>
                    <div class="proj-s1">
                        <select
                            v-model="car.vac"
                            required
                            ref="vac"
                            @change="carChange('vac', cn)">
                            <option></option>
                            <template v-if="car.drive_manufacturer != 'KONE KDM 90'">
                                <option value="208-230" v-if="car.drive_manufacturer != 'Otis (No Cable Supplied)'">208-230</option>
                                <option value="460-480">460-480</option>
                            </template>
                            <option value="360" v-if="car.drive_manufacturer == 'KONE KDM 90'">360 (special)</option>
                            <option v-if="model.project.is_final == 'no'" value="Unknown">Unknown</option>
                        </select>
                    </div>
                    <div class="proj-s1">
                        <select
                            ref="drive_manufacturer"
                            v-model="car.drive_manufacturer"
                            required
                            @change="carChange('drive_manufacturer',cn)">
                            <option value="KEB">KEB</option>
                            <option value="KEB Green" v-if="user.functions.includes('kebgrn')">KEB Green</option>
                            <option value="Yaskawa/Magnetek">Yaskawa/Magnetek</option>
                            <option value="Schindler">Schindler</option>
                            <option value="KONE KDM 90">KONE KDM 90</option>
                            <option value="TKE (No Cable Supplied)">TKE (No Cable Supplied)</option>
                            <option value="Otis (No Cable Supplied)">Otis (No Cable Supplied)</option>
                            <option value="Others (No Cable Supplied)">Others (No Cable Supplied)</option>
                            <option v-if="model.project.is_final != 'yes'" value="None Selected">None Selected</option>
                        </select>
                    </div>
                    <div class="proj-s1" :hidden="hidableRows.encoder_cable">
                        <select 
                            v-model="car.encoder_cable"
                            required
                            ref="encoder_cable"
                            :disabled="car.encoder != 'TRUE' || (car.drive_manufacturer && (car.drive_manufacturer.includes('No Cable Supplied'))) || !car.drive_manufacturer || !car.gear || !enc_cables || !enc_cables[car.gear] || (!enc_cables[car.gear][car.drive_manufacturer] && !enc_cables[car.gear]['All'] && car.drive_manufacturer != 'None Selected') || (car.gear === 'TRUE' && car.drive_manufacturer === 'Schindler')"
                            @change="carChange('encoder_cable', cn)"
                        >
                            <template v-if="enc_cables && enc_cables[car.gear] && enc_cables[car.gear][car.drive_manufacturer]">
                                <option :value="enc" v-for="(enc,k) in enc_cables[car.gear][car.drive_manufacturer]" :key="k">{{ enc }}</option>
                            </template>
                            <template v-if="enc_cables && enc_cables[car.gear] && enc_cables[car.gear]['All']">
                                <option :value="enc" v-for="(enc,k) in enc_cables[car.gear]['All']" :key="k">{{ enc }}</option>
                            </template>
                            <template v-if="enc_cables && enc_cables[car.gear] && enc_cables[car.gear]['KEB'] && car.drive_manufacturer == 'None Selected'">
                                <option :value="enc" v-for="(enc,k) in enc_cables[car.gear]['KEB']" :key="k">{{ enc }}</option>
                            </template>
                        </select>
                    </div>
                    <div class="proj-s1 proj-h2"><label> <h2>System Options</h2> </label></div>
                    <div class="proj-s1">
                        <select v-model="car.ecwsel" required @change="carChange('ecwsel',cn)" ref="ecwsel">
                            <option :value="car.capacity*1.5" v-if="car.capacity">{{ car.capacity*1.5 }}</option>
                            <option value="Other">Other</option>
                        </select>
                        <input
                            v-model="car.empty_car_weight"
                            :required="model.project.is_final == 'yes'"
                            @change="carChange('empty_car_weight',cn)"
                            @blur="rangeSub(cn,0,'empty_car_weight',1000,50000)"
                            :type="car.ecwsel == 'Other'?'number':'hidden'"
                            ref="empty_car_weight"
                        >
                    </div>
                    <div class="proj-s1">
                        <input
                            type="number"
                            v-model="car.counterweight"
                            :required="model.project.is_final == 'yes'"
                            @change="carChange('counterweight',cn)"
                            @blur="rangeSub(cn,0,'counterweight',40,50)"
                            ref="counterweight"
                        >
                    </div>

                    <!-- brake -->
                    <div class="proj-s1 j-center"><label><input type="checkbox" :checked="car.tdi_emergency_brake == 'TRUE'" @change="bolToggle(cn,'tdi_emergency_brake')">&nbsp;</label></div>
                    <div class="proj-s1 j-center" stylex="height: 55px;">
                        <div class="proj-split">
                            <div class="">
                                <label class="proj-chk mbt-3"><input type="checkbox" :disabled="car.machine_location == 'MRL'" :checked="car.hw_rope_gripper == 'TRUE'" @change="bolToggle(cn,'hw_rope_gripper')">&nbsp;</label>
                                <!-- <div style="clear:both;border-top:1px solid black;"></div>
                                <label class="proj-chk mbt-3"><input type="checkbox" :disabled="car.machine_location == 'MRL'" :checked="car.ses_rope_brake == 'TRUE'" @change="bolToggle(cn,'ses_rope_brake')">&nbsp;</label> -->
                            </div>
                            <select v-model="car.hw_rope_gripper_model" :disabled="car.ses_rope_brake !== 'TRUE' && car.hw_rope_gripper !== 'TRUE'" required stylex="height: 55px;" ref="hw_rope_gripper_model">
                                <option value="HW620">HW620</option>
                                <option value="HW622">HW622</option>
                                <option value="HW624">HW624</option>
                                <option value="HW626">HW626</option>
                                <option value="HW626-SPL">HW626-SPL</option>
                            </select>
                        </div>
                    </div>
                    <!-- brake -->
                    
                    <div class="proj-s1">
                        <input
                            type="number"
                            v-model="car.compensation"
                            :required="model.project.is_final == 'yes'"
                            @change="carChange('compensation',cn)"
                            @blur="rangeSub(cn,0,'compensation',0,9)"
                            ref="compensation"
                        >
                    </div>
                    <div :hidden="hidableRows.weight_comp_sheave" class="proj-s1">
                        <input
                            type="number"
                            v-model="car.weight_comp_sheave"
                            :required="model.project.is_final == 'yes'"
                            :disabled="car.compensation <= 0"
                            ref="weight_comp_sheave"
                            @blur="rangeSub(cn,0,'weight_comp_sheave',0,9999)"
                        >
                    </div>
                    <div class="proj-s1">
                        <select
                            :ref="cn+'__double_wrap'"
                            v-model="car.double_wrap"
                            :required="model.project.is_final == 'yes'"
                            @change="carChange('double_wrap', cn)">
                            <option></option>
                            <option value="TRUE">Yes</option>
                            <option value="FALSE">No</option>
                        </select>
                    </div>
                    <div class="proj-s1">
                        <input
                            type="number"
                            v-model="car.acceleration"
                            :required="model.project.is_final == 'yes'"
                            ref="acceleration"
                            value="2.5"
                            @change="carChange('acceleration',cn)"
                            @blur="rangeSub(cn,0,'acceleration',1,5)"
                        >
                    </div>
                    <!-- to quote -->
                    <div class="proj-s1 static-cover-wrap j-center"><label><input type="checkbox" checked></label><small class="static-cover"></small></div>
                    <div class="proj-s1 j-center">
                        <label>
                            <input 
                                type="checkbox" 
                                :checked="car.bedplate == 'TRUE'" 
                                @change="bolToggle(cn,'bedplate')" 
                                :disabled="car.machine_location == 'MRL' || (model.project.phase == 'construction' && car.machine_location != 'OHMR')"
                            >
                        </label>
                    </div>
                    <div class="proj-s1 j-center">
                        <label>
                            <input
                                type="checkbox"
                                :checked="car.rope_guard == 'TRUE'"
                                @change="bolToggle(cn,'rope_guard')"
                                :disabled="(car.machine_location && car.machine_location != 'OHMR') || car.bedplate != 'TRUE'"
                            >
                        </label>
                    </div>
                    <div class="proj-s1 j-center">
                        <label>
                            <input
                                type="checkbox"
                                :checked="car.deflector == 'TRUE'"
                                @change="bolToggle(cn,'deflector')"
                                :disabled="(car.machine_location && car.machine_location != 'OHMR')"
                            >
                        </label>
                    </div>
                    <div class="proj-s1 j-center s1-end">
                        <label>
                            <input
                                type="checkbox"
                                :checked="car.encoder == 'TRUE'"
                                @change="bolToggle(cn,'encoder')"
                                :disabled="car.drive_manufacturer && car.drive_manufacturer.includes('No Cable Supplied')"
                            >
                        </label>
                    </div>
                </div>

                <div class="proj-section2 proj-group" v-if="model.project.is_final == 'yes'">
                    <div class="proj-s2"></div>
                    <div class="proj-s2"></div>
                    <div class="proj-s2"></div>
                    <div :hidden="hidableRows.right_left_machine" class="proj-s2">
                        <select 
                            v-model="car.right_left_machine" 
                            class="s2" 
                            required 
                            :disabled="car.machine_location == 'MRL'" 
                            ref="right_left_machine"
                        >
                            <option></option>
                            <option value="LEFT">Left</option>
                            <option value="RIGHT">Right</option>
                        </select>
                    </div>
                    <div class="proj-s1">
                        <select v-model="car.chains" required ref="chains">
                            <option value="1">1</option>
                            <option value="2">2</option>
                        </select>
                    </div>
                    <div :hidden="hidableRows.onsite_assembly" class="proj-s2">
                        <select 
                            v-model="car.onsite_assembly"
                            class="s2"
                            required
                            ref="onsite_assembly"
                            :disabled="car.gear != 'FALSE' || car.machine_location != 'OHMR'"
                        >
                            <option value="no">No</option>
                            <option value="yes">Yes</option>
                        </select>
                    </div>
                    <!-- <div class="proj-s2"><input type="number" ref="no_of_floors" v-model="car.no_of_floors" class="s2" required></div> -->
                    
                    
                    <div :hidden="hidableRows.rope_drop_distance" class="proj-s2">
                        <input 
                            type="number" 
                            ref="rope_drop_distance"
                            v-model="car.rope_drop_distance" 
                            @change="carChange('rope_drop_distance',cn)" 
                            @blur="rangeSub(cn,0,'rope_drop_distance',10,99)"
                            title="Rope Drop Distance (in)" 
                            class="s2 g-msr" 
                            required 
                            :disabled="car.bedplate != 'TRUE' || car.machine_location != 'OHMR'"
                        >
                    </div>
                    <div :hidden="hidableRows.rope_to_machine_wall" class="proj-s2">
                        <input
                            type="number" 
                            ref="rope_to_machine_wall" 
                            v-model="car.rope_to_machine_wall" 
                            @change="carChange('rope_to_machine_wall',cn)" 
                            @blur="rangeSub(cn,0,'rope_to_machine_wall',0,99)"
                            class="s2 g-msr" 
                            required 
                            :disabled="car.bedplate != 'TRUE' || car.machine_location != 'OHMR'"
                        >
                    </div>
                    <div :hidden="hidableRows.machine_room_height_clearance" class="proj-s2">
                        <input 
                            type="number" 
                            ref="machine_room_height_clearance" 
                            v-model="car.machine_room_height_clearance" 
                            @change="carChange('machine_room_height_clearance',cn)" 
                            @blur="rangeSub(cn,0,'machine_room_height_clearance',20,300)"
                            class="s2 g-msr" 
                            required 
                            :disabled="car.bedplate != 'TRUE' || car.machine_location != 'OHMR'"
                        >
                    </div>

                    <div :hidden="hidableRows.existing_machine_beam_location" class="proj-s2">
                        <select 
                            ref="existing_machine_beam_location" 
                            v-model="car.existing_machine_beam_location" 
                            class="s2 g-msr" 
                            required 
                            @change="carChange('existing_machine_beam_location',cn)" 
                            :disabled="car.bedplate != 'TRUE' || car.machine_location != 'OHMR'"
                        >
                            <option></option>
                            <option value="A">A</option>
                            <option value="B">B</option>
                            <option value="C">C</option>
                            <option value="D">D</option>
                            <option value="E">E</option>
                        </select>
                    </div>
                    <div :hidden="hidableRows.ct" class="proj-s2">
                        <input
                            type="number" 
                            ref="ct" 
                            v-model="car.ct" 
                            class="s2 g-msr" 
                            required 
                            @change="carChange('ct',cn)" 
                            @blur="rangeSub(cn,0,'ct',0,(car.ww_beam_height && car.existing_machine_beam_location == 'C') ? parseFloat(car.ww_beam_height) : 20)"
                            :disabled="car.bedplate != 'TRUE' || car.machine_location != 'OHMR'"
                        >
                    </div>
                    <div :hidden="hidableRows.wf_beam_width" class="proj-s2">
                        <input 
                            type="number" 
                            ref="wf_beam_width" 
                            v-model="car.wf_beam_width" 
                            @change="carChange('wf_beam_width',cn)" 
                            @blur="rangeSub(cn,0,'wf_beam_width',0,20)"
                            class="s2 g-msr" 
                            required 
                            :disabled="car.bedplate != 'TRUE' || car.machine_location != 'OHMR' || car.existing_machine_beam_location == 'E'"
                        >
                    </div>
                    <div :hidden="hidableRows.ww_beam_height" class="proj-s2">
                        <input 
                            type="number" 
                            ref="ww_beam_height" 
                            v-model="car.ww_beam_height" 
                            @change="carChange('ww_beam_height',cn)" 
                            @blur="rangeSub(cn,0,'ww_beam_height',(car.ct && car.existing_machine_beam_location == 'C') ? parseFloat(car.ct) : 0,20)"
                            class="s2 g-msr" 
                            min="0" 
                            max="36" 
                            required 
                            :disabled="car.bedplate != 'TRUE' || car.machine_location != 'OHMR' || car.existing_machine_beam_location == 'E'"
                        >
                    </div>
                    <div :hidden="hidableRows.z1" class="proj-s2">
                        <input 
                            type="number" 
                            ref="z1" 
                            v-model="car.z1" 
                            @change="carChange('z1',cn)" 
                            @blur="rangeSub(cn,0,'z1',0,50)"
                            class="s2 g-msr" 
                            required 
                            :disabled="car.bedplate != 'TRUE' || car.machine_location != 'OHMR' || car.existing_machine_beam_location == 'E'"
                        >
                    </div>
                    <div :hidden="hidableRows.z2" class="proj-s2">
                        <input 
                            type="number" 
                            ref="z2" 
                            v-model="car.z2" 
                            @change="carChange('z2',cn)" 
                            @blur="rangeSub(cn,0,'z2',0,(car && car.z1 ? ( 72 - car.z1) : 50))"
                            class="s2 g-msr" 
                            required 
                            :disabled="car.bedplate != 'TRUE' || car.machine_location != 'OHMR' || car.existing_machine_beam_location == 'E'"
                        >
                    </div>
                    <!-- special bedplate -->
                    <div :hidden="hidableRows.deflector_in_overhead && (!showPadsOnFloors || hidableRows.pads_on_floors)" class="proj-s2"></div>
                    <div :hidden="hidableRows.pads_on_floors" v-if="showPadsOnFloors" class="proj-s2 pads-on-floors">
                        <label>
                            <input
                                type="checkbox"
                                :checked="car.pads_on_floors === 'TRUE'"
                                :disabled="car.bedplate === 'FALSE'"
                                ref="pads_on_floors"
                                @change="bolToggle(cn,'pads_on_floors')">
                        </label>
                    </div>
                    <div :hidden="hidableRows.deflector_in_overhead" class="proj-s2">
                        <select
                            ref="deflector_in_overhead" 
                            v-model="car.deflector_in_overhead" 
                            class="s2"
                            :disabled="car.machine_location != 'OHMR'"
                            @change="carChange('deflector_in_overhead', cn)"
                        >
                            <option></option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                    <template v-if="model.project.phase=='modernization'">
                        <div :hidden="hidableRows.existing_deflector_sheave" class="proj-s2">
                            <select
                                ref="existing_deflector_sheave" 
                                v-model="car.existing_deflector_sheave" 
                                class="s2"
                                :disabled="car.bedplate != 'TRUE' || car.machine_location != 'OHMR'"
                                @change="carChange('existing_deflector_sheave', cn)"
                            >
                                <option></option>
                                <option value="YES">Retain Deflector</option>
                                <option value="NO">Replace Deflector</option>
                            </select>
                        </div>
                        <div :hidden="hidableRows.deflector_sheave_diameter || hidableRows.number_of_ropes || hidableRows.groove_pitch || hidableRows.ys" class="proj-s2 sss"></div>
                        <div :hidden="hidableRows.deflector_sheave_diameter" class="proj-s2">
                            <input
                                type="number" 
                                ref="deflector_sheave_diameter" 
                                v-model="car.deflector_sheave_diameter" 
                                @blur="rangeSub(cn,0,'deflector_sheave_diameter',0,99)"
                                class="s2 g-eds" 
                                required
                                :disabled="car.existing_deflector_sheave != 'YES'" 
                            >
                        </div>
                        <div :hidden="hidableRows.number_of_ropes" class="proj-s2">
                            <input
                                type="number" 
                                ref="number_of_ropes" 
                                v-model="car.number_of_ropes" 
                                @blur="rangeSub(cn,0,'number_of_ropes',0,20)"
                                :disabled="car.existing_deflector_sheave != 'YES'" 
                                class="s2 g-eds" 
                                required
                            >
                        </div>
                        <div :hidden="hidableRows.groove_pitch" class="proj-s2">
                            <input
                                type="number" 
                                ref="groove_pitch" 
                                v-model="car.groove_pitch" 
                                @blur="rangeSub(cn,0,'groove_pitch',0,9)"
                                :disabled="car.existing_deflector_sheave != 'YES'" 
                                class="s2 g-eds" 
                                required
                            >
                        </div>
                        <div :hidden="hidableRows.ys" class="proj-s2">
                            <input
                                type="number" 
                                ref="ys" 
                                v-model="car.ys" 
                                @blur="rangeSub(cn,0,'ys',0,30)"
                                :disabled="car.existing_deflector_sheave != 'YES'" 
                                class="s2 g-eds" 
                                required
                            >
                        </div>
                    </template>
                    <!-- special bedplate -->
                    
                    <!-- angled bedplate -->
                    <div :hidden="hidableRows.angled_bedplate" class="proj-s2">
                        <select 
                            v-model="car.angled_bedplate"
                            ref="angled_bedplate"
                            class="s2"
                            @change="carChange('angled_bedplate',cn)" 
                            :disabled="car.bedplate != 'TRUE' || car.machine_location != 'OHMR'"
                        >
                            <option></option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                    <div :hidden="hidableRows.angle_profile" class="proj-s2">
                        <select
                            ref="angle_profile" 
                            v-model="car.angle_profile" 
                            class="s2" 
                            required 
                            @change="carChange('angle_profile',cn)" 
                            :disabled="car.angled_bedplate != 'No'"
                        >
                            <option></option>
                            <option value="A">A</option>
                            <option value="B">B</option>
                            <option value="C">C</option>
                            <option value="D">D</option>
                        </select>
                    </div>
                    <div :hidden="hidableRows.car_rope_x1" class="proj-s2">
                        <input
                            type="number" 
                            ref="car_rope_x1" 
                            v-model="car.car_rope_x1" 
                            @change="carChange('car_rope_x1',cn)" 
                            @blur="rangeSub(cn,0,'car_rope_x1',parseFloat(car.car_rope_x2 ) > 0 ? parseFloat(car.car_rope_x2) + .01 : 0, 99)"
                            class="s2" 
                            required 
                            :disabled="car.angled_bedplate != 'No'"
                        >
                    </div>
                    <div :hidden="hidableRows.car_rope_x2" class="proj-s2">
                        <input
                            type="number" 
                            ref="car_rope_x2" 
                            v-model="car.car_rope_x2" 
                            @blur="rangeSub(cn,0,'car_rope_x2',0,parseFloat(car.car_rope_x1) > 0 ? parseFloat(car.car_rope_x1) - .01 : 99)"
                            class="s2" 
                            required 
                            :disabled="car.angled_bedplate != 'No'"
                        >
                    </div>
                    <div :hidden="hidableRows.car_rope_x3" class="proj-s2">
                        <input 
                            type="number" 
                            ref="car_rope_x3" 
                            v-model="car.car_rope_x3" 
                            @blur="rangeSub(cn,0,'car_rope_x3',(parseFloat(car.car_rope_x1) > 0 && parseFloat(car.car_rope_x2) > 0 ? Math.sqrt(Math.pow(parseFloat(car.car_rope_x1),2) - Math.pow(parseFloat(car.car_rope_x2),2)) : 0),99)"
                            class="s2" 
                            required 
                            :disabled="car.angled_bedplate != 'No' || car.angle_profile == 'A' || car.angle_profile == 'B'"
                        >
                    </div>
                    <!-- angled bedplate -->
                    
                    <template v-if="model.project.phase=='modernization'">
                    <div :hidden="hidableRows.basement_config" class="proj-s2"></div>
                    <div :hidden="hidableRows.basement_config" class="proj-s2">
                        <select
                            ref="basement_config" 
                            v-model="car.basement_config" 
                            class="s2" 
                            required 
                            @change="carChange('basement_config',cn)" 
                            :disabled="car.machine_location != 'BASEMENT' || car.bedplate != 'TRUE'"
                        >
                            <option></option>
                            <option value="A">A</option>
                            <option value="B">B</option>
                            <option value="C">C</option>
                            <option value="Other">Other</option>
                        </select>
                    </div>
                    <div :hidden="hidableRows.basement_pattern" class="proj-s2">
                        <select
                            ref="basement_pattern" 
                            v-model="car.basement_pattern" 
                            class="s2" 
                            required 
                            @change="carChange('basement_pattern',cn)" 
                            :disabled="car.machine_location != 'BASEMENT' || car.bedplate != 'TRUE'"
                        >
                            <option></option>
                            <option>Westinghouse 28</option>
                            <option>Westinghouse 38</option>
                            <option>Otis 6119 BN/BP</option>
                            <option>Otis 6176BG</option>
                            <option>Otis A7078T</option>
                            <option>Otis A7116T</option>
                            <option>TKE GD-1</option>
                            <option>TKE GD-2</option>
                            <option>TKE GD-105</option>
                            <option>TKE-GD-240</option>
                            <option>TKE GD-300</option>
                            <option>HW #43/44</option>
                            <option>HW #53/54</option>
                            <option>HW #63/64</option>
                            <option>HW #74</option>
                            <option>Armor 4BB</option>
                            <option>Montgomery 208E</option>
                            <option>Montgomery 210E</option>
                            <option>Other</option>
                        </select>
                    </div>
                    <div :hidden="hidableRows.basement_anchor" class="proj-s2">
                        <input
                            type="number" 
                            ref="basement_anchor" 
                            v-model="car.basement_anchor"
                            @blur="rangeSub(cn,0,'basement_anchor',0,99)"
                            :disabled="car.machine_location != 'BASEMENT' || car.bedplate != 'TRUE'" 
                            class="s2 g-eds" 
                            required
                        >
                    </div>
                    <div :hidden="hidableRows.basement_thread" class="proj-s2">
                        <input
                            type="number" 
                            ref="basement_thread" 
                            v-model="car.basement_thread"
                            @blur="rangeSub(cn,0,'basement_thread',0,car.basement_anchor)"
                            :disabled="car.machine_location != 'BASEMENT' || car.bedplate != 'TRUE'" 
                            class="s2 g-eds" 
                            required
                        >
                    </div>
                    <div :hidden="hidableRows.basement_sheave_diameter" class="proj-s2">
                        <input
                            type="number" 
                            ref="basement_sheave_diameter" 
                            v-model="car.basement_sheave_diameter"
                            @blur="rangeSub(cn,0,'basement_sheave_diameter',0,99)"
                            :disabled="car.machine_location != 'BASEMENT' || car.bedplate != 'TRUE'" 
                            class="s2 g-eds" 
                            required
                        >
                    </div>
                    <div :hidden="hidableRows.basement_rope_diameter" class="proj-s2">
                        <select
                            ref="basement_rope_diameter" 
                            v-model="car.basement_rope_diameter" 
                            class="s2" 
                            required 
                            @change="carChange('basement_rope_diameter',cn)" 
                            :disabled="car.machine_location != 'BASEMENT' || car.bedplate != 'TRUE'"
                        >
                            <option></option>
                            <option value="8mm">8mm</option>
                            <option value="10mm">10mm</option>
                            <option value="1/2">1/2</option>
                            <option value="5/8">5/8</option>
                            <option value="3/4">3/4</option>
                        </select>
                    </div>
                    <div :hidden="hidableRows.basement_rope_number" class="proj-s2">
                        <input
                            type="number" 
                            ref="basement_rope_number" 
                            v-model="car.basement_rope_number"
                            @blur="rangeSub(cn,0,'basement_rope_number',0,20)"
                            :disabled="car.machine_location != 'BASEMENT' || car.bedplate != 'TRUE'" 
                            class="s2 g-eds" 
                            required
                        >
                    </div>
                    <div :hidden="hidableRows.basement_pitch" class="proj-s2">
                        <input
                            type="number" 
                            ref="basement_pitch" 
                            v-model="car.basement_pitch"
                            @blur="rangeSub(cn,0,'basement_pitch',0,10)"
                            :disabled="car.machine_location != 'BASEMENT' || car.bedplate != 'TRUE'" 
                            class="s2 g-eds" 
                            required
                        >
                    </div>

                    <div :hidden="hidableRows.basement_mr1" class="proj-s2"></div>
                    <template v-if="car.basement_config == 'A'">
                        <div class="proj-s2">
                            <input
                                type="number" 
                                ref="basement_mr1" 
                                v-model="car.basement_mr1"
                                @blur="rangeSub(cn,0,'basement_mr1',0,999)"
                                class="s2 g-eds" 
                                required
                            >
                        </div>
                        <div class="proj-s2">
                            <input
                                type="number" 
                                ref="basement_mr2" 
                                v-model="car.basement_mr2"
                                @blur="rangeSub(cn,0,'basement_mr2',0,999)"
                                class="s2 g-eds" 
                                required
                            >
                        </div>
                        <div class="proj-s2">
                            <input
                                type="number" 
                                ref="basement_mr3" 
                                v-model="car.basement_mr3"
                                @blur="rangeSub(cn,0,'basement_mr3',0,999)"
                                class="s2 g-eds" 
                                required
                            >
                        </div>
                        <div class="proj-s2">
                            <input
                                type="number" 
                                ref="basement_mr4" 
                                v-model="car.basement_mr4"
                                @blur="rangeSub(cn,0,'basement_mr4',0,999)"
                                class="s2 g-eds" 
                                required
                            >
                        </div>
                    </template>
                    <template v-else>
                        <div :hidden="hidableRows.basement_mr1" class="proj-s2"><input ref="basement_mr1" type="number" disabled></div>
                        <div :hidden="hidableRows.basement_mr1" class="proj-s2"><input ref="basement_mr2" type="number" disabled></div>
                        <div :hidden="hidableRows.basement_mr1" class="proj-s2"><input ref="basement_mr3" type="number" disabled></div>
                        <div :hidden="hidableRows.basement_mr1" class="proj-s2"><input ref="basement_mr4" type="number" disabled></div>
                    </template>

                    <div :hidden="hidableRows.basement_mr1b" class="proj-s2"></div>
                    <template v-if="car.basement_config == 'B'">
                        <div class="proj-s2">
                            <input
                                type="number" 
                                ref="basement_mr1b" 
                                v-model="car.basement_mr1"
                                @blur="rangeSub(cn,0,'basement_mr1',0,999)"
                                class="s2 g-eds" 
                                required
                            >
                        </div>
                        <div class="proj-s2">
                            <input
                                type="number" 
                                ref="basement_mr2b" 
                                v-model="car.basement_mr2"
                                @blur="rangeSub(cn,0,'basement_mr2',0,999)"
                                class="s2 g-eds" 
                                required
                            >
                        </div>
                        <div class="proj-s2">
                            <input
                                type="number" 
                                ref="basement_mr3b" 
                                v-model="car.basement_mr3"
                                @blur="rangeSub(cn,0,'basement_mr3',0,999)"
                                class="s2 g-eds" 
                                required
                            >
                        </div>
                        <div class="proj-s2">
                            <input
                                type="number" 
                                ref="basement_df1b" 
                                v-model="car.basement_df1"
                                @blur="rangeSub(cn,0,'basement_df1',0,999)"
                                class="s2 g-eds" 
                                required
                            >
                        </div>
                        <div class="proj-s2">
                            <input
                                type="number" 
                                ref="basement_df2b" 
                                v-model="car.basement_df2"
                                @blur="rangeSub(cn,0,'basement_df2',0,999)"
                                class="s2 g-eds" 
                                required
                            >
                        </div>
                        <div class="proj-s2">
                            <input
                                type="number" 
                                ref="basement_rdb" 
                                v-model="car.basement_rd"
                                @blur="rangeSub(cn,0,'basement_rd',0,99)"
                                :disabled="car.machine_location != 'BASEMENT' || car.basement_config != 'B'" 
                                class="s2 g-eds" 
                                required
                            >
                        </div>
                    </template>
                    <template v-else>
                        <div :hidden="hidableRows.basement_mr1b" class="proj-s2"><input ref="basement_mr1b" type="number" disabled></div>
                        <div :hidden="hidableRows.basement_mr1b" class="proj-s2"><input ref="basement_mr2b" type="number" disabled></div>
                        <div :hidden="hidableRows.basement_mr1b" class="proj-s2"><input ref="basement_mr3b" type="number" disabled></div>
                        <div :hidden="hidableRows.basement_mr1b" class="proj-s2"><input ref="basement_df1b" type="number" disabled></div>
                        <div :hidden="hidableRows.basement_mr1b" class="proj-s2"><input ref="basement_df2b" type="number" disabled></div>
                        <div :hidden="hidableRows.basement_mr1b" class="proj-s2"><input ref="basement_rdb" type="number" disabled></div>
                    </template>

                    <div :hidden="hidableRows.basement_mr1c" class="proj-s2"></div>
                    <template v-if="car.basement_config == 'C'">
                        <div class="proj-s2">
                            <input
                                type="number" 
                                ref="basement_mr1c" 
                                v-model="car.basement_mr1"
                                @blur="rangeSub(cn,0,'basement_mr1',0,999)"
                                class="s2 g-eds" 
                                required
                            >
                        </div>
                        <div class="proj-s2">
                            <input
                                type="number" 
                                ref="basement_mr2c" 
                                v-model="car.basement_mr2"
                                @blur="rangeSub(cn,0,'basement_mr2',0,999)"
                                class="s2 g-eds" 
                                required
                            >
                        </div>
                        <div class="proj-s2">
                            <input
                                type="number" 
                                ref="basement_mr3c" 
                                v-model="car.basement_mr3"
                                @blur="rangeSub(cn,0,'basement_mr3',0,999)"
                                class="s2 g-eds" 
                                required
                            >
                        </div>
                        <div class="proj-s2">
                            <input
                                type="number" 
                                ref="basement_df1c" 
                                v-model="car.basement_df1"
                                @blur="rangeSub(cn,0,'basement_df1',0,999)"
                                class="s2 g-eds" 
                                required
                            >
                        </div>
                        <div class="proj-s2">
                            <input
                                type="number" 
                                ref="basement_df2c" 
                                v-model="car.basement_df2"
                                @blur="rangeSub(cn,0,'basement_df2',0,999)"
                                class="s2 g-eds" 
                                required
                            >
                        </div>
                        <div class="proj-s2">
                            <input
                                type="number" 
                                ref="basement_df3c" 
                                v-model="car.basement_df3"
                                @blur="rangeSub(cn,0,'basement_df3',0,999)"
                                class="s2 g-eds" 
                                required
                            >
                        </div>
                        <div class="proj-s2">
                            <input
                                type="number" 
                                ref="basement_df4c" 
                                v-model="car.basement_df4"
                                @blur="rangeSub(cn,0,'basement_df4',0,999)"
                                class="s2 g-eds" 
                                required
                            >
                        </div>
                    </template>
                    <template v-else>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2"><input ref="basement_mr1c" type="number" disabled></div>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2"><input ref="basement_mr2c" type="number" disabled></div>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2"><input ref="basement_mr3c" type="number" disabled></div>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2"><input ref="basement_df1c" type="number" disabled></div>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2"><input ref="basement_df2c" type="number" disabled></div>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2"><input ref="basement_df3c" type="number" disabled></div>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2"><input ref="basement_df4c" type="number" disabled></div>
                    </template>

                    </template>
                </div>
            </div></div>
            </div>
        </section>

        <section class="project-section" v-if="step == 'controller'">
            <h2 class="proj-s1">Controller</h2>

            <div class="top-scroll">
                <div class="top-scroll-body"></div>
            </div>

            <div class="proj-labels">
                <div class="proj-section1 proj-group">
                    <div class="proj-s1" v-if="model.cars[2]">Copy From</div>
                    <div class="proj-ds"><label> Car ID Number</label></div>
                    <div class="proj-ds"><label> Speed</label></div>
                    <div class="proj-ds"><label> Capacity</label></div>
                    <div class="proj-ds"><label> Machine Location</label></div>

                    <div class="proj-cc proj-h3"><label> <strong>Hoist Motor</strong></label></div>
                    <div class="proj-ds"><label> Geared or Gearless</label></div>
                    <div class="proj-ds"><label> Motor Voltage (App/Rated)</label></div>
                    <div class="proj-ds"><label> Motor RPM (App/Rated)</label></div>
                    <div class="proj-ds"><label> Motor Freq (App/Rated)</label></div>
                    <div class="proj-ds"><label> Motor Power (App/Rated)</label></div>
                    <div class="proj-ds"><label> FL Current (App/Rated)</label></div>
                    <div class="proj-ds"><label> Accel Current (App/Rated)</label></div>

                    <div class="proj-cc proj-h3"><label> <strong>Brake</strong></label></div>
                    <div class="proj-ds"><label> Pick/Hold Voltage</label></div>
                    <div class="proj-ds"><label> Coil Resistance</label></div>

                    <div class="proj-cc proj-h3"><label> <strong>EBrake</strong></label></div>
                    <div class="proj-ds"><label> Pick/Hold Voltage</label></div>
                    <div class="proj-ds"><label> Coil Resistance</label></div>

                    <div class="proj-cc proj-h3"><label> <strong>Rope Gripper or Rope Brake</strong></label></div>
                    <div class="proj-cc"><label> Mfg</label></div>
                    <div class="proj-cc"><label> Voltage</label></div>

                    <div class="proj-cc proj-h3"><label> <strong>Frequency Drive</strong></label></div>
                    <div class="proj-cc"><label> Drive Manufacturer</label></div>
                    <div class="proj-cc"><label> Encoder</label></div>
                    <div class="proj-cc"><label> Regen Drive</label></div>

                    <div class="proj-cc proj-h3"><label> <strong>General Information</strong></label></div>
                    <div class="proj-cc"><label> # of Floors  <small>(range: 1-32)</small></label></div>
                    <div class="proj-cc"><label> # of Opening  <small>(range: 1-64)</small></label></div>
                    <div class="proj-cc"><label> Floor Lock-outs</label></div>
                    <div class="proj-cc"><label> Operation </label></div>
                    <div class="proj-cc"><label> Measure AC Line <small>(VAC,3ph)</small> </label></div>
                    <div class="proj-cc"><label> Door Type </label></div>

                    <div class="proj-cc proj-h2"><label> <h2>FEATURES</h2></label></div>
                    <div class="proj-cc"><label> <strong>PI Driver</strong></label></div>
                    <div class="proj-cc"><label> <strong>Controller A/C unit </strong></label></div>
                    <div class="proj-cc"><label> <i class="ind"></i>Material of A/C</label></div>
                    <div class="proj-cc"><label> <strong>UPS lowering </strong></label></div>
                    <div class="proj-cc"><label> <strong>Controller Stand</strong> <small>(Note: * Height is 22")</small></label></div>

                    <div class="proj-cc proj-h3"><label> <strong>Load Weigher</strong></label></div>
                    <div class="proj-cc"><label> <i class="ind"></i>Load Weighing or Not </label></div>
                    <div class="proj-cc"><label> <i class="ind"></i>Rope or Cross Beam</label></div>
                    <div class="proj-cc"><label> <i class="ind"></i># of Ropes <small>(range: 1-20)</small></label></div>
                    <div class="proj-cc"><label> <i class="ind"></i>Rope Size</label></div>

                    <div class="proj-cc"><label> Floor Information</label></div>
                    <div class="proj-cc"><label> Access Top & Bottom</label></div>
                    <div class="proj-cc"><label> Collective</label></div>
                    <div class="proj-cc"><label> Travel <small>(ft) (range: 10-2999)</small></label></div>

                    <div class="proj-cc proj-h3"><label> <strong>Door Operation</strong></label></div>
                    <div class="proj-cc"><label> Retiring Cam Type</label></div>
                    <div class="proj-cc"><label> <i class="ind"></i>Electrical Cam Voltage Type</label></div>
                    <div class="proj-cc"><label> <i class="ind"></i>Electrical Cam Voltage</label></div>
                    <div class="proj-cc"><label> Door Operator Manufacturer </label></div>
                    <div class="proj-cc"><label> Door Motor Model </label></div>
                    <div class="proj-cc"><label> Door Motor Supply AC/DC</label></div>
                    <div class="proj-cc"><label> Door Motor Supply <small>(Voltage)</small></label></div>
                    <div class="proj-cc"><label> Door Motor Supply Phase</label></div>

                    <div class="proj-cc proj-h3"><label><strong>Car and Hall Fixtures <small>(Note: All fixtures must be 24VDC)</small></strong></label></div>
                    <div class="proj-cc"><label> Hall Lanterns</label></div>

                    <div class="proj-cc proj-h3"><label> <strong>Serial Communication</strong></label></div>
                    <div class="proj-cc"><label> Serial Car Station</label></div>
                    <div class="proj-cc"><label> Serial Hall Station</label></div>
                </div>
            </div>

            <div class="proj-cars"><div class="proj-car" v-for="(car,cn) in model.cars" :key="cn">
                <div class="proj-section1 proj-group">
                    <div class="proj-s1" v-if="model.cars[2]">
                        <select v-model="car.copier" required  @change="copyInput(car.copier,cn,'controller')">
                            <template v-for="(ccar,ccn) in model.cars">
                                <option :value="ccn" :key="ccn" v-if="cn != ccn">Car #{{ ccar.car_id_number }}</option>
                            </template>
                        </select>
                    </div>
                    <div class="proj-ds"><input type="text" v-model="car.car_id_number" placeholder="Car ID Number" required disabled></div>
                    <div class="proj-ds"><input type="text" :value="car.speed" disabled></div>
                    <div class="proj-ds"><input type="text" :value="car.capacity" disabled></div>
                    <div class="proj-ds"><input type="text" :value="car.machine_location" disabled></div>

                    <div class="proj-cc"></div>
                    <div class="proj-ds"><input type="text" :value="car.gear == 'TRUE' ? 'Geared' : 'Gearless'" disabled></div>
                    <div class="proj-ds"><input type="text" :value="car.controller.motor_rated_voltage" disabled></div>
                    <div class="proj-ds"><input type="text" :value="car.controller.motor_rpm_app_rated" disabled></div>
                    <div class="proj-ds"><input type="text" :value="car.controller.motor_frequency_app_rated" disabled></div>
                    <div class="proj-ds"><input type="text" :value="car.controller.motor_power_app_rated" disabled></div>
                    <div class="proj-ds"><input type="text" :value="car.controller.fl_current_app_rated" disabled></div>
                    <div class="proj-ds"><input type="text" :value="car.controller.accel_current_app_rated" disabled></div>

                    <div class="proj-cc"></div>
                    <div class="proj-ds"><input type="text" :value="car.controller.pick_hold_voltage" disabled></div>
                    <div class="proj-ds"><input type="text" :value="car.controller.coil_resistance" disabled></div>
                    
                    <div class="proj-cc"></div>
                    <div class="proj-ds"><input type="text" :value="car.controller.em_pick_hold_voltage" disabled></div>
                    <div class="proj-ds"><input type="text" :value="car.controller.em_coil_resistance" disabled></div>
                    
                    <div class="proj-cc"></div>
                    <div class="proj-ds"><input type="text" v-model="car.controller.rp_mfg" value="" disabled></div>
                    <div class="proj-ds"><input type="text" v-model="car.controller.rp_voltage" :disabled="car.ses_rope_brake != 'TRUE' && car.hw_rope_gripper != 'TRUE'" required ref="rp_voltage"></div>

                    <div class="proj-cc"></div>
                    <div class="proj-ds"><input type="text" :value="car.drive_manufacturer" disabled></div>
                    <div class="proj-ds"><input type="text" value="Yes" disabled></div>
                    <div class="proj-cc">
                        <select v-model="car.controller.freq_regen" required ref="freq_regen">
                            <option></option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>

                    <div class="proj-cc"></div>
                    <div class="proj-cc"><input type="number" v-model="car.controller.no_of_floors" required ref="no_of_floors" @blur="rangeSub(cn,'controller','no_of_floors',1,32)"></div>
                    <div class="proj-cc"><input type="number" v-model="car.controller.no_of_openings" required ref="no_of_openings" @blur="rangeSub(cn,'controller','no_of_openings',1,64)"></div>
                    <div class="proj-cc">
                        <select v-model="car.controller.floor_lockout" required ref="floor_lockout">
                            <option></option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                    <div class="proj-cc">
                        <select v-model="car.controller.operation" required ref="operation">
                            <option></option>
                            <option value="Simplex">Simplex</option>
                            <option value="Duplex">Duplex</option>
                            <option value="Triplex">Triplex</option>
                            <option value="4-Cars-Group">4 Cars Group</option>
                        </select>
                    </div>
                    <div class="proj-cc">
                        <select v-model="car.controller.ac_line" ref="ac_line" required>
                            <option></option>
                            <option value="208-230">208-230</option>
                            <option value="460-480">460-480</option>
                        </select>
                    </div>
                    <div class="proj-cc">
                        <select v-model="car.controller.door_type" required ref="door_type" @change="subChange(cn, 'controller', 'door_type')">
                            <option></option>
                            <option value="Swing Door">Swing Door</option>
                            <option value="Master Door">Master Door</option>
                            <option value="Peelle/Freight Door">Peelle/Freight Door</option>
                            <option value="Manual Door">Manual Door</option>
                        </select>
                    </div>

                    <div class="proj-cc"></div>
                    <div class="proj-cc">
                        <select v-model="car.controller.pi_driver" ref="pi_driver" required>
                            <option></option>
                            <option value="CE">CE</option>
                            <option value="VEGA">VEGA</option>
                            <option value="No Digital PI">No Digital PI</option>
                            <option value="CE Digital PI">CE Digital PI</option>
                            <option value="Controller Mfg. Digital PI">Controller Mfg. Digital PI</option>
                        </select>
                    </div>

                    <div class="proj-cc">
                        <select v-model="car.controller.controller_ac" required ref="controller_ac" @change="subChange(cn, 'controller', 'controller_ac')">
                            <option></option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                    <div class="proj-cc">
                        <select v-model="car.controller.controller_ac_material" required ref="controller_ac_material" :disabled="car.controller.controller_ac != 'Yes'">
                            <option></option>
                            <option value="Stainless Steel">Stainless Steel</option>
                            <option value="Regular">Regular</option>
                        </select>
                    </div>
                    <div class="proj-cc">
                        <select v-model="car.controller.ups_lowering" required ref="ups_lowering">
                            <option></option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                    <div class="proj-cc">
                        <select v-model="car.controller.controller_stand" required ref="controller_stand">
                            <option></option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>

                    <div class="proj-cc"></div>
                    <div class="proj-cc">
                        <select v-model="car.controller.load_weigher" required ref="load_weigher" @change="subChange(cn, 'controller', 'load_weigher')">
                            <option></option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                    <div class="proj-cc">
                        <select v-model="car.controller.rope_cross_beam" required ref="rope_cross_beam" :disabled="car.controller.load_weigher != 'Yes'">
                            <option value=""></option>
                            <option value="Rope">Rope</option>
                            <option value="Cross-Beam">Cross Beam</option>
                        </select>
                    </div>
                    <template v-if="car.controller.load_weigher == 'Yes' && car.controller.rope_cross_beam == 'Rope'">
                        <div class="proj-cc">
                            <input type="number" v-model="car.controller.number_of_ropes" required ref="number_of_ropes" @blur="rangeSub(cn,'controller','number_of_ropes',1,20)">
                        </div>
                        <div class="proj-cc"><input type="text" v-model="car.controller.rope_size" disabled></div>
                    </template>
                    <template v-else>
                        <div class="proj-cc"><input type="text" value="" disabled></div>
                        <div class="proj-cc"><input type="text" value="" disabled></div>
                    </template>


                    <div class="proj-cc">
                        <button type="button" class="btn btn-default btn-fl" @click="controllerIT(cn,car.controller)">Edit Information Table</button>
                    </div>
                    <div class="proj-cc">
                        <select v-model="car.controller.access" ref="access" :required="model.project.is_final == 'yes'">
                            <option></option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                    <div class="proj-cc">
                        <select v-model="car.controller.collective" ref="collective" :required="model.project.is_final == 'yes'">
                            <option></option>
                            <option value="Full">Full</option>
                            <option value="Down">Down</option>
                        </select>
                    </div>
                    <div class="proj-cc"><input type="number" v-model="car.controller.total_travel" :required="model.project.is_final == 'yes'" ref="total_travel" @blur="rangeSub(cn,'controller','total_travel',10,2999)"></div>

                    <div class="proj-cc"></div>
                    <div class="proj-cc">
                        <select v-model="car.controller.door_cam_type" :required="model.project.is_final == 'yes'" ref="door_cam_type" :disabled="car.controller.door_type != 'Swing Door' && car.controller.door_type != 'Peelle/Freight Door'" @change="subChange(cn, 'controller', 'door_cam_type')">
                            <option value="None">None</option>
                            <option value="Mechanical Cam">Mechanical Cam</option>
                            <option value="Electrical Cam">Electrical Cam</option>
                        </select>
                    </div>
                    <div class="proj-cc">
                        <select v-model="car.controller.door_cam_volt_type" :required="model.project.is_final == 'yes'" ref="door_cam_volt_type" :disabled="(car.controller.door_type != 'Swing Door' && car.controller.door_type != 'Peelle/Freight Door') || car.controller.door_cam_type != 'Electrical Cam'">
                            <option value=""></option>
                            <option value="AC">AC</option>
                            <option value="DC">DC</option>
                        </select>
                    </div>
                    <div class="proj-cc"><input type="number" v-model="car.controller.door_cam_voltage" :required="model.project.is_final == 'yes'" ref="door_cam_voltage" :disabled="(car.controller.door_type != 'Swing Door' && car.controller.door_type != 'Peelle/Freight Door') || car.controller.door_cam_type != 'Electrical Cam'"></div>
                    <div class="proj-cc"><input type="text" v-model="car.controller.door_op_mfg" :required="model.project.is_final == 'yes'" ref="door_op_mfg"></div>
                    <div class="proj-cc"><input type="text" v-model="car.controller.door_motor_model" :required="model.project.is_final == 'yes'" ref="door_motor_model"></div>
                    <div class="proj-cc">
                        <select v-model="car.controller.door_motor_supp_acdc" ref="door_motor_supp_acdc" :required="model.project.is_final == 'yes'">
                            <option value=""></option>
                            <option value="AC">AC</option>
                            <option value="DC">DC</option>
                        </select>
                    </div>
                    <div class="proj-cc">
                        <select v-model="car.controller.door_motor_supp_volt" ref="door_motor_supp_volt" :required="model.project.is_final == 'yes'">
                            <option value=""></option>
                            <option value="110">110</option>
                            <option value="220">220</option>
                        </select>
                    </div>
                    <div class="proj-cc">
                        <select v-model="car.controller.door_motor_supp_phase" ref="door_motor_supp_phase" :required="model.project.is_final == 'yes'">
                            <option value=""></option>
                            <option value="1ph">1ph</option>
                            <option value="3ph">3ph</option>
                        </select>
                    </div>
                    <div class="proj-cc"></div>
                    <div class="proj-cc">
                        <select v-model="car.controller.door_lantern" ref="door_lantern" :required="model.project.is_final == 'yes'">
                            <option></option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>

                    <div class="proj-cc"></div>
                    <div class="proj-cc">
                        <select v-model="car.controller.serial_car" ref="serial_car" :required="model.project.is_final == 'yes'">
                            <option></option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                    <div class="proj-cc">
                        <select v-model="car.controller.serial_hall" ref="serial_hall" :required="model.project.is_final == 'yes'">
                            <option></option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                </div>
            </div></div>
        </section>

        <section class="project-section" v-if="step == 'door_system'">
            <h2 class="proj-s1">Door System</h2>

            <div class="top-scroll">
                <div class="top-scroll-body"></div>
            </div>

            <div class="proj-labels">
                <div class="proj-section1 proj-group">

                    <div class="proj-cc proj-h3 proj-r6" style="color:red;" v-if="false">
                        <div>
                            <strong>CAUTION:</strong> <br>
                            (1) Required 4” sill for both car and landing side, and 1-1/4” between sills for running clearance. (ill.4) <br>
                            (2) Door space must be exactly 5”. (ill.4) <br>
                            (3) Combined door weight (car door + landing door) must be under 500 lbs.) <br>
                            (4) The input signal (OP and CL) from elevator controller must be active low.) <br>
                            Please contact SES immediately if there is any discrepancy.
                        </div>
                    </div>
                    <div class="proj-ds" v-if="model.cars[2]"><label> Copy From</label></div>
                    <div class="proj-cc proj-h3"><label> <strong>Basic Information</strong></label></div>
                    <div class="proj-cc proj-r4"><label> Products Required</label></div>
                    <div class="proj-cc"><label> # of Floors <small>(range: 1-200)</small></label></div>
                    <div class="proj-ds"><label> Car ID Number</label></div>

                    <div class="proj-cc proj-h3"><label> <strong>ENTRANCE SPEC</strong></label></div>
                    <div class="proj-cc"><label> Front Opening  Width <small>(in) <ses-tooltip type="illu-ds3"></ses-tooltip> A2</small></label></div>
                    <div class="proj-cc"><label> Front Opening  Height <small>(in) (range: 72-96)<ses-tooltip type="illu-ds3"></ses-tooltip> A2</small></label></div>
                    <div class="proj-cc"><label> Front Hoistway Width <small>(in) (range: 30-200)<ses-tooltip type="illu-ds3"></ses-tooltip> A3</small></label></div>
                    <div class="proj-cc"><label> Rear/Side Opening Width <small>(in) <ses-tooltip type="illu-ds3"></ses-tooltip> A5</small></label></div>
                    <div class="proj-cc"><label> Rear/Side Opening Height <small>(in) (range: 72-96)<ses-tooltip type="illu-ds3"></ses-tooltip> A5</small></label></div>
                    <div class="proj-cc"><label> Rear/Side Hoistway Width <small>(in) (range: 30-200)<ses-tooltip type="illu-ds3"></ses-tooltip> A6</small></label></div>
                    <div class="proj-cc"><label> Entrance Sill Finish </label></div>
                    <div class="proj-cc"><label> Landing Door Access Keyhole Required </label></div>

                    <div class="proj-cc"><label> Car Sill Centerline to Transom <small>(in) (range: 3.4-12.0)</small> - <ses-tooltip type="illu-ds6" align="top"></ses-tooltip> B1</label></div>
                    <div class="proj-cc"><label> Car Sill Centerline to Sill Edge <small>(in) (range: 2.43-4.23)</small> - <ses-tooltip type="illu-ds6" align="top"></ses-tooltip> B2</label></div>
                    <div class="proj-cc"><label> Running Clearance <small>(in) (range: 0.90-1.25)</small> - <ses-tooltip type="illu-ds6" align="top"></ses-tooltip> B3</label></div>
                    <div class="proj-cc"><label> Car Sill Centerline to Hatch Wall <small>(in) (range: 8.30 - 10.05)</small> - <ses-tooltip type="illu-ds6" align="top"></ses-tooltip> B4</label></div>
                    <div class="proj-cc"><label> Combined Door Weight <small>(lbs) (range: 0-500)</small></label></div>
                    <div class="proj-cc"><label> Entrance Manufacturer</label></div>

                    <div class="proj-cc proj-h3"><label> <strong>FLOOR TO FLOOR DETAIL</strong></label></div>
                    <div class="proj-cc"><label> Floor Information</label></div>

                    <div class="proj-cc proj-h3"><label> <strong>DOOR OPERATOR & LANDING EQUIPMENT SPEC</strong></label></div>
                    <div class="proj-cc"><label> Supply Voltage <small>(VAC)</small></label></div>
                    <div class="proj-cc"><label> Front Entrance - Landing Equipment Qty <small>(range: 0-200)</small></label></div>
                    <div class="proj-cc"><label> Front Entrance - Width (in)</label></div>
                    <div class="proj-cc"><label> Front Entrance - Speed</label></div>
                    <div class="proj-cc"><label> Front Opening Direction</label></div>
                    <div class="proj-cc"><label> Rear/Side Entrance - Landing Equipment Qty <small>(range: 0-200)</small></label></div>
                    <div class="proj-cc"><label> Rear/Side Entrance - Width (in)</label></div>
                    <div class="proj-cc"><label> Rear/Side Entrance - Speed</label></div>
                    <div class="proj-cc"><label> Rear/Side Opening Direction<ses-tooltip type="illu-ds5" align="top"></ses-tooltip></label></div>

                </div>
            </div>

            <div class="proj-cars"><div class="proj-car" v-for="(car,cn) in model.cars" :key="cn">
                <div class="proj-section1 proj-group">

                    <div class="proj-cd" v-if="model.cars[2]">
                        <select v-model="car.copier" required  @change="copyInput(car.copier,cn,'door_system')">
                            <template v-for="(ccar,ccn) in model.cars">
                                <option :value="ccn" :key="ccn" v-if="cn != ccn">Car #{{ ccar.car_id_number }}</option>
                            </template>
                        </select>
                    </div>
                    <div class="proj-cc"></div>
                    <div class="proj-cc"><label><input type="checkbox" :checked="car.door_system.entrance == 'TRUE'" @change="subToggle(cn,'door_system','entrance', $event)"> Entrance</label></div>
                    <template v-if="car.door_system && false">
                        <div class="proj-cc static-cover-wrap"><label><input type="checkbox" checked> Landing Equipment</label><small class="static-cover"></small></div>
                        <div class="proj-cc static-cover-wrap"><label><input type="checkbox" checked> Door Operator</label><small class="static-cover"></small></div>
                    </template>
                    <template v-else>
                        <div class="proj-cc"><label><input type="checkbox" :checked="car.door_system.landing == 'TRUE'" @change="subToggle(cn,'door_system','landing', $event)"> Landing Equipment</label></div>
                        <div class="proj-cc"><label><input type="checkbox" :checked="car.door_system.door_op == 'TRUE'" @change="subToggle(cn,'door_system','door_op', $event)"> Door Operator</label></div>
                    </template>
                    <div class="proj-cc"><label><input type="checkbox" :checked="car.door_system.light_curtain == 'TRUE'" @change="subToggle(cn,'door_system','light_curtain', $event)"> Light Curtain</label></div>
                    <div class="proj-cc">
                        <input
                            type="number"
                            v-model="car.door_system.no_of_floors"
                            ref="no_of_floors"
                            :required="car.door_system.entrance == 'TRUE'"
                            @keyup="subChange(cn,'door_system','no_of_floors')"
                            @blur="rangeSub(cn,'door_system','no_of_floors',1,200)"
                        >
                    </div>
                    <div class="proj-ds"><input type="text" v-model="car.car_id_number" placeholder="Car ID Number" disabled></div>

                    <div class="proj-cc"></div>
                    <div class="proj-cc">
                        <select v-model="car.door_system.entrance_fr_opening_w" required ref="entrance_fr_opening_w" :disabled="car.door_system.entrance != 'TRUE'" @change="subChange(cn,'door_system','entrance_fr_opening_w')">
                            <option></option>
                            <option value="36">36</option>
                            <option value="42">42</option>
                            <option value="48">48</option>
                        </select>
                    </div>

                    <div class="proj-cc">
                        <input
                            type="number"
                            v-model="car.door_system.entrance_fr_opening_h"
                            ref="entrance_fr_opening_h"
                            :disabled="car.door_system.entrance != 'TRUE'"
                            @blur="rangeSub(cn,'door_system','entrance_fr_opening_h',72,96)"
                        >
                    </div>
                    <div class="proj-cc">
                        <input
                            type="number"
                            v-model="car.door_system.entrance_fr_hoistway_w"
                            ref="entrance_fr_hoistway_w"
                            :disabled="car.door_system.entrance != 'TRUE'"
                            @blur="rangeSub(cn,'door_system','entrance_fr_hoistway_w',30,200)"
                        >
                    </div>
                    <div class="proj-cc">
                        <select v-model="car.door_system.entrance_rear_opening_w" required ref="entrance_rear_opening_w" @change="subChange(cn,'door_system','entrance_rear_opening_w')" :disabled="car.door_system.entrance != 'TRUE'">
                            <option></option>
                            <option value="36">36</option>
                            <option value="42">42</option>
                            <option value="48">48</option>
                            <option value="N/A">N/A</option>
                        </select>
                    </div>
                    <div class="proj-cc">
                        <input
                            type="number"
                            :disabled="car.door_system.entrance_rear_opening_w == 'N/A' || car.door_system.entrance != 'TRUE'"
                            v-model="car.door_system.entrance_rear_opening_h"
                            ref="entrance_rear_opening_h"
                            @blur="rangeSub(cn,'door_system','entrance_rear_opening_h',72,96)"
                        >
                    </div>
                    <div class="proj-cc">
                        <input
                            type="number"
                            :disabled="car.door_system.entrance_rear_opening_w == 'N/A' || car.door_system.entrance != 'TRUE'"
                            v-model="car.door_system.entrance_rear_hoistway_w"
                            ref="entrance_rear_hoistway_w"
                            @blur="rangeSub(cn,'door_system','entrance_rear_hoistway_w',30,200)"
                        >
                    </div>
                    <div class="proj-cc">
                        <select v-model="car.door_system.entrance_sill_finish" required ref="entrance_sill_finish" :disabled="car.door_system.entrance != 'TRUE'">
                            <option></option>
                            <option value="Aluminium">Aluminium</option>
                            <option value="Bronze">Bronze</option>
                            <option value="Stainless Steel">Stainless Steel</option>
                        </select>
                    </div>
                    <div class="proj-cc">
                        <select v-model="car.door_system.entrance_keyhole" required ref="entrance_keyhole" :disabled="car.door_system.entrance != 'TRUE'">
                            <option></option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>

                    <div class="proj-cc">
                        <input 
                            type="number"
                            v-model="car.door_system.centerline_to_transom"
                            ref="centerline_to_transom"
                            :disabled="car.door_system.entrance != 'TRUE'"
                            @blur="rangeSub(cn,'door_system','centerline_to_transom',3.4,12)"
                        >
                    </div>
                    <div class="proj-cc">
                        <input 
                            type="number"
                            v-model="car.door_system.centerline_to_edge"
                            ref="centerline_to_edge"
                            :disabled="car.door_system.entrance != 'TRUE'"
                            @blur="rangeSub(cn,'door_system','centerline_to_edge',2.43,4.23)"
                        >
                    </div>
                    <div class="proj-cc">
                        <input 
                            type="number"
                            v-model="car.door_system.running_clearance"
                            ref="running_clearance"
                            :disabled="car.door_system.entrance != 'TRUE'"
                            @blur="rangeSub(cn,'door_system','running_clearance',0.9,1.25)"
                        >
                    </div>
                    <div class="proj-cc">
                        <input 
                            type="number"
                            v-model="car.door_system.centerline_to_hatch"
                            ref="centerline_to_hatch"
                            :disabled="car.door_system.entrance != 'TRUE'"
                            @blur="rangeSub(cn,'door_system','centerline_to_hatch',8.3,10.05)"
                        >
                    </div>
                    <div class="proj-cc">
                        <input 
                            type="number"
                            v-model="car.door_system.door_combined_weight"
                            ref="door_combined_weight"
                            :disabled="car.door_system.entrance != 'TRUE'"
                            @blur="rangeSub(cn,'door_system','door_combined_weight',0,500)"
                        >
                    </div>
                    <div class="proj-cc">
                        <select
                            v-model="car.door_system.entrance_manufacturer"
                            required ref="entrance_manufacturer"
                            :disabled="car.door_system.entrance != 'TRUE'"
                    >
                            <option value="IDEC">IDEC</option>
                        </select>
                    </div>

                    <div class="proj-cc"></div>
                    <div class="proj-cc"><button type="button" class="btn btn-default btn-fl" @click="doorIT(cn,car.door_system)">Edit Information Table</button></div>

                    <div class="proj-cc"></div>
                    <div class="proj-cc">
                        <select
                            v-model="car.door_system.door_op_vac"
                            required
                            ref="door_op_vac"
                            :disabled="car.door_system.landing != 'TRUE' || car.door_system.door_op != 'TRUE'"
                        >
                            <option></option>
                            <option value="110">110</option>
                            <option value="220">220</option>
                        </select>
                    </div>
                    <div class="proj-cc">
                        <input 
                            type="number"
                            v-model="car.door_system.door_op_fr_landing_qty"
                            ref="door_op_fr_landing_qty"
                            @change="subChange(cn,'door_system','door_op_fr_landing_qty')"
                            @blur="rangeSub(cn,'door_system','door_op_fr_landing_qty',0,200)"
                            :disabled="car.door_system.landing != 'TRUE' || car.door_system.door_op != 'TRUE'"
                        >
                    </div>
                    <div class="proj-cc">
                        <select 
                            v-model="car.door_system.door_op_fr_w"
                            required
                            ref="door_op_fr_w"
                            :disabled="car.door_system.door_op_fr_landing_qty == 0 || car.door_system.landing != 'TRUE' || car.door_system.door_op != 'TRUE'"
                            @change="subChange(cn,'door_system','door_op_fr_w')"
                        >
                            <option></option>
                            <option value="36">36</option>
                            <option value="42">42</option>
                            <option value="48">48</option>
                        </select>
                    </div>
                    <div class="proj-cc">
                        <select 
                            v-model="car.door_system.door_op_fr_speed" 
                            required 
                            ref="door_op_fr_speed"
                            :disabled="car.door_system.door_op_fr_landing_qty == 0 || car.door_system.landing != 'TRUE' || car.door_system.door_op != 'TRUE'"
                        >
                            <option></option>
                            <option value="Single Speed">Single Speed</option>
                        </select>
                    </div>
                    <div class="proj-cc">
                        <select 
                            v-model="car.door_system.door_op_fr_opening" 
                            required 
                            ref="door_op_fr_opening"
                            :disabled="car.door_system.door_op_fr_landing_qty == 0 || car.door_system.landing != 'TRUE' || car.door_system.door_op != 'TRUE'"
                        >
                            <template v-if="car.door_system.entrance != 'TRUE' || car.door_system.door_op_fr_w != '48'">
                                <option></option>
                                <option value="Left">Left</option>
                                <option value="Right">Right</option>
                            </template>
                            <option value="Center">Center</option>
                        </select>
                    </div>
                    <div class="proj-cc">
                        <input
                            type="number"
                            :disabled="car.door_system.door_op_rear_w == 'N/A' || car.door_system.landing != 'TRUE' || car.door_system.door_op != 'TRUE'"
                            v-model="car.door_system.door_op_rear_landing_qty"
                            ref="door_op_rear_landing_qty"
                            @change="subChange(cn,'door_system','door_op_rear_landing_qty')"
                            @blur="rangeSub(cn,'door_system','door_op_rear_landing_qty',0,200)"
                        >
                    </div>
                    <div class="proj-cc">
                        <select 
                            v-model="car.door_system.door_op_rear_w" 
                            required 
                            ref="door_op_rear_w" 
                            :disabled="car.door_system.door_op_rear_landing_qty == 0 || car.door_system.landing != 'TRUE' || car.door_system.door_op != 'TRUE'"
                            @change="subChange(cn,'door_system','door_op_rear_w')"
                        >
                            <option></option>
                            <option value="36">36</option>
                            <option value="42">42</option>
                            <option value="48">48</option>
                            <option value="N/A">N/A</option>
                        </select>
                    </div>
                    <div class="proj-cc">
                        <select
                            :disabled="car.door_system.door_op_rear_w == 'N/A' || car.door_system.door_op_rear_landing_qty == 0 || car.door_system.landing != 'TRUE' || car.door_system.door_op != 'TRUE'"
                            v-model="car.door_system.door_op_rear_speed"
                            required
                            ref="door_op_rear_speed">
                            <option></option>
                            <option value="Single Speed">Single Speed</option>
                        </select>
                    </div>
                    <div class="proj-cc">
                        <select
                            :disabled="car.door_system.door_op_rear_w == 'N/A' || car.door_system.door_op_rear_landing_qty == 0 || car.door_system.landing != 'TRUE' || car.door_system.door_op != 'TRUE'"
                            v-model="car.door_system.door_op_rear_opening"
                            required ref="door_op_rear_opening">
                            <template v-if="car.door_system.entrance != 'TRUE' || car.door_system.door_op_rear_w != '48'">
                                <option></option>
                                <option value="Left">Left</option>
                                <option value="Right">Right</option>
                            </template>
                            <option value="Center">Center</option>
                        </select>
                    </div>
                    <div class="proj-cc" v-if="false"><input type="number" :disabled="car.door_system.light_curtain != 'TRUE'" v-model="car.door_system.light_curtain_qty" ref="light_curtain_qty"></div>
                </div>
            </div></div>
        </section>

        <section class="project-section" v-if="step == 'guide_rails'">
            <h2 class="proj-s1">Guide Rail</h2>

            <div class="top-scroll">
                <div class="top-scroll-body"></div>
            </div>

            <div class="proj-labels">
                <div class="proj-section1 proj-group">
                    <div class="proj-s1" v-if="model.cars[2]">Copy From</div>
                    <div class="proj-ds"><label> Car ID Number</label></div>

                    <div class="proj-cc proj-h3"><label> <strong>Car Guide Rail</strong></label></div>
                    <div class="proj-ds"><label> Rail Size</label></div>
                    <div class="proj-ds"><label> Std. length for Guide Rail</label></div>
                    <div class="proj-ds"><label> Number of Rails for Car Side <small>(range: 0-200)</small></label></div>
                    <div class="proj-ds"><label> Fishplate Type <small>(Including hardware)</small></label></div>

                    <div class="proj-cc proj-h3"><label> <strong>CWT Guide Rail</strong></label></div>
                    <div class="proj-ds"><label> Rail Size</label></div>
                    <div class="proj-ds"><label> Std. length for Guide Rail</label></div>
                    <div class="proj-ds"><label> Number of Rails for CWT Side <small>(range: 0-200)</small></label></div>
                    <div class="proj-ds"><label> Fishplate Type <small>(Including hardware)</small></label></div>
                </div>
            </div>

            <div class="proj-cars"><div class="proj-car" v-for="(car,cn) in model.cars" :key="cn">
                <div class="proj-section1 proj-group">
                    <div class="proj-s1" v-if="model.cars[2]">
                        <select v-model="car.copier" required  @change="copyInput(car.copier,cn,'guide_rails')">
                            <template v-for="(ccar,ccn) in model.cars">
                                <option :value="ccn" :key="ccn" v-if="cn != ccn">Car #{{ ccar.car_id_number }}</option>
                            </template>
                        </select>
                    </div>
                    <div class="proj-ds"><input type="text" v-model="car.car_id_number" placeholder="Car ID Number" disabled></div>

                    <div class="proj-cc"></div>
                    <div class="proj-cc">
                        <select v-model="car.guide_rails.rail_size_car" required ref="rail_size_car">
                            <option></option>
                            <option value="8#">8#</option>
                            <option value="15#">15#</option>
                            <option value="12#">12#</option>
                            <option value="18.5#">18.5#</option>
                        </select>
                    </div>
                    <div class="proj-s2">
                        <div class="proj-split">
                            <label>8ft</label>
                            <label>16ft</label>
                        </div>
                    </div>
                    <div class="proj-s2">
                        <div class="proj-split">
                            <input
                                type="number"
                                v-model="car.guide_rails.rail_no_car_8"
                                class="s3"
                                ref="rail_no_car_8"
                                required
                                @blur="rangeSub(cn,'guide_rails','rail_no_car_8',0,200)">
                            <input
                                type="number"
                                v-model="car.guide_rails.rail_no_car_16"
                                class="s3"
                                ref="rail_no_car_16"
                                required
                                @blur="rangeSub(cn,'guide_rails','rail_no_car_16',0,200)">
                        </div>
                    </div>
                    <div class="proj-cc">
                        <select v-model="car.guide_rails.fishplate_car" required ref="fishplate_car">
                            <option></option>
                            <option value="Standard">Standard</option>
                            <option value="Seismic T-shape">Seismic T-shape</option>
                            <option value="Seismic Low Profile">Seismic Low Profile</option>
                        </select>
                    </div>

                    <div class="proj-cc"></div>
                    <div class="proj-cc">
                        <select v-model="car.guide_rails.rail_size_cwt" required ref="rail_size_cwt">
                            <option></option>
                            <option value="8#">8#</option>
                            <option value="15#">15#</option>
                            <option value="12#">12#</option>
                            <option value="18.5#">18.5#</option>
                        </select>
                    </div>
                    <div class="proj-s2">
                        <div class="proj-split">
                            <label>8ft</label>
                            <label>16ft</label>
                        </div>
                    </div>
                    <div class="proj-s2">
                        <div class="proj-split">
                            <input 
                                type="number"
                                v-model="car.guide_rails.rail_no_cwt_8"
                                class="s3"
                                ref="rail_no_cwt_8"
                                required
                                @blur="rangeSub(cn,'guide_rails','rail_no_cwt_8',0,200)">
                            <input
                                type="number"
                                v-model="car.guide_rails.rail_no_cwt_16"
                                class="s3"
                                ref="rail_no_cwt_16"
                                required
                                @blur="rangeSub(cn,'guide_rails','rail_no_cwt_16',0,200)">
                        </div>
                    </div>
                    <div class="proj-cc">
                        <select v-model="car.guide_rails.fishplate_cwt" required ref="fishplate_cwt">
                            <option></option>
                            <option value="Standard">Standard</option>
                            <option value="Seismic T-shape">Seismic T-shape</option>
                            <option value="Seismic Low Profile">Seismic Low Profile</option>
                        </select>
                    </div>
                </div>
            </div></div>
        </section>

        <section class="project-section" v-if="step == 'hoistway_components'">
            <h2 class="proj-s1">Hoistway Components</h2>

            <div class="top-scroll">
                <div class="top-scroll-body"></div>
            </div>

            <div class="proj-labels">
                <div class="proj-section1 proj-group">
                    <div class="proj-s1" v-if="model.cars[2]">Copy From</div>
                    <div class="proj-ds"><label> Car ID Number</label></div>
                    <div class="proj-ds proj-r5"><label> </label></div>
                    <div class="proj-ds"><label> Speed (fpm)</label></div>
                    <div :hidden="hidableRowsHoist.capacitysel && hidableRowsHoist.capacity" class="proj-ds"><label> Rated Capacity (lbs)</label></div>
                    <div :hidden="hidableRowsHoist.empty_car_weight" class="proj-ds"><label> Estimated Empty Car Weight <small>(lb) (range: 1000-50000)</small></label></div>
                    <div :hidden="hidableRowsHoist.counterweight" class="proj-ds"><label> Counterweight  <small>(%) (range: 40-50)</small></label></div>
                    <div :hidden="hidableRowsHoist.governor_type" class="proj-ds"><label> Governor Type</label></div>
                    <div :hidden="hidableRowsHoist.governor_rope_length" class="proj-ds"><label> Governor Rope Length <small>(ft) (range: 0-999)</small></label></div>
                    <div :hidden="hidableRowsHoist.governor_position" class="proj-ds"><label> Governor Position <ses-tooltip type="illu-hc1" align="top"></ses-tooltip></label></div>
                    <div :hidden="hidableRowsHoist.dbg" class="proj-ds"><label> DBG (X) <small>(in) (range: 35-118)</small> <ses-tooltip type="illu-dbg" align="top"></ses-tooltip></label></div>
                    <div :hidden="hidableRowsHoist.oil_buffer_car_side_qty" class="proj-ds"><label> Oil Buffer Qty for Car Side</label></div>
                    <div :hidden="hidableRowsHoist.oil_buffer_cwt_side_qty" class="proj-ds"><label> Oil Buffer Qty for CWT Side</label></div>
                </div>
            </div>

            <div class="proj-cars"><div class="proj-car" v-for="(car,cn) in model.cars" :key="cn">
                <div class="proj-section1 proj-group">
                    <div class="proj-s1" v-if="model.cars[2]">
                        <select v-model="car.copier" required  @change="copyInput(car.copier,cn,'hoistway_components')">
                            <template v-for="(ccar,ccn) in model.cars">
                                <option :value="ccn" :key="ccn" v-if="cn != ccn">Car #{{ ccar.car_id_number }}</option>
                            </template>
                        </select>
                    </div>
                    <div class="proj-ds"><input type="text" v-model="car.car_id_number" placeholder="Car ID Number" disabled></div>

                    <div class="proj-cc"><label><input type="checkbox" :checked="car.hoistway_components.governor == 'Y'" @change="subYToggle(cn,'hoistway_components','governor', $event)"> Governor</label></div>
                    <div class="proj-cc"><label><input type="checkbox" :checked="car.hoistway_components.governor_rope == 'Y'" @change="subYToggle(cn,'hoistway_components','governor_rope', $event)"> Governor Rope</label></div>
                    <div class="proj-cc"><label><input type="checkbox" :checked="car.hoistway_components.roller_guide == 'Y'" @change="subYToggle(cn,'hoistway_components','roller_guide', $event)"> Roller Guide</label></div>
                    <div class="proj-cc"><label><input type="checkbox" :checked="car.hoistway_components.safety == 'Y'" @change="subYToggle(cn,'hoistway_components','safety', $event)"> Safety</label></div>
                    <div class="proj-cc"><label><input type="checkbox" :checked="car.hoistway_components.oil_buffer == 'Y'" @change="subYToggle(cn,'hoistway_components','oil_buffer', $event)"> Oil Buffer</label></div>

                    <template v-if="
                            car.hoistway_components.governor != 'Y'
                            && car.hoistway_components.governor_rope != 'Y'
                            && car.hoistway_components.roller_guide != 'Y'
                            && car.hoistway_components.safety != 'Y'
                            && car.hoistway_components.oil_buffer != 'Y'
                    ">
                        <div class="proj-cc" v-if="steps.machine_system"><input type="number" ref="speed" readonly=""></div>
                        <div class="proj-cc" v-if="steps.machine_system"><input type="number" ref="capacity" readonly=""></div>
                        <div class="proj-cc" v-if="steps.machine_system"><input type="number" ref="empty_car_weight" readonly=""></div>
                        <div class="proj-cc" v-if="steps.machine_system"><input type="number" ref="counterweight" readonly=""></div>
                    </template>
                    <template v-else>
                        <div class="proj-cc" v-if="steps.machine_system"><input type="number" v-model="car.speed" ref="speed" readonly=""></div>
                        <div class="proj-cc" v-if="steps.machine_system"><input type="number" v-model="car.capacity" ref="capacity" readonly=""></div>
                        <div class="proj-cc" v-if="steps.machine_system"><input type="number" v-model="car.empty_car_weight" ref="empty_car_weight" readonly=""></div>
                        <div class="proj-cc" v-if="steps.machine_system"><input type="number" v-model="car.counterweight" ref="counterweight" readonly=""></div>
                    </template>

                    <div class="proj-cc" v-if="!steps.machine_system">
                        <select
                            v-model="car.hoistway_components.speedsel"
                            required
                            @change="car.hoistway_components.speed=car.hoistway_components.speedsel!='Other'?car.hoistway_components.speedsel:''"
                            ref="speedsel"
                        >
                            <option value="50">50</option>
                            <option value="75">75</option>
                            <option value="100">100</option>
                            <option value="150">150</option>
                            <option value="200">200</option>
                            <option value="250">250</option>
                            <option value="300">300</option>
                            <option value="350">350</option>
                            <option value="400">400</option>
                            <option value="450">450</option>
                            <option value="500">500</option>
                            <option value="600">600</option>
                            <option value="700">700</option>
                            <option value="800">800</option>
                            <option value="1000">1000</option>
                            <option value="1200">1200</option>
                            <option value="1400">1400</option>
                            <option value="Other">Other</option>
                        </select>
                        <input
                            :type="car.hoistway_components.speedsel == 'Other'?'number':'hidden'"
                            v-model="car.hoistway_components.speed"
                            required
                            ref="speed"
                            @blur="rangeSub(cn,'hoistway_components','speed',1,9999)"
                        >
                    </div>
                    <div class="proj-cc" v-if="!steps.machine_system" :hidden="hidableRowsHoist.capacitysel">
                        <select
                            v-model="car.hoistway_components.capacitysel"
                            required
                            :disabled="car.hoistway_components.roller_guide !== 'Y' && car.hoistway_components.safety !== 'Y' && car.hoistway_components.oil_buffer !== 'Y'"
                            @change="car.hoistway_components.capacity=car.hoistway_components.capacitysel!='Other'?car.hoistway_components.capacitysel:''"
                            ref="capacitysel"
                        >
                            <option value="1500">1500</option>
                            <option value="2000">2000</option>
                            <option value="2500">2500</option>
                            <option value="3000">3000</option>
                            <option value="3500">3500</option>
                            <option value="4000">4000</option>
                            <option value="4500">4500</option>
                            <option value="5000">5000</option>
                            <option value="5500">5500</option>
                            <option value="6000">6000</option>
                            <option value="8000">8000</option>
                            <option value="10000">10000</option>
                            <option value="12000">12000</option>
                            <option value="Other">Other</option>
                        </select>
                        <input
                            :type="car.hoistway_components.capacitysel == 'Other'?'number':'hidden'"
                            v-model="car.hoistway_components.capacity"
                            :disabled="car.hoistway_components.roller_guide !== 'Y' && car.hoistway_components.safety !== 'Y' && car.hoistway_components.oil_buffer !== 'Y'"
                            required
                            ref="capacity"
                            @blur="rangeSub(cn,'hoistway_components','capacity',1,15000)"
                        >
                    </div>
                    <div class="proj-cc" v-if="!steps.machine_system" :hidden="hidableRowsHoist.empty_car_weight">
                        <input
                            type="number"
                            v-model="car.hoistway_components.empty_car_weight"
                            ref="empty_car_weight"
                            :disabled="car.hoistway_components.safety !== 'Y' && car.hoistway_components.oil_buffer !== 'Y'"
                            required
                            @blur="rangeSub(cn,'hoistway_components','empty_car_weight',1000,50000)"
                        >
                    </div>
                    <div class="proj-cc" v-if="!steps.machine_system" :hidden="hidableRowsHoist.counterweight">
                        <input
                            type="number"
                            v-model="car.hoistway_components.counterweight"
                            :disabled="car.hoistway_components.oil_buffer !== 'Y'"
                            required
                            ref="counterweight"
                            @blur="rangeSub(cn,'hoistway_components','counterweight',40,50)"
                        >
                    </div>

                    <div :hidden="hidableRowsHoist.governor_type" class="proj-cc">
                        <select v-model="car.hoistway_components.governor_type" required ref="governor_type" disabled>
                            <option></option>
                            <option value="Standard">Standard</option>
                            <!-- <option value="Remote Trip & Reset">Remote Trip & Reset</option> -->
                        </select>
                    </div>
                    <div :hidden="hidableRowsHoist.governor_rope_length" class="proj-cc">
                        <input type="number" 
                            :disabled="car.hoistway_components.governor_rope != 'Y'"
                            @blur="rangeSub(cn,'hoistway_components','governor_rope_length',0,999)"
                            v-model="car.hoistway_components.governor_rope_length" 
                            required
                            ref="governor_rope_length">
                    </div>
                    <div :hidden="hidableRowsHoist.governor_position" class="proj-cc">
                        <select v-model="car.hoistway_components.governor_position" required ref="governor_position" :disabled="car.hoistway_components.safety != 'Y'">
                            <option></option>
                            <option value="Q1 or Q3">Q1 or Q3</option>
                            <option value="Q2 or Q4">Q2 or Q4</option>
                        </select>
                    </div>
                    <div :hidden="hidableRowsHoist.dbg" class="proj-cc">
                        <input
                            type="number"
                            v-model="car.hoistway_components.dbg"
                            required
                            ref="dbg"
                            :disabled="car.hoistway_components.safety != 'Y'"
                            @blur="rangeSub(cn,'hoistway_components','dbg',35,118)"
                        >
                    </div>
                    <div :hidden="hidableRowsHoist.oil_buffer_car_side_qty" class="proj-cc">
                        <select v-model="car.hoistway_components.oil_buffer_car_side_qty" required ref="oil_buffer_car_side_qty" :disabled="car.hoistway_components.oil_buffer != 'Y'">
                            <option></option>
                            <option value="0">0</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                        </select>
                    </div>
                    <div :hidden="hidableRowsHoist.oil_buffer_cwt_side_qty" class="proj-cc">
                        <select v-model="car.hoistway_components.oil_buffer_cwt_side_qty" required ref="oil_buffer_cwt_side_qty" :disabled="car.hoistway_components.oil_buffer != 'Y'">
                            <option></option>
                            <option value="0">0</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                        </select>
                    </div>
                </div>
            </div></div>
        </section>

        <section class="project-section" v-if="step == 'hydraulics'">
            <h2 class="proj-s1">Hydraulic Power Unit</h2>

            <div class="top-scroll">
                <div class="top-scroll-body"></div>
            </div>

            <div class="proj-labels">
                <div class="proj-section1 proj-group">
                    <div class="proj-s1" v-if="model.cars[2]">Copy From</div>
                    <div class="proj-ds"><label> Car ID Number</label></div>
                    <div class="proj-ds"><label> ANSI Code 2010 or later? </label></div>
                    <div class="proj-ds"><label> Twin Jack? </label></div>
                    <div :hidden="hidableRowsHydraulic.existing_fl_pressure" class="proj-ds"><label> Existing FL Pressure <small>(PSI) (range: 300-500)</small></label></div>
                    <div :hidden="hidableRowsHydraulic.capacitysel" class="proj-ds"><label> Capacity <small>(lb) (range: 1000-12000)</small></label></div>
                    <div :hidden="hidableRowsHydraulic.car_weight" class="proj-ds"><label> Car Weight <small>(lb) (range: 1000-15000)</small></label></div>
                    <div class="proj-ds"><label> Requested Speed <small>(ft/min) (0-200)</small></label></div>
                    <div class="proj-ds"><label> Piston Diameter <small>(in) (range: 2-6)</small></label></div>
                    <div class="proj-ds"><label> Travel <small>(ft) (range: 10-65)</small></label></div>
                    <div class="proj-ds"><label> Existing Motor HP <small>(HP) (range: 1-50)</small></label></div>
                    <div class="proj-ds"><label> Building Voltage <small>(VAC)</small></label></div>
                    <div class="proj-ds"><label> Valve Coil Voltage </label></div>
                    <div class="proj-ds"><label> Motor SPH </label></div>
                    <div class="proj-ds"><label> Hand </label></div>
                    <div class="proj-ds"><label> Connection Type </label></div>
                    <div class="proj-ds"><label> Machine Room </label></div>
                    <div :hidden="hidableRowsHydraulic.distance" class="proj-ds"><label> Distance <small>(ft) (range: 0-60)</small></label></div>
                    <div class="proj-ds"><label> Rupture Valve Installed</label></div>
                    <div class="proj-cc proj-h3"><label><strong>Optional Components</strong></label></div>
                    <div class="proj-ds"><label> Viscosity Temp Switch </label></div>
                    <div class="proj-ds"><label> Low Pressure Sw </label></div>
                    <div class="proj-ds"><label> Low Oil Switch </label></div>
                    <div class="proj-ds"><label> Load Weigh Pressure Switch </label></div>
                    <div class="proj-ds"><label> Constant Down Speed Control(Maxton) </label></div>
                    <div class="proj-ds"><label> Oil Cooler(fit to Tank) </label></div>
                    <div class="proj-ds"><label> Oil Level Temp/Sight Gauge; Grainger 6W388 </label></div>
                    <div class="proj-ds"><label> Pulsating Material Muffler VIC </label></div>
                    <div class="proj-ds"><label> Scavenger Pump w/ 100ft Plastic Tubing </label></div>
                    <div :hidden="hidableRowsHydraulic.copper_tubing" class="proj-ds"><label> 50ft roll copper tubing in lieu of Plastic*** </label></div>
                    <div class="proj-ds"><label> Tank Heater </label></div>
                    <div class="proj-ds"><label> Shut Off Ball Valve </label></div>
                    <div class="proj-ds"><label> J Box mounted on Tank for wire consolidation </label></div>
                </div>
            </div>

            <div class="proj-cars"><div class="proj-car" v-for="(car,cn) in model.cars" :key="cn">
                <div class="proj-section1 proj-group">
                    <div class="proj-s1" v-if="model.cars[2]">
                        <select v-model="car.copier" required  @change="copyInput(car.copier,cn,'hydraulics')">
                            <template v-for="(ccar,ccn) in model.cars">
                                <option :value="ccn" :key="ccn" v-if="cn != ccn">Car #{{ ccar.car_id_number }}</option>
                            </template>
                        </select>
                    </div>
                    <div class="proj-ds"><input type="text" v-model="car.car_id_number" placeholder="Car ID Number" required readonly></div>
                    <div class="proj-ds">
                        <select v-model="car.hydraulics.ansi_code_2010" required ref="ansi_code_2010">
                            <option></option>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                    <div class="proj-ds">
                        <select v-model="car.hydraulics.twin_jack" required ref="twin_jack">
                            <option></option>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                    <div :hidden="hidableRowsHydraulic.existing_fl_pressure" class="proj-cc">
                        <input
                            type="number"
                            v-model="car.hydraulics.existing_fl_pressure"
                            ref="existing_fl_pressure"
                            @keyup="subChange(cn,'hydraulics','existing_fl_pressure')"
                            @blur="rangeSub(cn,'hydraulics','existing_fl_pressure',300,500)"
                            :disabled="car.hydraulics.capacity > 0 || car.hydraulics.car_weight > 0"
                        >
                    </div>
                    <div :hidden="hidableRowsHydraulic.capacitysel" class="proj-cc">
                        <select
                            v-model="car.hydraulics.capacitysel"
                            required
                            @change="car.hydraulics.capacity=car.hydraulics.capacitysel!='Other'?car.hydraulics.capacitysel:''"
                            ref="capacitysel"
                            :disabled="car.hydraulics.existing_fl_pressure > 0"
                        >
                            <option value=""></option>
                            <option value="1500">1500</option>
                            <option value="2000">2000</option>
                            <option value="2500">2500</option>
                            <option value="3000">3000</option>
                            <option value="3500">3500</option>
                            <option value="4000">4000</option>
                            <option value="4500">4500</option>
                            <option value="5000">5000</option>
                            <option value="5500">5500</option>
                            <option value="6000">6000</option>
                            <option value="8000">8000</option>
                            <option value="10000">10000</option>
                            <option value="12000">12000</option>
                            <option value="Other">Other</option>
                        </select>
                        <input
                            :type="car.hydraulics.capacitysel == 'Other'?'number':'hidden'"
                            v-model="car.hydraulics.capacity"
                            required
                            ref="capacity"
                            @blur="rangeSub(cn,'hydraulics','capacity',1000,12000)"
                            :disabled="car.hydraulics.existing_fl_pressure > 0"
                        >
                    </div>
                    <div :hidden="hidableRowsHydraulic.car_weight" class="proj-cc">
                        <input
                            type="number"
                            v-model="car.hydraulics.car_weight"
                            :disabled="car.hydraulics.existing_fl_pressure > 0"
                            ref="car_weight"
                            @blur="rangeSub(cn,'hydraulics','car_weight',1000,15000)"
                        >
                    </div>
                    <div class="proj-cc">
                        <select
                            v-model="car.hydraulics.speedsel"
                            required
                            @change="car.hydraulics.requested_speed=car.hydraulics.speedsel!='Other'?car.hydraulics.speedsel:''"
                            ref="speedsel"
                        >
                            <option value="50">50</option>
                            <option value="75">75</option>
                            <option value="100">100</option>
                            <option value="150">150</option>
                            <option value="200">200</option>
                            <option value="Other">Other</option>
                        </select>
                        <input
                            :type="car.hydraulics.speedsel == 'Other'?'number':'hidden'"
                            v-model="car.hydraulics.requested_speed"
                            required
                            ref="requested_speed"
                            @blur="rangeSub(cn,'hydraulics','requested_speed',0,200)"
                        >
                    </div>
                    <div class="proj-cc">
                        <input
                            type="number"
                            v-model="car.hydraulics.piston_diameter"
                            required
                            ref="piston_diameter"
                            @blur="rangeSub(cn,'hydraulics','piston_diameter',2,6)"
                        >
                    </div>
                    <div class="proj-cc">
                        <input
                            type="number"
                            v-model="car.hydraulics.travel"
                            required
                            ref="travel"
                            @blur="rangeSub(cn,'hydraulics','travel',10,65)"
                        >
                    </div>
                    <div class="proj-ds">
                        <select v-model="car.hydraulics.existing_motor_hp" required ref="existing_motor_hp">
                            <option></option>
                            <option>15</option>
                            <option>20</option>
                            <option>25</option>
                            <option>30</option>
                            <option>40</option>
                            <option>50</option>
                        </select>
                    </div>
                    <div class="proj-ds">
                        <select v-model="car.hydraulics.building_voltage" required ref="building_voltage">
                            <option></option>
                            <option value="208">208 VAC</option>
                            <option value="240">240 VAC</option>
                            <option value="480">480 VAC</option>
                        </select>
                    </div>
                    <div class="proj-ds">
                        <select v-model="car.hydraulics.valve_coil_voltage" required ref="valve_coil_voltage">
                            <option></option>
                            <option value="120 VAC">120 VAC</option>
                            <option value="230 VAC">230 VAC</option>
                            <option value="110 VDC">110 VDC</option>
                        </select>
                    </div>
                    <div class="proj-ds">
                        <select v-model="car.hydraulics.motor_sph" required ref="motor_sph">
                            <option></option>
                            <option>80</option>
                            <option>120</option>
                        </select>
                    </div>
                    <div class="proj-ds">
                        <select v-model="car.hydraulics.hand" required ref="hand">
                            <option></option>
                            <option>LH</option>
                            <option>RH</option>
                        </select>
                    </div>
                    <div class="proj-ds">
                        <select v-model="car.hydraulics.connection_type" required ref="connection_type">
                            <option></option>
                            <option>Victaulic</option>
                            <option>Threaded</option>
                        </select>
                    </div>
                    <div class="proj-ds">
                        <select v-model="car.hydraulics.machine_room_location" required ref="machine_room_location" @change="subChange(cn, 'hydraulics', 'machine_room_location')">
                            <option></option>
                            <option>Adjacent</option>
                            <option>Remote</option>
                        </select>
                    </div>
                    <div :hidden="hidableRowsHydraulic.distance" class="proj-cc">
                        <input
                            type="number"
                            required
                            v-model="car.hydraulics.distance"
                            ref="distance"
                            :disabled="car.hydraulics.machine_room_location == 'Adjacent'"
                            @blur="rangeSub(cn,'hydraulics','distance',0,60)"
                        >
                    </div>
                    <div class="proj-ds">
                        <select v-model="car.hydraulics.rupture_valve_installed" required ref="rupture_valve_installed">
                            <option></option>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>

                    <div class="proj-ds"></div>
                    <div class="proj-ds">
                        <select v-model="car.hydraulics.viscosity_temp_switch" required ref="viscosity_temp_switch">
                            <option></option>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                    <div class="proj-ds">
                        <select v-model="car.hydraulics.low_pressure_sw" required ref="low_pressure_sw">
                            <option></option>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                    <div class="proj-ds">
                        <select v-model="car.hydraulics.low_oil_switch" required ref="low_oil_switch">
                            <option></option>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                    <div class="proj-ds">
                        <select v-model="car.hydraulics.load_weigh_pressure_switch" required ref="load_weigh_pressure_switch">
                            <option></option>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                    <div class="proj-ds">
                        <select v-model="car.hydraulics.constant_down_speed_control" required ref="constant_down_speed_control">
                            <option></option>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                    <div class="proj-ds">
                        <select v-model="car.hydraulics.oil_cooler" required ref="oil_cooler">
                            <option></option>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                    <div class="proj-ds">
                        <select v-model="car.hydraulics.oil_level_temp_sight_gauge" required ref="oil_level_temp_sight_gauge">
                            <option></option>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                    <div class="proj-ds">
                        <select v-model="car.hydraulics.pulsating_material_muffler" required ref="pulsating_material_muffler">
                            <option></option>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                    <div class="proj-ds">
                        <select v-model="car.hydraulics.scavenger_pump" required ref="scavenger_pump" @change="subChange(cn, 'hydraulics', 'scavenger_pump')">
                            <option></option>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                    <div :hidden="hidableRowsHydraulic.copper_tubing" class="proj-ds">
                        <select v-model="car.hydraulics.copper_tubing" required ref="copper_tubing" :disabled="car.hydraulics.scavenger_pump == 'N'">
                            <option></option>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                    <div class="proj-ds">
                        <select v-model="car.hydraulics.tank_heater" required ref="tank_heater">
                            <option></option>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                    <div class="proj-ds">
                        <select v-model="car.hydraulics.shut_off_ball_valve" required ref="shut_off_ball_valve">
                            <option></option>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                    <div class="proj-ds">
                        <select v-model="car.hydraulics.j_box" required ref="j_box">
                            <option></option>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                </div>
            </div></div>
        </section>

        <section class="project-section" v-if="step == 'wire_ropes'">
            <h2 class="proj-s1">Wire Rope</h2>

            <div class="top-scroll">
                <div class="top-scroll-body"></div>
            </div>

            <div class="proj-labels">
                <div class="proj-section1 proj-group">
                    <div class="proj-s1" v-if="model.cars[2]">Copy From</div>
                    <div class="proj-ds"><label> Car ID Number</label></div>
                    <div class="proj-ds proj-r2"><label> </label></div>
                    <div :hidden="hidableRowsWire.governor_rope_length" class="proj-ds"><label> Governor Rope Length <small>(ft) (range: 0-999)</small></label></div>
                    <div :hidden="hidableRowsWire.rope_size" class="proj-ds"><label> Hoist Rope Size</label></div>
                    <div :hidden="hidableRowsWire.rope_type" class="proj-ds"><label> Hoist Rope Type</label></div>
                    <div :hidden="hidableRowsWire.hoist_rope_length" class="proj-ds"><label> Hoist Rope Length <small>(ft) (range: 0-999)</small></label></div>
                    <div :hidden="hidableRowsWire.hoist_rope_number" class="proj-ds"><label> Hoist Rope Number <small>(range: 0-999)</small></label></div>
                    <div :hidden="hidableRowsWire.dw" class="proj-ds"><label> Double Wrap</label></div>
                </div>
            </div>

            <div class="proj-cars"><div class="proj-car" v-for="(car,cn) in model.cars" :key="cn">
                <div class="proj-section1 proj-group" v-if="steps.machine_system">
                    <div class="proj-ds"></div>
                    <div class="proj-ds"><input type="text" v-model="car.car_id_number" disabled></div>
                    <div class="proj-ds"><input type="text" disabled></div>
                    <div class="proj-ds"><input type="text" disabled></div>
                    <div class="proj-ds"><input type="text" disabled></div>
                    <div class="proj-ds"><input type="text" disabled></div>
                    <div class="proj-ds"><input type="text" disabled></div>
                    <div class="proj-ds"><input type="text" disabled></div>
                    <div class="proj-ds"><input type="text" disabled></div>
                    <div class="proj-ds"><input type="text" disabled></div>
                    <div class="proj-ds"><input type="text" disabled></div>
                </div>
                <div class="proj-section1 proj-group" v-else>
                    <div class="proj-s1" v-if="model.cars[2]">
                        <select v-model="car.copier" required  @change="copyInput(car.copier,cn,'wire_ropes')">
                            <template v-for="(ccar,ccn) in model.cars">
                                <option :value="ccn" :key="ccn" v-if="cn != ccn">Car #{{ ccar.car_id_number }}</option>
                            </template>
                        </select>
                    </div>
                    <div class="proj-ds"><input type="text" v-model="car.car_id_number" placeholder="Car ID Number" disabled></div>

                    <div class="proj-cc"><label><input type="checkbox" :checked="car.wire_ropes.governor_rope == 'Y'" @change="subYToggle(cn,'wire_ropes','governor_rope', $event)"> Governor Rope</label></div>
                    <div class="proj-cc"><label><input type="checkbox" :checked="car.wire_ropes.hoist_rope == 'Y'" @change="subYToggle(cn,'wire_ropes','hoist_rope', $event)"> Hoist Rope</label></div>

                    <div :hidden="hidableRowsWire.governor_rope_length" class="proj-cc">
                        <input type="number" 
                            v-model="car.wire_ropes.governor_rope_length" 
                            ref="governor_rope_length" 
                            :disabled="car.wire_ropes.governor_rope != 'Y'"
                            @blur="rangeSub(cn,'wire_ropes','governor_rope_length',0,999)"
                        >
                    </div>
                    <div :hidden="hidableRowsWire.rope_size" class="proj-cc">
                        <select v-model="car.wire_ropes.rope_size" required ref="rope_size" :disabled="car.wire_ropes.hoist_rope != 'Y'">
                            <option></option>
                            <option value="8mm">8mm</option>
                            <option value="10mm">10mm</option>
                            <option value="1/2">1/2</option>
                            <option value="5/8">5/8</option>
                            <option value="3/4">3/4</option>
                        </select>
                    </div>
                    <div :hidden="hidableRowsWire.rope_type" class="proj-cc">
                        <select v-model="car.wire_ropes.rope_type" required ref="rope_type" :disabled="car.wire_ropes.hoist_rope != 'Y' || !car.wire_ropes.rope_size || !hropes || !hropes[car.wire_ropes.rope_size]">
                            <option></option>
                            <template v-if="hropes && hropes[car.wire_ropes.rope_size]">
                                <template v-for="(rope,sz) in hropes[car.wire_ropes.rope_size]">
                                    <option :value="rope" :key="sz">{{ rope }}</option>
                                </template>
                            </template>
                        </select>
                    </div>
                    <div :hidden="hidableRowsWire.hoist_rope_length" class="proj-cc">
                        <input
                            type="number"
                            v-model="car.wire_ropes.hoist_rope_length"
                            ref="hoist_rope_length"
                            :disabled="car.wire_ropes.hoist_rope != 'Y'"
                            @blur="rangeSub(cn,'wire_ropes','hoist_rope_length',0,999)"
                        >
                    </div>
                    <div :hidden="hidableRowsWire.hoist_rope_number" class="proj-cc">
                        <input
                            type="number"
                            v-model="car.wire_ropes.hoist_rope_number"
                            ref="hoist_rope_number"
                            :disabled="car.wire_ropes.hoist_rope != 'Y'"
                            @blur="rangeSub(cn,'wire_ropes','hoist_rope_number',0,999)"
                        >
                    </div>
                    <div :hidden="hidableRowsWire.dw" class="proj-cc">
                        <select v-model="car.wire_ropes.dw" required ref="dw" :disabled="car.wire_ropes.hoist_rope != 'Y'">
                            <option></option>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                </div>
            </div></div>
        </section>

        <section class="project-section" v-if="step == 'compensations'">
            <h2 class="proj-s1">Compensation</h2>

            <div class="top-scroll">
                <div class="top-scroll-body"></div>
            </div>

            <div class="proj-labels">
                <div class="proj-section1 proj-group">
                    <div class="proj-s1" v-if="model.cars[2]">Copy From</div>
                    <div class="proj-ds"><label> Car ID Number</label></div>
                    <div class="proj-ds"><label> Compensation Type</label></div>
                    <div class="proj-ds"><label> Compensation Weight <small>(lbs/ft)</small></label></div>
                    <div class="proj-ds"><label> Compensation Length <small>(ft) (range: 0-999)</small></label></div>
                    <div class="proj-ds"><label> No. of Compensation Chain</label></div>
                    <div class="proj-ds"><label> Request Swayless Device</label></div>
                    <div class="proj-ds"><label> Speed <small>(fpm) (range: 0-700)</small></label></div>
                </div>
            </div>

            <div class="proj-cars"><div class="proj-car" v-for="(car,cn) in model.cars" :key="cn">
                <div class="proj-section1 proj-group" v-if="steps.machine_system">
                    <div class="proj-ds"></div>
                    <div class="proj-ds"><input type="text" v-model="car.car_id_number" disabled></div>
                    <div class="proj-ds"><input type="text" disabled></div>
                    <div class="proj-ds"><input type="text" disabled></div>
                    <div class="proj-ds"><input type="text" disabled></div>
                    <div class="proj-ds"><input type="text" disabled></div>
                    <div class="proj-ds"><input type="text" disabled></div>
                    <div class="proj-ds"><input type="text" disabled></div>
                </div>
                <div class="proj-section1 proj-group" v-else>
                    <div class="proj-s1" v-if="model.cars[2]">
                        <select v-model="car.copier" required  @change="copyInput(car.copier,cn,'compensations')">
                            <template v-for="(ccar,ccn) in model.cars">
                                <option :value="ccn" :key="ccn" v-if="cn != ccn">Car #{{ ccar.car_id_number }}</option>
                            </template>
                        </select>
                    </div>
                    <div class="proj-ds"><input type="text" v-model="car.car_id_number" placeholder="Car ID Number" disabled></div>
                    <div class="proj-cc">
                        <select v-model="car.compensations.compensation_type" required ref="compensation_type">
                            <option></option>
                            <option value="Normal">Normal</option>
                            <option value="Wide Loop">Wide Loop</option>
                        </select>
                    </div>
                    <div class="proj-cc">
                        <select v-model="car.compensations.compensation_weight" required ref="compensation_weight">
                            <option></option>
                            <option>0.75</option>
                            <option>1</option>
                            <option>1.5</option>
                            <option>2</option>
                            <option>2.5</option>
                            <option>3</option>
                            <option>3.5</option>
                            <option>4</option>
                        </select>
                    </div>
                    <div class="proj-cc">
                        <input
                            type="number"
                            v-model="car.compensations.compensation_length"
                            required
                            ref="compensation_length"
                            @blur="rangeSub(cn,'compensations','compensation_length',0,999)"
                        >
                    </div>
                    <div class="proj-cc">
                        <select v-model="car.compensations.compensation_chains" required ref="compensation_chains">
                            <option></option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                        </select>
                    </div>
                    <div class="proj-cc">
                        <select v-model="car.compensations.swayless_device" required ref="swayless_device">
                            <option></option>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                    <div class="proj-cc">
                        <select
                            v-model="car.compensations.speedsel"
                            required
                            @change="car.compensations.speed=car.compensations.speedsel!='Other'?car.compensations.speedsel:''"
                            ref="speedsel"
                        >
                            <option value="100">100</option>
                            <option value="150">150</option>
                            <option value="200">200</option>
                            <option value="250">250</option>
                            <option value="300">300</option>
                            <option value="350">350</option>
                            <option value="400">400</option>
                            <option value="450">450</option>
                            <option value="500">500</option>
                            <option value="600">600</option>
                            <option value="700">700</option>
                            <option value="Other">Other</option>
                        </select>
                        <input
                            :type="car.compensations.speedsel == 'Other'?'number':'hidden'"
                            v-model="car.compensations.speed"
                            required
                            ref="speed"
                            @blur="rangeSub(cn,'compensations','speed',0,700)"
                        >
                </div>
            </div></div></div>
        </section>

        <section class="project-section" v-if="step == 'compounding_sheaves'">
            <h2 class="proj-s1">Other Sheave</h2>

            <div class="top-scroll">
                <div class="top-scroll-body"></div>
            </div>

            <div class="proj-labels">
                <div class="proj-section1 proj-group">
                    <div class="proj-s1" v-if="model.cars[2]">Copy From</div>
                    <div class="proj-ds"><label> Car ID Number</label></div>
                    <div class="proj-ds"><label> No Sheave Option</label></div>
                    <div class="proj-ds"><label> Add/Remove Sheave Types</label></div>
                    <div v-if="showDuraLiftSheave" :hidden="hidableRowsSheave.dura_lift_sheave" class="proj-ds"><label> Dura Lift Sheave <ses-tooltip type="illu-dura"></ses-tooltip></label></div>
                    <div :hidden="hidableRowsSheave.sheave_type" class="proj-ds"><label> Sheave Type <ses-tooltip type="illu-S1new"></ses-tooltip></label></div>
                    <div :hidden="hidableRowsSheave.location" class="proj-ds"><label> Location</label></div>
                    <div :hidden="hidableRowsSheave.rope_size" class="proj-ds"><label> Rope Size</label></div>
                    <div :hidden="hidableRowsSheave.groove_number" class="proj-ds"><label> Groove number <small>(range: 1-20)</small></label></div>
                    <div :hidden="hidableRowsSheave.pitch_in" class="proj-ds"><label> Pitch <small>(in) (range: 0.3-2)</small></label></div>
                    <div :hidden="hidableRowsSheave.sheave_diameter" class="proj-ds"><label> Sheave Diameter (D)</label></div>
                    <div :hidden="hidableRowsSheave.max_sheave_width" class="proj-ds"><label> Maximum Allowable Sheave Width <small>(W) (in) (range: 0-99)</small></label></div>
                    <div :hidden="hidableRowsSheave.shaft_type" class="proj-ds"><label> Shaft Type (A or B) <ses-tooltip type="illu-6" align="top"></ses-tooltip></label></div>
                    <div :hidden="hidableRowsSheave.qty" class="proj-ds"><label> Qty</label></div>
                    <div :hidden="hidableRowsSheave.l1" class="proj-ds"><label> L1 <small>(in) (range: 0-25)</small> <ses-tooltip type="illu-6" align="top"></ses-tooltip></label></div>
                    <div :hidden="hidableRowsSheave.l2" class="proj-ds"><label> L2 <small>(in) (range: 0-25)</small> <ses-tooltip type="illu-6" align="top"></ses-tooltip></label></div>
                    <div :hidden="hidableRowsSheave.l3" class="proj-ds"><label> L3 <small>(in) (range: 0-25)</small> <ses-tooltip type="illu-6" align="top"></ses-tooltip></label></div>
                    <div :hidden="hidableRowsSheave.l4" class="proj-ds"><label> L4 <small>(in) (range: 0-25)</small> <ses-tooltip type="illu-6" align="top"></ses-tooltip></label></div>
                    <div :hidden="hidableRowsSheave.l5" class="proj-ds"><label> L5 <small>(in) (range: 0-25)</small> <ses-tooltip type="illu-6" align="top"></ses-tooltip></label></div>
                    <div :hidden="hidableRowsSheave.l6" class="proj-ds"><label> L6 <small>(in) (range: 0-0.6)</small> <ses-tooltip type="illu-6" align="top"></ses-tooltip></label></div>
                </div>
            </div>

            <div class="proj-cars"><div
                    class="proj-car"
                    v-for="(car,cn) in model.cars"
                    :key="cn"
                    :style="car.compounding_sheaves.type_width ? 'width:'+car.compounding_sheaves.type_width+'px' :''"
                >
                <div class="proj-section1 proj-group">
                    <div class="proj-s1" v-if="model.cars[2]">
                        <select v-model="car.copier" required  @change="copyInput(car.copier,cn,'compounding_sheaves')">
                            <template v-for="(ccar,ccn) in model.cars">
                                <option :value="ccn" :key="ccn" v-if="cn != ccn">Car #{{ ccar.car_id_number }}</option>
                            </template>
                        </select>
                    </div>
                    <div class="proj-ds"><input type="text" v-model="car.car_id_number" placeholder="Car ID Number" disabled></div>
                    <div class="proj-ds no-sheave-option">
                        <label>
                            <input
                                type="checkbox"
                                :checked="car.compounding_sheaves.no_sheave === 1"
                                @change="noSheaveToggle(cn,'compounding_sheaves', 'no_sheave')">
                            No Sheave
                        </label>
                    </div>
                    <div class="proj-cc">
                        <div class="proj-split dyna">
                            <button :disabled="car.compounding_sheaves.no_sheave  === 1" type="button" @click="addSheave(cn)" class="btn btn-success">Add</button>
                            <button :disabled="car.compounding_sheaves.no_sheave  === 1" type="button" @click="removeSheave(cn)" class="btn btn-danger">Remove</button>
                        </div>
                    </div>
                    <div v-if="showDuraLiftSheave" :hidden="hidableRowsSheave.dura_lift_sheave" class="proj-cc">
                        <div class="proj-split dyna">
                            <template v-for="(type,tn) in car.compounding_sheaves.types">
                                <select
                                    v-model="car.compounding_sheaves.types[tn].dura_lift_sheave"
                                    ref="dura_lift_sheave"
                                    :key="tn"
                                    :disabled="car.compounding_sheaves.no_sheave === 1"
                                    @change="sheaveChange(cn, 'compounding_sheaves', 'dura_lift_sheave', tn)"
                                    @click="handleClickDuraLift(cn)">
                                    <option></option>
                                    <template v-if="car.rope_diameter === '8mm'">
                                        <option>CSSV-DUR-1</option>
                                        <option>CSSV-DUR-2</option>
                                    </template>
                                    <template v-else-if="car.rope_diameter === '10mm'">
                                        <option>CSSV-DUR-3</option>
                                        <option>CSSV-DUR-4</option>
                                    </template>
                                    <template v-else-if="!('machine_system' in steps)">
                                        <option>CSSV-DUR-1</option>
                                        <option>CSSV-DUR-2</option>
                                        <option>CSSV-DUR-3</option>
                                        <option>CSSV-DUR-4</option>
                                    </template>
                                </select>
                            </template>
                        </div>
                    </div>
                    <div :hidden="hidableRowsSheave.sheave_type" class="proj-cc">
                        <div class="proj-split dyna">
                            <template v-for="(type,tn) in car.compounding_sheaves.types">
                                <select
                                    v-model="car.compounding_sheaves.types[tn].sheave_type"
                                    ref="sheave_type"
                                    required
                                    :key="tn"
                                    :disabled="car.compounding_sheaves.no_sheave === 1 || showDuraLiftSheave && (disabledCssvInput.includes(car.compounding_sheaves.types[tn].dura_lift_sheave))"
                                    @change="sheaveChange(cn, 'compounding_sheaves', 'sheave_type', tn)">
                                    <option></option>
                                    <template v-if="('machine_system' in steps)">
                                        <template v-if="'sheaveTypes' in car.compounding_sheaves">
                                            <option v-if="car.compounding_sheaves.sheaveTypes.includes('A')">A</option>
                                        </template>
                                        <option>B</option>
                                        <option>C</option>
                                        <template v-if="'sheaveTypes' in car.compounding_sheaves">
                                            <option v-if="car.compounding_sheaves.sheaveTypes.includes('D')">D</option>
                                        </template>
                                    </template>
                                    <template v-else-if="!('machine_system' in steps)">
                                        <option>A</option>
                                        <option>B</option>
                                        <option>C</option>
                                        <option>D</option>
                                    </template>
                                </select>
                            </template>
                        </div>
                    </div>
                    <div :hidden="hidableRowsSheave.location" class="proj-cc">
                        <div class="proj-split dyna">
                            <template v-for="(type,tn) in car.compounding_sheaves.types">
                                <select
                                    v-model="car.compounding_sheaves.types[tn].location"
                                    required
                                    ref="location"
                                    :key="tn"
                                    :disabled="car.compounding_sheaves.no_sheave === 1 || showDuraLiftSheave && (disabledCssvInput.includes(car.compounding_sheaves.types[tn].dura_lift_sheave))">
                                    <option></option>
                                    <option>Car Side</option>
                                    <option>CWT Side</option>
                                </select>
                            </template>
                        </div>
                    </div>
                    <div :hidden="hidableRowsSheave.rope_size" class="proj-cc">
                        <div class="proj-split dyna">
                            <template v-for="(type,tn) in car.compounding_sheaves.types">
                                <select
                                    v-model="car.compounding_sheaves.types[tn].rope_size"
                                    required
                                    ref="rope_size"
                                    :key="tn"
                                    :disabled="car.compounding_sheaves.no_sheave === 1 || showDuraLiftSheave && (disabledCssvInput.includes(car.compounding_sheaves.types[tn].dura_lift_sheave))">
                                    <option></option>
                                    <option value="8mm">8mm</option>
                                    <option value="10mm">10mm</option>
                                    <option value="1/2">1/2</option>
                                    <option value="5/8">5/8</option>
                                    <option value="3/4">3/4</option>
                                </select>
                            </template>
                        </div>
                    </div>
                    <div :hidden="hidableRowsSheave.groove_number" class="proj-cc">
                        <div class="proj-split dyna">
                            <template v-for="(type,tn) in car.compounding_sheaves.types">
                                <input 
                                    type="number"
                                    v-model="car.compounding_sheaves.types[tn].groove_number"
                                    ref="groove_number"
                                    @blur="rangeSub(cn,'compounding_sheaves','groove_number',1,20)"
                                    required
                                    :key="tn"
                                    :disabled="car.compounding_sheaves.no_sheave === 1 || showDuraLiftSheave && (disabledCssvInput.includes(car.compounding_sheaves.types[tn].dura_lift_sheave))"
                                >
                            </template>
                        </div>
                    </div>
                    <div :hidden="hidableRowsSheave.pitch_in" class="proj-cc">
                        <div class="proj-split dyna">
                            <template v-for="(type,tn) in car.compounding_sheaves.types">
                                <input type="number"
                                    v-model="car.compounding_sheaves.types[tn].pitch_in"
                                    ref="pitch_in"
                                    @blur="rangeSub(cn,'compounding_sheaves','pitch_in',0.3,2)"
                                    required
                                    :key="tn"
                                    :disabled="car.compounding_sheaves.no_sheave === 1 || showDuraLiftSheave && (disabledCssvInput.includes(car.compounding_sheaves.types[tn].dura_lift_sheave))"
                                >
                            </template>
                        </div>
                    </div>
                    <div :hidden="hidableRowsSheave.sheave_diameter" class="proj-s2">
                        <div class="proj-split dyna">
                            <template v-for="(type,tn) in car.compounding_sheaves.types">
                                <select
                                    v-model="car.compounding_sheaves.types[tn].sheave_diameter"
                                    required
                                    class="s3"
                                    ref="sheave_diameter"
                                    :key="tn"
                                    :disabled="car.compounding_sheaves.no_sheave === 1 || showDuraLiftSheave && (disabledCssvInput.includes(car.compounding_sheaves.types[tn].dura_lift_sheave))">
                                    <option></option>
                                    <option value='340mm [13.4"]'>340mm [13.4"]</option>
                                    <option value='400mm [15.7"]'>400mm [15.7"]</option>
                                    <option value='520mm [20.5"]'>520mm [20.5"]</option>
                                    <option value='640mm [25.2"]'>640mm [25.2"]</option>
                                    <option value='762mm [30.0"]'>762mm [30.0"]</option>
                                </select>
                            </template>
                        </div>
                    </div>
                    <div :hidden="hidableRowsSheave.max_sheave_width" class="proj-s2">
                        <div class="proj-split dyna">
                            <template v-for="(type,tn) in car.compounding_sheaves.types">
                                <input type="number"
                                    v-model="car.compounding_sheaves.types[tn].max_sheave_width"
                                    class="s3"
                                    required
                                    ref="max_sheave_width"
                                    @blur="rangeSub(cn,'compounding_sheaves','max_sheave_width',0,99)"
                                    :key="tn"
                                    :disabled="car.compounding_sheaves.no_sheave === 1 || showDuraLiftSheave && (disabledCssvInput.includes(car.compounding_sheaves.types[tn].dura_lift_sheave))"
                                >
                            </template>
                        </div>
                    </div>
                    <div :hidden="hidableRowsSheave.shaft_type" class="proj-s2">
                        <div class="proj-split dyna">
                            <template v-for="(type,tn) in car.compounding_sheaves.types">
                                <select
                                    ref="shaft_type"
                                    v-model="car.compounding_sheaves.types[tn].shaft_type"
                                    class="s3"
                                    required
                                    @change="subChange(cn, 'compounding_sheaves', 'shaft_type')"
                                    :key="tn"
                                    :disabled="car.compounding_sheaves.no_sheave === 1 || showDuraLiftSheave && (disabledCssvInput.includes(car.compounding_sheaves.types[tn].dura_lift_sheave))"
                                >
                                    <option></option>
                                    <option value='A'>A</option>
                                    <option value='B'>B</option>
                                </select>
                            </template>
                        </div>
                    </div>
                    <div :hidden="hidableRowsSheave.qty" class="proj-s2">
                        <div class="proj-split dyna">
                            <template v-for="(type,tn) in car.compounding_sheaves.types">
                                <select
                                    ref="qty"
                                    v-model="car.compounding_sheaves.types[tn].qty"
                                    class="s3"
                                    required
                                    :key="tn"
                                    :disabled="car.compounding_sheaves.no_sheave === 1">
                                    <option></option>
                                    <option>1</option>
                                    <option>2</option>
                                    <option>3</option>
                                    <option>4</option>
                                </select>
                            </template>
                        </div>
                    </div>
                    <div :hidden="hidableRowsSheave.l1" class="proj-s2">
                        <div class="proj-split dyna">
                            <template v-for="(type,tn) in car.compounding_sheaves.types">
                                <input
                                    type="number"
                                    v-model="car.compounding_sheaves.types[tn].l1"
                                    class="s3"
                                    @blur="rangeSub(cn,'compounding_sheaves','l1',0,25)"
                                    required
                                    ref="l1"
                                    :key="tn"
                                    :disabled="car.compounding_sheaves.no_sheave === 1 || showDuraLiftSheave && (disabledCssvInput.includes(car.compounding_sheaves.types[tn].dura_lift_sheave))"
                                >
                            </template>
                        </div>
                    </div>
                    <div :hidden="hidableRowsSheave.l2" class="proj-s2">
                        <div class="proj-split dyna">
                            <template v-for="(type,tn) in car.compounding_sheaves.types">
                                <input
                                    type="number"
                                    v-model="car.compounding_sheaves.types[tn].l2"
                                    class="s3"
                                    @blur="rangeSub(cn,'compounding_sheaves','l2',0,25)"
                                    required
                                    ref="l2"
                                    :disabled="car.compounding_sheaves.no_sheave === 1 || showDuraLiftSheave && (disabledCssvInput.includes(car.compounding_sheaves.types[tn].dura_lift_sheave))"
                                    :key="tn">
                            </template>
                        </div>
                    </div>
                    <div :hidden="hidableRowsSheave.l3" class="proj-s2">
                        <div class="proj-split dyna">
                            <template v-for="(type,tn) in car.compounding_sheaves.types">
                                <input
                                    type="number"
                                    v-model="car.compounding_sheaves.types[tn].l3"
                                    class="s3"
                                    @blur="rangeSub(cn,'compounding_sheaves','l3',0,25)"
                                    required
                                    ref="l3"
                                    :disabled="car.compounding_sheaves.no_sheave === 1 || showDuraLiftSheave && (disabledCssvInput.includes(car.compounding_sheaves.types[tn].dura_lift_sheave))"
                                    :key="tn">
                            </template>
                        </div>
                    </div>
                    <div :hidden="hidableRowsSheave.l4" class="proj-s2">
                        <div class="proj-split dyna">
                            <template v-for="(type,tn) in car.compounding_sheaves.types">
                                <input
                                    type="number"
                                    v-model="car.compounding_sheaves.types[tn].l4"
                                    class="s3"
                                    @blur="rangeSub(cn,'compounding_sheaves','l4',0,25)"
                                    required
                                    ref="l4"
                                    :disabled="car.compounding_sheaves.no_sheave === 1 || showDuraLiftSheave && (disabledCssvInput.includes(car.compounding_sheaves.types[tn].dura_lift_sheave))"
                                    :key="tn">
                            </template>
                        </div>
                    </div>
                    <div :hidden="hidableRowsSheave.l5" class="proj-s2">
                        <div class="proj-split dyna">
                            <template v-for="(type,tn) in car.compounding_sheaves.types">
                                <input
                                    type="number"
                                    v-model="car.compounding_sheaves.types[tn].l5"
                                    class="s3"
                                    @blur="rangeSub(cn,'compounding_sheaves','l5',0,25)"
                                    required
                                    ref="l5"
                                    :disabled="car.compounding_sheaves.no_sheave === 1 || car.compounding_sheaves.types[tn].shaft_type != 'B' || (showDuraLiftSheave && (disabledCssvInput.includes(car.compounding_sheaves.types[tn].dura_lift_sheave)))"
                                    :key="tn"
                                >
                            </template>
                        </div>
                    </div>
                    <div :hidden="hidableRowsSheave.l6" class="proj-s2">
                        <div class="proj-split dyna">
                            <template v-for="(type,tn) in car.compounding_sheaves.types">
                                <input
                                    type="number"
                                    v-model="car.compounding_sheaves.types[tn].l6"
                                    class="s3"
                                    @blur="rangeSub(cn,'compounding_sheaves','l6',0,25)"
                                    required
                                    ref="l6"
                                    :disabled="car.compounding_sheaves.no_sheave === 1 || car.compounding_sheaves.types[tn].shaft_type != 'B' || (showDuraLiftSheave && (disabledCssvInput.includes(car.compounding_sheaves.types[tn].dura_lift_sheave)))"
                                    :key="tn"
                                >
                            </template>
                        </div>
                    </div>
                </div>
            </div></div>
        </section>
    </form>

    <div class="proj-controls">
        <span v-if="step == 'selection'">
            <a class="btn btn-primary" @click="nextStep">Get Instant Quote</a>
        </span>
        <span v-else-if="step == 'preview' || showDS">
            <a class="btn btn-primary" @click="edit" data-str="Edit">Edit</a>
            <a class="btn btn-primary" @click="request" data-str="Request">
                <span v-if="loading"><span class="fa fa-spinner fa-pulse"></span></span>
                <span v-else>Request</span>
            </a>
        </span>
        <span v-else-if="step == laststep || model.project.form_type == 'selection'">
            <a class="btn btn-primary" @click="backStep">Back</a>
            <a class="btn btn-primary" @click="showSP">
                <span v-if="loading"><span class="fa fa-spinner fa-pulse"></span></span>
                <span v-else-if="(!steps.machine_system || model.project.form_type == 'selection') && model.project.phase == 'construction'">Request</span>
                <span v-else>Submit</span>
            </a>
        </span>
        <span v-else>
            <a class="btn btn-primary" @click="backStep">Back</a>
            <a class="btn btn-primary" @click="nextSP">
                <template v-if="nextloading"><span class="fa fa-spinner fa-pulse"></span></template>
                <template v-else>Next</template>
            </a>
        </span>
    </div>

    <div :class="showLD ? 'fx-datasheet is_loading' : 'fx-datasheet'" v-if="showDS">
    <div v-if="showLD">
        <img src="/project/img/loading.gif" class="loader">
    </div>
    <div v-else>
        <br>
        <br>

        <h2 class="proj-s1 text-center">Review of Input</h2>


        <h2 class="proj-s1 text-left" v-if="steps.machine_system">Machine Selection</h2>
        <section class="project-section project-section-1" v-if="steps.machine_system">

            <div class="sform">
            <div class="proj-labels">
                <div class="proj-section1 proj-group">
                    <div class="proj-nn" v-for="(car,group) in datasheets" :key="group"><label> Machine Number <small>({{ group }})</small></label></div>
                </div>
            </div>

            <div class="proj-cars"><div class="proj-car" v-for="(car,cn) in model.cars" :key="cn">
                <div class="proj-section1 proj-group">
                    <div class="proj-nn" v-for="(car,group) in datasheets" :key="group">{{ car[cn] ? car[cn].machine_number : '' }}</div>
                </div>
            </div></div>
            </div>
        </section>


        <h2 class="proj-s1 text-left" v-if="steps.machine_system">Traction Machine Sytem</h2>
        <section class="project-section project-section-1" v-if="steps.machine_system">

            <div class="sform">
            <h2 class="proj-s1">SECTION #1 - For Bidding</h2>

            <div class="proj-labels">
                <div class="proj-section1 proj-group">
                    <div class="proj-nn"><label> Car ID Number <small>(One car per column)</small></label></div>
                    <div :class="`proj-r${requiredRowsSpan}`" class="proj-s1 no-pt no-pl">
                        <div class="proj-split-lbl">
                            <div class="vertical-text">
                                <div class="v-required"></div>
                            </div>
                            <div class="split-left-align split-labels">
                                <div class="bb bl text-bold">
                                    <label>Geared or Gearless</label>
                                </div>
                                <div class="bb bl text-bold">
                                    <label>Machine Location</label>
                                </div>
                                <div class="bb bl text-bold">
                                    <label>Roping Ratio</label>
                                </div>
                                <div class="bb bl text-bold">
                                    <label>Elevator Capacity <small>(lb)</small></label>
                                </div>
                                <div class="bb bl text-bold">
                                    <label>Elevator Speed <small>(fpm)</small></label>
                                </div>
                                <div class="bl text-bold" :class="{ 'bb': hasNonOHMR }">
                                    <label> Travel <small>(ft)</small> <a :title="`Assume 12' per landing if unknown during bidding.`" style="font-size:11px;font-weight:normal;"><span class="bg-diamond"><i>(?)</i></span></a></label>
                                </div>
                                <div :hidden="hidableRows.machine_shape" class="bl text-bold" :class="{ 'bb': !hidableRows.basement_layout || !hidableRows.tpm_flat_mount }">
                                    <label> Machine Shape </label>
                                </div>
                                <div :hidden="hidableRows.basement_layout" class="bl text-bold" :class="{ 'bb': !hidableRows.tpm_flat_mount }">
                                    <label class="ilbot"> Basement Machine Room Layout <ses-tooltip type="illu-B4"></ses-tooltip>:</label>
                                </div>
                                <div :hidden="hidableRows.tpm_flat_mount" class="bl text-bold">
                                    <label> Is the Pancake Installed Flat </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div :hidden="hidableRows.machine_shape" class="proj-s1"><label> Machine Shape <small>(MRL Only)</small></label></div>
                    <div :hidden="hidableRows.basement_layout" class="proj-s1 siw"><label class="ilbot"> Basement Machine Room Layout <ses-tooltip type="illu-B4"></ses-tooltip></label></div>
                    <div :hidden="hidableRows.tpm_flat_mount" class="proj-s1"><label> Is the Pancake Installed Flat </label></div> -->
                    <div class="proj-s1"><label> Rope Diameter Size <small>(use for reference only)</small></label></div>
                    <div class="proj-s1"><label> Will New Rope Diameter Need to Match Existing? </label></div>
                    <div class="proj-s1"><label> Drive Output Voltage </label></div>
                    <div class="proj-s1"><label> Drive Manufacturer <a :title="`Required for drive compatibility, Yaskawa/Magnetek and KEB have identical pricing for reference quotes. Must be verified before ordering.`" style="font-size:11px;"><span class="bg-diamond"><i>(?)</i></span></a></label></div>
                    <div :hidden="hidableRows.encoder_cable" class="proj-s1"><label> Encoder Cable Length </label></div>

                    <div class="proj-s1 proj-h2"><label> <h2>System Options</h2></label></div>
                    <div class="proj-s1"><label> Empty Car Weight <small>(lb)</small> </label></div>
                    <div class="proj-s1"><label> Preferred Counterweight <small>(%)</small> </label></div>
                    <div class="proj-s1 proj-r3 no-pt no-pl">
                        <div class="proj-split-lbl">
                            <div class="">
                                <label>
                                    Emergency Brake Option
                                </label>
                            </div>
                            <div class="split-left-align">
                                <div class="bb bl" style="padding-top:1px;">
                                    <label>TDNA Standard</label>
                                </div>
                                <div class="bb bl">
                                    <label>HW Rope Gripper</label>
                                </div>
                                <!-- <div class="bl">
                                    <label>TDNA Rope Brake</label>
                                </div> -->
                            </div>
                        </div>
                    </div>

                    <div class="proj-s1"><label> {{ strExt() }} Compensation Density <small>(lbs/ft)</small> </label></div>
                    <div :hidden="hidableRows.weight_comp_sheave" class="proj-s1"><label> Weight of {{ strExt() }} Compensation Sheave <small>(lb) (Enter 0, if no comp sheave)</small> </label></div>
                    <div class="proj-s1"><label> Double Wrap Roping Required? </label></div>
                    <div class="proj-s1"><label> Acceleration Rate <small>(ft/s2)</small> </label></div>
                    <div class="proj-s1 proj-r5 no-pt no-pl s1-end">
                        <div class="proj-split-lbl">
                            <div class="">
                                <label>
                                    Items to Quote:
                                </label>
                            </div>
                            <div class="split-left-align">
                                <div class="bb bl">
                                    <label>Machine</label>
                                </div>
                                <div class="bb bl">
                                    <label>Bedplate</label>
                                </div>
                                <div class="bb bl">
                                    <label>Rope Guard</label>
                                </div>
                                <div class="bb bl">
                                    <label>Deflector</label>
                                </div>
                                <div class=" bl">
                                    <label>Encoder Cable</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="proj-section1 proj-group" v-if="step == 'yes'">
                </div>
                <div class="proj-section2 proj-group" v-if="model.project.is_final == 'yes'">
                    <div class="proj-s2 proj-h2"><label> <h2>SECTION #2 - For Drawings</h2> </label></div>
                    <div class="proj-s2 proj-h2 proj-h2-field">
                        <label> {{ lead_stw }}-Week Lead Time Option Preferred? <a title="Stock machine can be more expensive than regular machine."><span class="bg-diamond"><i>!</i></span></a></label>
                        <input type="text" :value="model.project.use_stock" readonly class="text-center capitalize">
                    </div>
                    <div class="proj-s2 proj-h2 proj-h2-field">
                        <label> Estimated Project Start Date <a :title="'Earliest ship date is today plus '+lead_stw+' weeks.'" style="font-size:15px;"><span class="bg-diamond"><i>?</i></span></a></label>
                        <input type="text" :value="model.project.start_date" readonly class="text-center">
                    </div>
                    <div :hidden="hidableRows.right_left_machine" class="proj-s2 siw"><label> Right or Left Hand Machine? <ses-tooltip type="illu-1"></ses-tooltip></label></div>
                    <div class="proj-s1"><label> If compensation is required, do you prefer 1 or 2 chains? </label></div>
                    <div :hidden="hidableRows.onsite_assembly" class="proj-s2"><label> On-Site Reassembly Service<br><small>(Only Available for Large Gearless TGL Machines)</small></label></div>
                    <!-- <div class="proj-s2 siw"><label> Number of Floors above Lobby</label></div> -->
                    <div :hidden="hidableRows.rope_drop_distance" class="proj-s2 siw"><label> Rope Drop Distance <small>(in)</small> <ses-tooltip type="illu-2"></ses-tooltip></label></div>
                    <div :hidden="hidableRows.rope_to_machine_wall" class="proj-s2 siw"><label> Rope to Machine Room Wall (in) <ses-tooltip type="illu-2"></ses-tooltip></label></div>
                    <div :hidden="hidableRows.machine_room_height_clearance" class="proj-s2 siw"><label> Machine Room Height Clearance (in) <ses-tooltip type="illu-2"></ses-tooltip></label></div>
                    <div :hidden="hidableRows.existing_machine_beam_location" class="proj-s2 siw"><label> {{ strExt() }} Machine Beam Location <ses-tooltip type="illu-3" align="top"></ses-tooltip></label></div>
                    <div :hidden="hidableRows.ct" class="proj-s2 siw"><label> CT - Concrete Slab Thickness <small>(in) </small> <ses-tooltip type="illu-3" align="top"></ses-tooltip></label></div>
                    <div :hidden="hidableRows.wf_beam_width" class="proj-s2 siw"><label> Wf - Beam Width (in) <ses-tooltip type="illu-3"></ses-tooltip></label></div>
                    <div :hidden="hidableRows.ww_beam_height" class="proj-s2 siw"><label> Ww - Beam Height (in) <ses-tooltip type="illu-3"></ses-tooltip></label></div>
                    <div :hidden="hidableRows.z1" class="proj-s2 siw"><label> Z1 (in) <ses-tooltip type="illu-2"></ses-tooltip></label></div>
                    <div :hidden="hidableRows.z2" class="proj-s2 siw"><label> Z2 (in) <ses-tooltip type="illu-2"></ses-tooltip></label></div>
                    <div :hidden="hidableRows.deflector_in_overhead && (!showPadsOnFloors || hidableRows.pads_on_floors)" class="proj-s2 proj-h2"><label> <h2>Special Bedplate Configurations (Optional)</h2> </label></div>
                    <div v-if="showPadsOnFloors" :hidden="hidableRows.pads_on_floors" class="proj-s2"><label> Isolation on Floor Option </label></div>
                    <div :hidden="hidableRows.deflector_in_overhead" class="proj-s2"><label> Prefer Deflector Mounted Below Slab <ses-tooltip type="illu-def-slab" align="top"></ses-tooltip></label></div>
                    <template v-if="model.project.phase=='modernization'">
                        <div :hidden="hidableRows.existing_deflector_sheave" class="proj-s2"><label> Keep Existing Deflector or Replace with New? </label></div>
                        <div :hidden="hidableRows.deflector_sheave_diameter || hidableRows.deflector_sheave_diameter || hidableRows.number_of_ropes || hidableRows.groove_pitch || hidableRows.ys" class="proj-s2"><label> If retaining Deflector: </label></div>
                        <div :hidden="hidableRows.deflector_sheave_diameter" class="proj-s2"><label> <i class="ind"></i>Ddef - Deflector Sheave Diameter (in) </label></div>
                        <div :hidden="hidableRows.number_of_ropes" class="proj-s2"><label> <i class="ind"></i>Number of Existing Deflector Grooves </label></div>
                        <div :hidden="hidableRows.groove_pitch" class="proj-s2"><label> <i class="ind"></i>Groove Pitch (Center of rope to rope) (in) </label></div>
                        <div :hidden="hidableRows.ys" class="proj-s2 siw"><label class="ilbot"> <i class="ind"></i>Ys - Bottom of Slab to Deflector Centerline (in) <ses-tooltip type="illu-3" align="top"></ses-tooltip></label></div>
                    </template>
                    <div :hidden="hidableRows.angled_bedplate" class="proj-s2"><label> Rope Drop Square to the Wall </label></div>
                    <div :hidden="hidableRows.angle_profile" class="proj-s2"><label> <i class="ind"></i>Angle Profile (A, B, C or D)</label></div>
                    <div :hidden="hidableRows.car_rope_x1" class="proj-s2"><label> <i class="ind"></i>X1 - Car Rope to Wall</label></div>
                    <div :hidden="hidableRows.car_rope_x2" class="proj-s2"><label> <i class="ind"></i>X2 - Car Rope to Wall - <small>(Perpendicular) (in)</small></label></div>
                    <div :hidden="hidableRows.car_rope_x3" class="proj-s2"><label> <i class="ind"></i>X3 - Car Rope to Wall 2 - <small>(Perpendicular) (in)</small></label></div>

                    <template v-if="model.project.phase=='modernization'">
                        <div :hidden="hidableRows.basement_config" class="proj-s2 proj-h2"><label><h2>Basement Inputs</h2></label></div>
                        <div :hidden="hidableRows.basement_config" class="proj-s2"><label> Basement Configuration <ses-tooltip type="illu-B4"></ses-tooltip></label></div>
                        <div :hidden="hidableRows.basement_pattern" class="proj-s2"><label> Existing Machine / Anchor Pattern</label></div>
                        <div :hidden="hidableRows.basement_anchor" class="proj-s2"><label> Anchor Bolt Height Above Floor</label></div>
                        <div :hidden="hidableRows.basement_thread" class="proj-s2"><label> Thread Length of Anchor Bolts</label></div>
                        <div :hidden="hidableRows.basement_sheave_diameter" class="proj-s2"><label> Existing Sheave Diameter</label></div>
                        <div :hidden="hidableRows.basement_rope_diameter" class="proj-s2"><label> Existing Rope Diameter</label></div>
                        <div :hidden="hidableRows.basement_rope_number" class="proj-s2"><label> Existing Rope Number</label></div>
                        <div :hidden="hidableRows.basement_pitch" class="proj-s2"><label> Existing Pitch</label></div>

                        <div :hidden="hidableRows.basement_mr1" class="proj-s2 proj-h2"><label> <h2>Basement A Configuration Inputs</h2></label></div>
                        <div :hidden="hidableRows.basement_mr1" class="proj-s2"><label> MR1 </label></div>
                        <div :hidden="hidableRows.basement_mr1" class="proj-s2"><label> MR2 </label></div>
                        <div :hidden="hidableRows.basement_mr1" class="proj-s2"><label> MR3 </label></div>
                        <div :hidden="hidableRows.basement_mr1" class="proj-s2"><label> MR4 </label></div>

                        <div :hidden="hidableRows.basement_mr1b" class="proj-s2 proj-h2"><label> <h2>Basement B Configuration Inputs</h2></label></div>
                        <div :hidden="hidableRows.basement_mr1b" class="proj-s2"><label> MR1 </label></div>
                        <div :hidden="hidableRows.basement_mr1b" class="proj-s2"><label> MR2 </label></div>
                        <div :hidden="hidableRows.basement_mr1b" class="proj-s2"><label> MR3 </label></div>
                        <div :hidden="hidableRows.basement_mr1b" class="proj-s2"><label> DF1 </label></div>
                        <div :hidden="hidableRows.basement_mr1b" class="proj-s2"><label> DF2 </label></div>
                        <div :hidden="hidableRows.basement_mr1b" class="proj-s2"><label> RD </label></div>

                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2 proj-h2"><label> <h2>Basement C Configuration Inputs</h2></label></div>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2"><label> MR1 </label></div>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2"><label> MR2 </label></div>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2"><label> MR3 </label></div>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2"><label> DF1 </label></div>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2"><label> DF2 </label></div>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2"><label> DF3 </label></div>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2"><label> DF4 </label></div>
                    </template>
                </div>
            </div>

            <div class="proj-cars"><div class="proj-car" v-for="(car,cn) in model.cars" :key="cn">
                <div class="proj-section1 proj-group">
                    <div class="proj-nn">{{ car.car_id_number }}</div>
                    <div class="proj-s1">{{ car.gear == 'TRUE' ? 'Geared' : 'Gearless' }}</div>
                    <div class="proj-s1">{{ car.machine_location }}</div>
                    <div class="proj-s1">{{ car.roping }} to 1</div>
                    <div class="proj-s1">{{ car.capacity }}</div>
                    <div class="proj-s1">{{ car.speed }}</div>
                    <div class="proj-s1">{{ car.travel }}</div>
                    <div :hidden="hidableRows.machine_shape" class="proj-s1">{{ car.machine_shape }}</div>
                    <div :hidden="hidableRows.basement_layout" class="proj-s1">{{ car.basement_layout }}</div>
                    <div :hidden="hidableRows.tpm_flat_mount" class="proj-s1">{{ car.tpm_flat_mount == '100' ? 'Yes' : 'No' }}</div>
                    <div class="proj-s1">
                        {{ car.rope_diameter }}
                    </div>
                    <!-- <div class="proj-s1 check-input">
                        <label class="default-label-mt" :class="{ 'prdr-label': ('rope_diameter' in car && car.rope_diameter !== '') }">
                            <input
                                :checked="car.rope_diameter_required === 'Y'"
                                disabled
                                type="checkbox">
                            <span>Required</span>
                        </label>
                    </div> -->
                    <div class="proj-s1">
                        {{ (car.rope_diameter_required == 'Y') ? 'Yes' : ((car.rope_diameter_required == 'N') ? 'No' : '') }}
                    </div>
                    <div class="proj-s1">
                        {{ car.vac }}
                    </div>
                    <div class="proj-s1">
                        {{ car.drive_manufacturer }}
                    </div>
                    <div :hidden="hidableRows.encoder_cable" class="proj-s1">
                        {{ car.encoder_cable }}
                    </div>
                    <div class="proj-s1 proj-h2"><label> <h2>System Options</h2> </label></div>
                    <div class="proj-s1">{{ car.empty_car_weight }}</div>
                    <div class="proj-s1">{{ car.counterweight }}</div>

                    <!-- brake -->
                    <div class="proj-s1 j-center check-input"><label class="mbt-3"><input type="checkbox" :checked="car.tdi_emergency_brake == 'TRUE'" disabled>&nbsp;</label></div>
                    <div class="proj-s1 j-center check-input" style="height: 55px;">
                        <div class="proj-split">
                            <div class="">
                                <label class="proj-chk mbt-3"><input type="checkbox" disabled :checked="car.hw_rope_gripper == 'TRUE'">&nbsp;</label>
                                <div style="clear:both;border-top:1px solid black;"></div>
                                <label class="proj-chk mbt-3"><input type="checkbox" disabled :checked="car.ses_rope_brake == 'TRUE'">&nbsp;</label>
                            </div>
                            <div style="height: 55px;width: 40% !important;padding-top: 7%;border-left:1px solid black;">{{ car.hw_rope_gripper_model }}</div>
                        </div>
                    </div>
                    <!-- brake -->

                    <div class="proj-s1">{{ car.compensation }}</div>
                    <div :hidden="hidableRows.weight_comp_sheave" class="proj-s1">{{ car.weight_comp_sheave }}</div>
                    <div class="proj-s1">{{ (car.double_wrap == 'TRUE') ? 'Yes' : (car.double_wrap == 'FALSE') ? 'No' : '' }}</div>
                    <div class="proj-s1">{{ car.acceleration }}</div>
                    <div class="proj-s1 j-center check-input"><label><input type="checkbox" checked disabled></label></div>
                    <div class="proj-s1 j-center check-input"><label><input type="checkbox" :checked="car.bedplate == 'TRUE'" disabled></label></div>
                    <div class="proj-s1 j-center check-input"><label><input type="checkbox" :checked="car.rope_guard == 'TRUE'" disabled></label></div>
                    <div class="proj-s1 j-center check-input"><label><input type="checkbox" :checked="car.deflector == 'TRUE'" disabled></label></div>
                    <div class="proj-s1 j-center s1-end check-input"><label><input type="checkbox" :checked="car.encoder == 'TRUE'" disabled></label></div>
                </div>

                <div class="proj-section2 proj-group" v-if="model.project.is_final == 'yes'">
                    <div class="proj-s2"></div>
                    <div class="proj-s2"></div>
                    <div class="proj-s2"></div>
                    <div :hidden="hidableRows.right_left_machine" class="proj-s2">{{ car.right_left_machine }}</div>
                    <div class="proj-s1">{{ car.chains }}</div>
                    <div :hidden="hidableRows.onsite_assembly" class="proj-s2">{{ car.onsite_assembly }}</div>
                    <!-- <div class="proj-s2">{{ car.no_of_floors }}</div> -->
                    <div :hidden="hidableRows.rope_drop_distance" class="proj-s2">{{ car.rope_drop_distance }}</div>
                    <div :hidden="hidableRows.rope_to_machine_wall" class="proj-s2">{{ car.rope_to_machine_wall }}</div>
                    <div :hidden="hidableRows.machine_room_height_clearance" class="proj-s2">{{ car.machine_room_height_clearance }}</div>

                    <div :hidden="hidableRows.existing_machine_beam_location" class="proj-s2">{{ car.existing_machine_beam_location }}</div>
                    <div :hidden="hidableRows.ct" class="proj-s2">{{ car.ct }}</div>
                    <div :hidden="hidableRows.wf_beam_width" class="proj-s2">{{ car.wf_beam_width }}</div>
                    <div :hidden="hidableRows.ww_beam_height" class="proj-s2">{{ car.ww_beam_height }}</div>
                    <div :hidden="hidableRows.z1" class="proj-s2">{{ car.z1 }}</div>
                    <div :hidden="hidableRows.z2" class="proj-s2">{{ car.z2 }}</div>
                    <div :hidden="hidableRows.deflector_in_overhead && (!showPadsOnFloors || hidableRows.pads_on_floors)" class="proj-s2"></div>
                    <div v-if="showPadsOnFloors" :hidden="hidableRows.pads_on_floors" class="proj-s2 pads-on-floors pf-review">
                        <label class="mbt-3"><input type="checkbox" :checked="car.pads_on_floors == 'TRUE'" disabled></label>
                    </div>
                    <div :hidden="hidableRows.deflector_in_overhead" class="proj-s2 capitalize">{{ car.deflector_in_overhead }}</div>
                    <template v-if="model.project.phase=='modernization'">
                        <!-- for new dflector in overhead -->
                        <div :hidden="hidableRows.existing_deflector_sheave" class="proj-s2 capitalize">{{ (car.existing_deflector_sheave == 'NO') ? 'Replace Deflector' : (car.existing_deflector_sheave == 'YES') ? 'Retain Deflector' : '' }}</div>
                        <div :hidden="hidableRows.deflector_sheave_diameter || hidableRows.deflector_sheave_diameter || hidableRows.number_of_ropes || hidableRows.groove_pitch || hidableRows.ys" class="proj-s2"></div>
                        <div :hidden="hidableRows.deflector_sheave_diameter" class="proj-s2">{{ car.deflector_sheave_diameter }}</div>
                        <div :hidden="hidableRows.number_of_ropes" class="proj-s2">{{ car.number_of_ropes }}</div>
                        <div :hidden="hidableRows.groove_pitch" class="proj-s2">{{ car.groove_pitch }}</div>
                        <div :hidden="hidableRows.ys" class="proj-s2">{{ car.ys }}</div>
                    </template>

                    <div :hidden="hidableRows.angled_bedplate" class="proj-s2">{{ car.angled_bedplate }}</div>
                    <div :hidden="hidableRows.angle_profile" class="proj-s2">{{ car.angle_profile }}</div>
                    <div :hidden="hidableRows.car_rope_x1" class="proj-s2">{{ car.car_rope_x1 }}</div>
                    <div :hidden="hidableRows.car_rope_x2" class="proj-s2">{{ car.car_rope_x2 }}</div>
                    <div :hidden="hidableRows.car_rope_x3" class="proj-s2">{{ car.car_rope_x3 }}</div>

                    <template v-if="model.project.phase=='modernization'">
                        <div :hidden="hidableRows.basement_config" class="proj-s2"></div>
                        <div :hidden="hidableRows.basement_config" class="proj-s2">{{ car.basement_config }}</div>
                        <div :hidden="hidableRows.basement_pattern" class="proj-s2">{{ car.basement_pattern }}</div>
                        <div :hidden="hidableRows.basement_anchor" class="proj-s2">{{ car.basement_anchor }}</div>
                        <div :hidden="hidableRows.basement_thread" class="proj-s2">{{ car.basement_thread }}</div>
                        <div :hidden="hidableRows.basement_sheave_diameter" class="proj-s2">{{ car.basement_sheave_diameter }}</div>
                        <div :hidden="hidableRows.basement_rope_diameter" class="proj-s2">{{ car.basement_rope_diameter }}</div>
                        <div :hidden="hidableRows.basement_rope_number" class="proj-s2">{{ car.basement_rope_number }}</div>
                        <div :hidden="hidableRows.basement_pitch" class="proj-s2">{{ car.basement_pitch }}</div>

                        <div :hidden="hidableRows.basement_mr1" class="proj-s2"></div>
                        <div :hidden="hidableRows.basement_mr1" class="proj-s2">{{ car.basement_config == 'A' ? car.basement_mr1 : '' }}</div>
                        <div :hidden="hidableRows.basement_mr1" class="proj-s2">{{ car.basement_config == 'A' ? car.basement_mr2 : '' }}</div>
                        <div :hidden="hidableRows.basement_mr1" class="proj-s2">{{ car.basement_config == 'A' ? car.basement_mr3 : '' }}</div>
                        <div :hidden="hidableRows.basement_mr1" class="proj-s2">{{ car.basement_config == 'A' ? car.basement_mr4 : '' }}</div>
                        
                        <div :hidden="hidableRows.basement_mr1b" class="proj-s2"></div>
                        <div :hidden="hidableRows.basement_mr1b" class="proj-s2">{{ car.basement_config == 'B' ? car.basement_mr1 : '' }}</div>
                        <div :hidden="hidableRows.basement_mr1b" class="proj-s2">{{ car.basement_config == 'B' ? car.basement_mr2 : '' }}</div>
                        <div :hidden="hidableRows.basement_mr1b" class="proj-s2">{{ car.basement_config == 'B' ? car.basement_mr3 : '' }}</div>
                        <div :hidden="hidableRows.basement_mr1b" class="proj-s2">{{ car.basement_config == 'B' ? car.basement_df1 : '' }}</div>
                        <div :hidden="hidableRows.basement_mr1b" class="proj-s2">{{ car.basement_config == 'B' ? car.basement_df2 : '' }}</div>
                        <div :hidden="hidableRows.basement_mr1b" class="proj-s2">{{ car.basement_config == 'B' ? car.basement_rd : '' }}</div>
                        
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2"></div>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2">{{ car.basement_config == 'C' ? car.basement_mr1 : '' }}</div>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2">{{ car.basement_config == 'C' ? car.basement_mr2 : '' }}</div>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2">{{ car.basement_config == 'C' ? car.basement_mr3 : '' }}</div>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2">{{ car.basement_config == 'C' ? car.basement_df1 : '' }}</div>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2">{{ car.basement_config == 'C' ? car.basement_df2 : '' }}</div>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2">{{ car.basement_config == 'C' ? car.basement_df3 : '' }}</div>
                        <div :hidden="hidableRows.basement_mr1c" class="proj-s2">{{ car.basement_config == 'C' ? car.basement_df4 : '' }}</div>
                    </template>
                </div>
            </div></div>
            </div>
        </section>

        <h2 class="proj-s1 text-left" v-if="steps.controller">Controller</h2>
        <section class="project-section" v-if="steps.controller">
            <div class="proj-labels">
                <div class="proj-section1 proj-group">
                    <div class="proj-ds"><label> Car ID Number</label></div>
                    <div class="proj-ds"><label> Speed</label></div>
                    <div class="proj-ds"><label> Capacity</label></div>
                    <div class="proj-ds"><label> Machine Location</label></div>

                    <div class="proj-cc proj-h3"><label> <strong>Hoist Motor</strong></label></div>
                    <div class="proj-ds"><label> Geared or Gearless</label></div>
                    <div class="proj-ds"><label> Motor Voltage (App/Rated)</label></div>
                    <div class="proj-ds"><label> Motor RPM (App/Rated)</label></div>
                    <div class="proj-ds"><label> Motor Freq (App/Rated)</label></div>
                    <div class="proj-ds"><label> Motor Power (App/Rated)</label></div>
                    <div class="proj-ds"><label> FL Current (App/Rated)</label></div>
                    <div class="proj-ds"><label> Accel Current (App/Rated)</label></div>

                    <div class="proj-cc proj-h3"><label> <strong>Brake</strong></label></div>
                    <div class="proj-ds"><label> Pick/Hold Voltage</label></div>
                    <div class="proj-ds"><label> Coil Resistance</label></div>

                    <div class="proj-cc proj-h3"><label> <strong>EBrake</strong></label></div>
                    <div class="proj-ds"><label> Pick/Hold Voltage</label></div>
                    <div class="proj-ds"><label> Coil Resistance</label></div>

                    <div class="proj-cc proj-h3"><label> <strong>Rope Gripper or Rope Brake</strong></label></div>
                    <div class="proj-cc"><label> Mfg</label></div>
                    <div class="proj-cc"><label> Voltage</label></div>

                    <div class="proj-cc proj-h3"><label> <strong>Frequency Drive</strong></label></div>
                    <div class="proj-cc"><label> Drive Manufacturer</label></div>
                    <div class="proj-cc"><label> Encoder</label></div>
                    <div class="proj-cc"><label> Regen Drive</label></div>

                    <div class="proj-cc proj-h3"><label> <strong>General Information</strong></label></div>
                    <div class="proj-cc"><label> # of Floors </label></div>
                    <div class="proj-cc"><label> # of Opening </label></div>
                    <div class="proj-cc"><label> Floor Lock-outs </label></div>
                    <div class="proj-cc"><label> Operation </label></div>
                    <div class="proj-cc"><label> Measure AC Line <small>(VAC,3ph)</small> </label></div>
                    <div class="proj-cc"><label> Door Type </label></div>

                    <div class="proj-cc proj-h2"><label> <h2>FEATURES</h2></label></div>
                    <div class="proj-cc"><label> <strong>PI Driver</strong></label></div>
                    <div class="proj-cc"><label> <strong>Controller A/C unit </strong></label></div>
                    <div class="proj-cc"><label> <i class="ind"></i>Material of A/C</label></div>
                    <div class="proj-cc"><label> <strong>UPS lowering </strong></label></div>
                    <div class="proj-cc"><label> <strong>Controller Stand</strong> <small>(Note: * Height is 22")</small></label></div>

                    <div class="proj-cc proj-h3"><label> <strong>Load Weigher *</strong></label></div>
                    <div class="proj-cc"><label> <i class="ind"></i>Load Weighing or Not </label></div>
                    <div class="proj-cc"><label> <i class="ind"></i>Rope or Cross Beam</label></div>
                    <div class="proj-cc"><label> <i class="ind"></i># of Ropes</label></div>
                    <div class="proj-cc"><label> <i class="ind"></i>Rope Size</label></div>

                    <div class="proj-cc"><label> Floor Information</label></div>
                    <div class="proj-cc"><label> Access Top & Bottom</label></div>
                    <div class="proj-cc"><label> Collective</label></div>
                    <div class="proj-cc"><label> Travel <small>(ft)</small></label></div>

                    <div class="proj-cc proj-h3"><label> <strong>Door Operation</strong></label></div>
                    <div class="proj-cc"><label> Retiring Cam Type</label></div>
                    <div class="proj-cc"><label> <i class="ind"></i>Electrical Cam Voltage Type</label></div>
                    <div class="proj-cc"><label> <i class="ind"></i>Electrical Cam Voltage</label></div>
                    <div class="proj-cc"><label> Door Operator Manufacturer </label></div>
                    <div class="proj-cc"><label> Door Motor Model </label></div>
                    <div class="proj-cc"><label> Door Motor Supply AC/DC</label></div>
                    <div class="proj-cc"><label> Door Motor Supply <small>(Voltage)</small></label></div>
                    <div class="proj-cc"><label> Door Motor Supply Phase</label></div>
                    <div class="proj-cc proj-h3"><label><strong>Car and Hall Fixtures <small>(Note: All fixtures must be 24VDC)</small></strong></label></div>
                    <div class="proj-cc"><label> Hall Lanterns</label></div>
                    <div class="proj-cc proj-h3"><label> <strong>Serial Communication</strong></label></div>
                    <div class="proj-cc"><label> Serial Car Station</label></div>
                    <div class="proj-cc"><label> Serial Hall Station</label></div>
                </div>
            </div>

            <div class="proj-cars"><div class="proj-car" v-for="(car,cn) in model.cars" :key="cn">
                <div class="proj-section1 proj-group">
                    <div class="proj-ds">{{ car.car_id_number }}</div>
                    <div class="proj-ds">{{ car.speed }}</div>
                    <div class="proj-ds">{{ car.capacity }}</div>
                    <div class="proj-ds">{{ car.machine_location }}</div>

                    <div class="proj-cc"></div>
                    <div class="proj-cc">{{ car.gear == 'TRUE' ? 'Geared' : 'Gearless' }}</div>
                    <div class="proj-cc">{{ car.controller.motor_rated_voltage }}</div>
                    <div class="proj-cc">{{ car.controller.motor_rpm_app_rated }}</div>
                    <div class="proj-cc">{{ car.controller.motor_frequency_app_rated }}</div>
                    <div class="proj-cc">{{ car.controller.motor_power_app_rated }}</div>
                    <div class="proj-cc">{{ car.controller.fl_current_app_rated }}</div>
                    <div class="proj-cc">{{ car.controller.accel_current_app_rated }}</div>

                    <div class="proj-cc"></div>
                    <div class="proj-cc">{{ car.controller.pick_hold_voltage }}</div>
                    <div class="proj-cc">{{ car.controller.coil_resistance }}</div>

                    <div class="proj-cc"></div>
                    <div class="proj-cc">{{ car.controller.em_pick_hold_voltage }}</div>
                    <div class="proj-cc">{{ car.controller.em_coil_resistance }}</div>

                    <div class="proj-cc"></div>
                    <div class="proj-cc">{{ car.controller.rp_mfg }}</div>
                    <div class="proj-cc">{{ car.controller.rp_voltage }}</div>

                    <div class="proj-cc"></div>
                    <div class="proj-cc">{{ car.drive_manufacturer }}</div>
                    <div class="proj-cc">Yes</div>
                    <div class="proj-cc">{{ car.controller.freq_regen }}</div>

                    <div class="proj-cc"></div>
                    <div class="proj-cc">{{ car.controller.no_of_floors }}</div>
                    <div class="proj-cc">{{ car.controller.no_of_openings }}</div>
                    <div class="proj-cc">{{ car.controller.floor_lockout }}</div>
                    <div class="proj-cc">{{ car.controller.operation }}</div>
                    <div class="proj-cc">{{ car.controller.ac_line }}</div>
                    <div class="proj-cc">{{ car.controller.door_type }}</div>

                    <div class="proj-cc"></div>
                    <div class="proj-cc">{{ car.controller.pi_driver }}</div>

                    <div class="proj-cc">{{ car.controller.controller_ac }}</div>
                    <div class="proj-cc">{{ car.controller.controller_ac_material }}</div>
                    <div class="proj-cc">{{ car.controller.ups_lowering }}</div>
                    <div class="proj-cc">{{ car.controller.controller_stand }}</div>

                    <div class="proj-cc"></div>
                    <div class="proj-cc">{{ car.controller.load_weigher }}</div>
                    <div class="proj-cc">{{ car.controller.rope_cross_beam }}</div>
                    <div class="proj-cc">{{ car.controller.number_of_ropes }}</div>
                    <div class="proj-cc">{{ car.controller.rope_size }}</div>

                    <div class="proj-cc"></div>
                    <div class="proj-cc">{{ car.controller.access }}</div>
                    <div class="proj-cc">{{ car.controller.collective }}</div>
                    <div class="proj-cc">{{ car.controller.total_travel }}</div>

                    <div class="proj-cc"></div>
                    <div class="proj-cc">{{ car.controller.door_cam_type }}</div>
                    <div class="proj-cc">{{ car.controller.door_cam_volt_type }}</div>
                    <div class="proj-cc">{{ car.controller.door_cam_voltage }}</div>
                    <div class="proj-cc">{{ car.controller.door_op_mfg }}</div>
                    <div class="proj-cc">{{ car.controller.door_motor_model }}</div>
                    <div class="proj-cc">{{ car.controller.door_motor_supp_acdc }}</div>
                    <div class="proj-cc">{{ car.controller.door_motor_supp_volt }}</div>
                    <div class="proj-cc">{{ car.controller.door_motor_supp_phase }}</div>

                    <div class="proj-cc"></div>
                    <div class="proj-cc">{{ car.controller.door_lantern }}</div>

                    <div class="proj-cc"></div>
                    <div class="proj-cc">{{ car.controller.serial_car }}</div>
                    <div class="proj-cc">{{ car.controller.serial_hall }}</div>
                </div>
            </div></div>
        </section>

        <h2 class="proj-s1 text-left" v-if="steps.door_system">Door System</h2>
        <section class="project-section" v-if="steps.door_system">
            <div class="proj-labels">
                <div class="proj-section1 proj-group">

                    <div class="proj-cc proj-h3"><label> <strong>Basic Information</strong></label></div>
                    <div class="proj-cc proj-r4"><label> Products Required</label></div>
                    <!-- <div class="proj-cc"><label> Number of Floors</label></div> -->
                    <div class="proj-ds"><label> Car ID Number</label></div>

                    <div class="proj-cc proj-h3"><label> <strong>ENTRANCE SPEC</strong></label></div>
                    <div class="proj-cc"><label> Front Opening  Width <small>(in) <ses-tooltip type="illu-ds3"></ses-tooltip> A2</small></label></div>
                    <div class="proj-cc"><label> Front Opening  Height <small>(in) <ses-tooltip type="illu-ds3"></ses-tooltip> A2</small></label></div>
                    <div class="proj-cc"><label> Front Hoistway Width <small>(in) <ses-tooltip type="illu-ds3"></ses-tooltip> A3</small></label></div>
                    <div class="proj-cc"><label> Rear/Side Opening Width <small>(in) <ses-tooltip type="illu-ds3"></ses-tooltip> A5</small></label></div>
                    <div class="proj-cc"><label> Rear/Side Opening Height <small>(in) <ses-tooltip type="illu-ds3"></ses-tooltip> A5</small></label></div>
                    <div class="proj-cc"><label> Rear/Side Hoistway Width <small>(in) <ses-tooltip type="illu-ds3"></ses-tooltip> A6</small></label></div>
                    <div class="proj-cc"><label> Entrance Sill Finish </label></div>
                    <div class="proj-cc"><label> Landing Door Access Keyhole Required </label></div>

                    <div class="proj-cc"><label> Car Sill Centerline to Transom <small>(in)</small> - <ses-tooltip type="illu-ds6" align="top"></ses-tooltip> B1</label></div>
                    <div class="proj-cc"><label> Car Sill Centerline to Sill Edge <small>(in)</small> - <ses-tooltip type="illu-ds6" align="top"></ses-tooltip> B2</label></div>
                    <div class="proj-cc"><label> Running Clearance <small>(in)</small> - <ses-tooltip type="illu-ds6" align="top"></ses-tooltip> B3</label></div>
                    <div class="proj-cc"><label> Car Sill Centerline to Hatch Wall <small>(in)</small> - <ses-tooltip type="illu-ds6" align="top"></ses-tooltip> B4</label></div>
                    <div class="proj-cc"><label> Combined Door Weight <small>(lbs)</small></label></div>
                    <div class="proj-cc"><label> Entrance Manufacturer</label></div>

                    <div class="proj-cc proj-h3"><label> <strong>FLOOR TO FLOOR DETAIL</strong></label></div>
                    <div class="proj-cc"><label> Floor Information</label></div>

                    <div class="proj-cc proj-h3"><label> <strong>DOOR OPERATOR & LANDING EQUIPMENT SPEC</strong></label></div>
                    <div class="proj-cc"><label> Supply Voltage (VAC)</label></div>
                    <div class="proj-cc"><label> Front Entrance - Landing Equipment Qty</label></div>
                    <div class="proj-cc"><label> Front Entrance - Width (in)</label></div>
                    <div class="proj-cc"><label> Front Entrance - Speed</label></div>
                    <div class="proj-cc"><label> Front Entrance - Left, Right or Center Opening</label></div>
                    <div class="proj-cc"><label> Rear/Side Entrance - Landing Equipment Qty</label></div>
                    <div class="proj-cc"><label> Rear/Side Entrance - Width (in)</label></div>
                    <div class="proj-cc"><label> Rear/Side Entrance - Speed</label></div>
                    <div class="proj-cc"><label> Rear/Side Entrance - Left, Right or Center Opening</label></div>

                </div>
            </div>

            <div class="proj-cars"><div class="proj-car" v-for="(car,cn) in model.cars" :key="cn">
                <div class="proj-section1 proj-group">

                    <div class="proj-cc"></div>
                    <div class="proj-cc"><label><input type="checkbox" :checked="car.door_system.entrance == 'TRUE'" disabled> Entrance</label></div>
                    <div class="proj-cc"><label><input type="checkbox" :checked="car.door_system.landing == 'TRUE'" disabled> Landing Equipment</label></div>
                    <div class="proj-cc"><label><input type="checkbox" :checked="car.door_system.door_op == 'TRUE'" disabled> Door Operator</label></div>
                    <div class="proj-cc"><label><input type="checkbox" :checked="car.door_system.light_curtain == 'TRUE'" disabled> Light Curtain</label></div>
                    <div class="proj-cc">{{ car.door_system.no_of_floors }}</div>
                    <div class="proj-cc">{{ car.car_id_number }}</div>

                    <div class="proj-cc"></div>
                    <div class="proj-cc">{{ car.door_system.entrance_fr_opening_w }}</div>
                    <div class="proj-cc">{{ car.door_system.entrance_fr_opening_h }}</div>
                    <div class="proj-cc">{{ car.door_system.entrance_fr_hoistway_w }}</div>
                    <div class="proj-cc">{{ car.door_system.entrance_rear_opening_w }}</div>
                    <div class="proj-cc">{{ car.door_system.entrance_rear_opening_h }}</div>
                    <div class="proj-cc">{{ car.door_system.entrance_rear_hoistway_w }}</div>
                    <div class="proj-cc">{{ car.door_system.entrance_sill_finish }}</div>
                    <div class="proj-cc">{{ car.door_system.entrance_keyhole }}</div>

                    <div class="proj-cc">{{ car.door_system.centerline_to_transom }}</div>
                    <div class="proj-cc">{{ car.door_system.centerline_to_edge }}</div>
                    <div class="proj-cc">{{ car.door_system.running_clearance }}</div>
                    <div class="proj-cc">{{ car.door_system.centerline_to_hatch }}</div>
                    <div class="proj-cc">{{ car.door_system.door_combined_weight }}</div>
                    <div class="proj-cc">{{ car.door_system.entrance_manufacturer }}</div>

                    <div class="proj-cc"></div>
                    <div class="proj-cc"></div>

                    <div class="proj-cc"></div>
                    <div class="proj-cc">{{ car.door_system.door_op_vac }}</div>
                    <div class="proj-cc">{{ car.door_system.door_op_fr_landing_qty }}</div>
                    <div class="proj-cc">{{ car.door_system.door_op_fr_w }}</div>
                    <div class="proj-cc">{{ car.door_system.door_op_fr_speed }}</div>
                    <div class="proj-cc">{{ car.door_system.door_op_fr_opening }}</div>
                    <div class="proj-cc">{{ car.door_system.door_op_rear_landing_qty }}</div>
                    <div class="proj-cc">{{ car.door_system.door_op_rear_w }}</div>
                    <div class="proj-cc">{{ car.door_system.door_op_rear_speed }}</div>
                    <div class="proj-cc">{{ car.door_system.door_op_rear_opening }}</div>
                    <div class="proj-cc" v-if="false">{{ car.door_system.light_curtain_qty }}</div>
                </div>
            </div></div>
        </section>

        <h2 class="proj-s1 text-left" v-if="steps.guide_rails">Guide Rails</h2>
        <section class="project-section" v-if="steps.guide_rails">
            <div class="proj-labels">
                <div class="proj-section1 proj-group">
                    <div class="proj-ds"><label> Car ID Number</label></div>

                    <div class="proj-cc proj-h3"><label> <strong>Car Guide Rail</strong></label></div>
                    <div class="proj-ds"><label> Rail Size</label></div>
                    <div class="proj-ds"><label> Std. length for Guide Rail</label></div>
                    <div class="proj-ds"><label> Number of Rails for Car Side</label></div>
                    <div class="proj-ds"><label> Fishplate Type <small>(Including hardware)</small></label></div>

                    <div class="proj-cc proj-h3"><label> <strong>CWT Guide Rail</strong></label></div>
                    <div class="proj-ds"><label> Rail Size</label></div>
                    <div class="proj-ds"><label> Std. length for Guide Rail</label></div>
                    <div class="proj-ds"><label> Number of Rails for CWT Side</label></div>
                    <div class="proj-ds"><label> Fishplate Type <small>(Including hardware)</small></label></div>
                </div>
            </div>

            <div class="proj-cars"><div class="proj-car" v-for="(car,cn) in model.cars" :key="cn">
                <div class="proj-section1 proj-group">
                    <div class="proj-ds">{{ car.car_id_number }}</div>

                    <div class="proj-cc"></div>
                    <div class="proj-cc">{{ car.guide_rails.rail_size_car }}</div>
                    <div class="proj-s2">
                        <div class="proj-split">
                            <label>8ft</label>
                            <label>16ft</label>
                        </div>
                    </div>
                    <div class="proj-s2">
                        <div class="proj-split">
                            <label>{{ car.guide_rails.rail_no_car_8 }}</label>
                            <label>{{ car.guide_rails.rail_no_car_16 }}</label>
                        </div>
                    </div>
                    <div class="proj-cc">{{ car.guide_rails.fishplate_car }}</div>

                    <div class="proj-cc"></div>
                    <div class="proj-cc">{{ car.guide_rails.rail_size_cwt }}</div>
                    <div class="proj-s2">
                        <div class="proj-split">
                            <label>8ft</label>
                            <label>16ft</label>
                        </div>
                    </div>
                    <div class="proj-s2">
                        <div class="proj-split">
                            <label>{{ car.guide_rails.rail_no_cwt_8 }}</label>
                            <label>{{ car.guide_rails.rail_no_cwt_16 }}</label>
                        </div>
                    </div>
                    <div class="proj-cc">{{ car.guide_rails.fishplate_cwt }}</div>
                </div>
            </div></div>
        </section>

        <h2 class="proj-s1 text-left" v-if="steps.hoistway_components">Hoistway Components</h2>
        <section class="project-section" v-if="steps.hoistway_components">
            <div class="proj-labels">
                <div class="proj-section1 proj-group">
                    <div class="proj-ds"><label> Car ID Number</label></div>
                    <div class="proj-ds proj-r5"><label> </label></div>
                    <div class="proj-ds"><label> Speed (fpm)</label></div>
                    <div :hidden="hidableRowsHoist.capacitysel && hidableRowsHoist.capacity" class="proj-ds"><label> Rated Capacity (lbs)</label></div>
                    <div :hidden="hidableRowsHoist.empty_car_weight" class="proj-ds"><label> Estimated Empty Car Weight (lb)</label></div>
                    <div :hidden="hidableRowsHoist.counterweight" class="proj-ds"><label> Counterweight  %</label></div>
                    <div :hidden="hidableRowsHoist.governor_type" class="proj-ds"><label> Governor Type</label></div>
                    <div :hidden="hidableRowsHoist.governor_rope_length" class="proj-ds"><label> Governor Rope Length <small>(ft)</small></label></div>
                    <div :hidden="hidableRowsHoist.governor_position" class="proj-ds"><label> Governor Position <ses-tooltip type="illu-hc1"></ses-tooltip></label></div>
                    <div :hidden="hidableRowsHoist.dbg" class="proj-ds"><label> DBG (X) (in)</label></div>
                    <div :hidden="hidableRowsHoist.oil_buffer_car_side_qty" class="proj-ds"><label> Oil Buffer Qty for Car Side</label></div>
                    <div :hidden="hidableRowsHoist.oil_buffer_cwt_side_qty" class="proj-ds"><label> Oil Buffer Qty for CWT Side</label></div>
                </div>
            </div>

            <div class="proj-cars"><div class="proj-car" v-for="(car,cn) in model.cars" :key="cn">
                <div class="proj-section1 proj-group">
                    <div class="proj-ds">{{ car.car_id_number }}</div>

                    <div class="proj-cc"><label><input type="checkbox" :checked="car.hoistway_components.governor == 'Y'" disabled> Governor</label></div>
                    <div class="proj-cc"><label><input type="checkbox" :checked="car.hoistway_components.governor_rope == 'Y'" disabled> Governor Rope</label></div>
                    <div class="proj-cc"><label><input type="checkbox" :checked="car.hoistway_components.roller_guide == 'Y'" disabled> Roller Guide</label></div>
                    <div class="proj-cc"><label><input type="checkbox" :checked="car.hoistway_components.safety == 'Y'" disabled> Safety</label></div>
                    <div class="proj-cc"><label><input type="checkbox" :checked="car.hoistway_components.oil_buffer == 'Y'" disabled> Oil Buffer</label></div>

                    <div class="proj-cc" v-if="steps.machine_system">{{ car.speed }}</div>
                    <div :hidden="hidableRowsHoist.capacitysel && hidableRowsHoist.capacity" class="proj-cc" v-if="steps.machine_system">{{ car.capacity }}</div>
                    <div :hidden="hidableRowsHoist.empty_car_weight" class="proj-cc" v-if="steps.machine_system">{{ car.empty_car_weight }}</div>
                    <div :hidden="hidableRowsHoist.counterweight" class="proj-cc" v-if="steps.machine_system">{{ car.counterweight }}</div>

                    <div class="proj-cc" v-if="!steps.machine_system">{{ car.hoistway_components.speed }}</div>
                    <div :hidden="hidableRowsHoist.capacitysel && hidableRowsHoist.capacity" class="proj-cc" v-if="!steps.machine_system">{{ car.hoistway_components.capacity }}</div>
                    <div :hidden="hidableRowsHoist.empty_car_weight" class="proj-cc" v-if="!steps.machine_system">{{ car.hoistway_components.empty_car_weight }}</div>
                    <div :hidden="hidableRowsHoist.counterweight" class="proj-cc" v-if="!steps.machine_system">{{ car.hoistway_components.counterweight }}</div>

                    <div :hidden="hidableRowsHoist.governor_type" class="proj-cc">{{ car.hoistway_components.governor_type }}</div>
                    <div :hidden="hidableRowsHoist.governor_rope_length" class="proj-cc">{{ car.hoistway_components.governor_rope_length }}</div>
                    <div :hidden="hidableRowsHoist.governor_position" class="proj-cc">{{ car.hoistway_components.governor_position }}</div>
                    <div :hidden="hidableRowsHoist.dbg" class="proj-cc">{{ car.hoistway_components.dbg }}</div>
                    <div :hidden="hidableRowsHoist.oil_buffer_car_side_qty" class="proj-cc">{{ car.hoistway_components.oil_buffer_car_side_qty }}</div>
                    <div :hidden="hidableRowsHoist.oil_buffer_cwt_side_qty" class="proj-cc">{{ car.hoistway_components.oil_buffer_cwt_side_qty }}</div>
                </div>
            </div></div>
        </section>

        <h2 class="proj-s1 text-left" v-if="steps.hydraulics">Hydraulic Power Unit</h2>
        <section class="project-section" v-if="steps.hydraulics">
            <div class="proj-labels">
                <div class="proj-section1 proj-group">
                    <div class="proj-ds"><label> Car ID Number</label></div>
                    <div class="proj-ds"><label> ANSI Code 2010 or later? </label></div>
                    <div class="proj-ds"><label> Twin Jack? </label></div>
                    <div :hidden="hidableRowsHydraulic.existing_fl_pressure" class="proj-ds"><label> Existing FL Pressure <small>(PSI)</small></label></div>
                    <div :hidden="hidableRowsHydraulic.capacitysel" class="proj-ds"><label> Capacity <small>(lb)</small></label></div>
                    <div :hidden="hidableRowsHydraulic.car_weight" class="proj-ds"><label> Car Weight <small>(lb)</small></label></div>
                    <div class="proj-ds"><label> Requested Speed <small>(ft/min)</small></label></div>
                    <div class="proj-ds"><label> Piston Diameter <small>(in)</small></label></div>
                    <div class="proj-ds"><label> Travel <small>(ft)</small></label></div>
                    <div class="proj-ds"><label> Existing Motor HP <small>(HP)</small></label></div>
                    <div class="proj-ds"><label> Building Voltage <small>(VAC)</small></label></div>
                    <div class="proj-ds"><label> Valve Coil Voltage </label></div>
                    <div class="proj-ds"><label> Motor SPH </label></div>
                    <div class="proj-ds"><label> Hand </label></div>
                    <div class="proj-ds"><label> Connection Type </label></div>
                    <div class="proj-ds"><label> Machine Room machine_location </label></div>
                    <div :hidden="hidableRowsHydraulic.distance" class="proj-ds"><label> Distance <small>(ft)</small></label></div>
                    <div class="proj-ds"><label> Rupture Valve Installed <small>(ft)</small></label></div>
                    <div class="proj-cc proj-h3"><label><strong>Optional Components</strong></label></div>
                    <div class="proj-ds"><label> Viscosity Temp Switch </label></div>
                    <div class="proj-ds"><label> Low Pressure Sw </label></div>
                    <div class="proj-ds"><label> Low Oil Switch </label></div>
                    <div class="proj-ds"><label> Load Weigh Pressure Switch </label></div>
                    <div class="proj-ds"><label> Constant Down Speed Control(Maxton) </label></div>
                    <div class="proj-ds"><label> Oil Cooler(fit to Tank) </label></div>
                    <div class="proj-ds"><label> Oil Level Temp/Sight Gauge; Grainger 6W388 </label></div>
                    <div class="proj-ds"><label> Pulsating Material Muffler VIC </label></div>
                    <div class="proj-ds"><label> Scavenger Pump w/ 100ft Plastic Tubing </label></div>
                    <div :hidden="hidableRowsHydraulic.copper_tubing" class="proj-ds"><label> 50ft roll copper tubing in lieu of Plastic*** </label></div>
                    <div class="proj-ds"><label> Tank Heater </label></div>
                    <div class="proj-ds"><label> Shut Off Ball Valve </label></div>
                    <div class="proj-ds"><label> J Box mounted on Tank for wire consolidation </label></div>
                </div>
            </div>

            <div class="proj-cars"><div class="proj-car" v-for="(car,cn) in model.cars" :key="cn">
                <div class="proj-section1 proj-group">
                    <div class="proj-ds">{{ car.car_id_number }}</div>
                    <div class="proj-ds">{{ car.hydraulics.ansi_code_2010 }}</div>
                    <div class="proj-ds">{{ car.hydraulics.twin_jack }}</div>
                    <div :hidden="hidableRowsHydraulic.existing_fl_pressure" class="proj-ds">{{ car.hydraulics.existing_fl_pressure }}</div>
                    <div :hidden="hidableRowsHydraulic.capacitysel" class="proj-ds">{{ car.hydraulics.capacity }}</div>
                    <div :hidden="hidableRowsHydraulic.car_weight" class="proj-ds">{{ car.hydraulics.car_weight }}</div>
                    <div class="proj-ds">{{ car.hydraulics.requested_speed }}</div>
                    <div class="proj-ds">{{ car.hydraulics.piston_diameter }}</div>
                    <div class="proj-ds">{{ car.hydraulics.travel }}</div>
                    <div class="proj-ds">{{ car.hydraulics.existing_motor_hp }}</div>
                    <div class="proj-ds">{{ car.hydraulics.building_voltage }}</div>
                    <div class="proj-ds">{{ car.hydraulics.valve_coil_voltage }}</div>
                    <div class="proj-ds">{{ car.hydraulics.motor_sph }}</div>
                    <div class="proj-ds">{{ car.hydraulics.hand }}</div>
                    <div class="proj-ds">{{ car.hydraulics.connection_type }}</div>
                    <div class="proj-ds">{{ car.hydraulics.machine_room_location }}</div>
                    <div :hidden="hidableRowsHydraulic.distance" class="proj-ds">{{ car.hydraulics.distance }}</div>
                    <div class="proj-ds">{{ car.hydraulics.rupture_valve_installed }}</div>

                    <div class="proj-ds"></div>
                    <div class="proj-ds">{{ car.hydraulics.viscosity_temp_switch }}</div>
                    <div class="proj-ds">{{ car.hydraulics.low_pressure_sw }}</div>
                    <div class="proj-ds">{{ car.hydraulics.low_oil_switch }}</div>
                    <div class="proj-ds">{{ car.hydraulics.load_weigh_pressure_switch }}</div>
                    <div class="proj-ds">{{ car.hydraulics.constant_down_speed_control }}</div>
                    <div class="proj-ds">{{ car.hydraulics.oil_cooler }}</div>
                    <div class="proj-ds">{{ car.hydraulics.oil_level_temp_sight_gauge }}</div>
                    <div class="proj-ds">{{ car.hydraulics.pulsating_material_muffler }}</div>
                    <div class="proj-ds">{{ car.hydraulics.scavenger_pump }}</div>
                    <div :hidden="hidableRowsHydraulic.copper_tubing" class="proj-ds">{{ car.hydraulics.copper_tubing }}</div>
                    <div class="proj-ds">{{ car.hydraulics.tank_heater }}</div>
                    <div class="proj-ds">{{ car.hydraulics.shut_off_ball_valve }}</div>
                    <div class="proj-ds">{{ car.hydraulics.j_box }}</div>
                </div>
            </div></div>
        </section>

        <h2 class="proj-s1 text-left" v-if="!steps.machine_system && steps.wire_ropes">Wire Rope</h2>
        <section class="project-section" v-if="!steps.machine_system && steps.wire_ropes">
            <div class="proj-labels">
                <div class="proj-section1 proj-group">
                    <div class="proj-ds"><label> Car ID Number</label></div>
                    <div class="proj-ds proj-r2"><label> </label></div>
                    <div class="proj-ds"><label> Governor Rope Length (ft)</label></div>
                    <div class="proj-ds"><label> Hoist Rope Size</label></div>
                    <div class="proj-ds"><label> Hoist Rope Type</label></div>
                    <div class="proj-ds"><label> Hoist Rope Length (ft)</label></div>
                    <div class="proj-ds"><label> Hoist Rope Number</label></div>
                    <div class="proj-ds"><label> Double Wrap</label></div>
                </div>
            </div>

            <div class="proj-cars"><div class="proj-car" v-for="(car,cn) in model.cars" :key="cn">
                <div class="proj-section1 proj-group">
                    <div class="proj-ds">{{ car.car_id_number }}</div>

                    <div class="proj-cc"><label><input type="checkbox" :checked="car.wire_ropes.governor_rope == 'Y'" disabled> Governor Rope</label></div>
                    <div class="proj-cc"><label><input type="checkbox" :checked="car.wire_ropes.hoist_rope == 'Y'" disabled> Hoist Rope</label></div>

                    <div class="proj-cc">{{ car.wire_ropes.governor_rope_length }}</div>
                    <div class="proj-cc">{{ car.wire_ropes.rope_size }}</div>
                    <div class="proj-cc">{{ car.wire_ropes.rope_type }}</div>
                    <div class="proj-cc">{{ car.wire_ropes.hoist_rope_length }}</div>
                    <div class="proj-cc">{{ car.wire_ropes.hoist_rope_number }}</div>
                    <div class="proj-cc">{{ car.wire_ropes.dw }}</div>
                </div>
            </div></div>
        </section>

        <h2 class="proj-s1 text-left" v-if="!steps.machine_system && steps.compensations">Compensation</h2>
        <section class="project-section" v-if="!steps.machine_system && steps.compensations">
            <div class="proj-labels">
                <div class="proj-section1 proj-group">
                    <div class="proj-ds"><label> Car ID Number</label></div>
                    <div class="proj-ds"><label> Compensation Type</label></div>
                    <div class="proj-ds"><label> Compensation Weight (lbs/ft)</label></div>
                    <div class="proj-ds"><label> Compensation Length (ft)</label></div>
                    <div class="proj-ds"><label> No. of Compensation Chain</label></div>
                    <div class="proj-ds"><label> Request Swayless Device</label></div>
                    <div class="proj-ds"><label> Speed (fpm)</label></div>
                </div>
            </div>

            <div class="proj-cars"><div class="proj-car" v-for="(car,cn) in model.cars" :key="cn">
                <div class="proj-section1 proj-group">
                    <div class="proj-ds">{{ car.car_id_number }}</div>
                    <div class="proj-cc">{{ car.compensations.compensation_type }}</div>
                    <div class="proj-cc">{{ car.compensations.compensation_weight }}</div>
                    <div class="proj-cc">{{ car.compensations.compensation_length }}</div>
                    <div class="proj-cc">{{ car.compensations.compensation_chains }}</div>
                    <div class="proj-cc">{{ car.compensations.swayless_device }}</div>
                    <div class="proj-cc">{{ car.compensations.speed }}</div>
                </div>
            </div></div>
        </section>

        <h2 class="proj-s1 text-left" v-if="!steps.machine_system && steps.compounding_sheaves">Compounding Sheave</h2>
        <section class="project-section" v-if="!steps.machine_system && steps.compounding_sheaves">
            <div class="proj-labels">
                <div class="proj-section1 proj-group">
                    <div class="proj-ds"><label> Car ID Number</label></div>
                    <div class="proj-ds"><label> No Sheave Option</label></div>
                    <div v-if="showDuraLiftSheave" class="proj-ds"><label> Dura Lift Sheave <ses-tooltip type="illu-dura"></ses-tooltip></label></div>
                    <div class="proj-ds"><label> Rope Size</label></div>
                    <div class="proj-ds"><label> Groove number</label></div>
                    <div class="proj-ds"><label> Pitch (in)</label></div>
                    <div class="proj-ds"><label> Secondary Sheave Position</label></div>
                    <div class="proj-ds"><label> Sheave Diameter (D)</label></div>
                    <div class="proj-ds"><label> Maximum Allowable Sheave Width (W) (in)</label></div>
                    <div class="proj-ds"><label> Shaft Type (A or B) <ses-tooltip type="illu-6" align="top"></ses-tooltip></label></div>
                    <div class="proj-ds"><label> Qty</label></div>
                    <div class="proj-ds"><label> L1 (in)</label></div>
                    <div class="proj-ds"><label> L2 (in)</label></div>
                    <div class="proj-ds"><label> L3 (in)</label></div>
                    <div class="proj-ds"><label> L4 (in)</label></div>
                    <div class="proj-ds"><label> L5 (in)</label></div>
                    <div class="proj-ds"><label> L6 (in)</label></div>
                </div>
            </div>

            <div class="proj-cars"><div class="proj-car" v-for="(car,cn) in model.cars" :key="cn">
                <div class="proj-section1 proj-group">
                    <div class="proj-ds"></div>
                    <div class="proj-ds">{{ car.car_id_number }}</div>
                    <div class="proj-ds no-sheave-option">
                        <label><input type="checkbox" :checked="car.no_sheave == 1" disabled> No Sheave Option</label>
                    </div>
                    <div v-if="showDuraLiftSheave" class="proj-cc">{{ car.compounding_sheaves.dura_lift_sheave }}</div>
                    <div class="proj-cc">{{ car.compounding_sheaves.rope_size }}</div>
                    <div class="proj-cc">{{ car.compounding_sheaves.groove_number }}</div>
                    <div class="proj-cc">{{ car.compounding_sheaves.pitch_in }}</div>
                    <div class="proj-s2">
                        <div class="proj-split">
                            <label>Car Side</label>
                            <label>CWT Side</label>
                        </div>
                    </div>
                    <div class="proj-cc">
                        <div>{{ car.compounding_sheaves.sheave_diameter_car }}</div>
                        <div>{{ car.compounding_sheaves.sheave_diameter_cwt }}</div>
                    </div>
                    <div class="proj-cc">
                        <div>{{ car.compounding_sheaves.max_sheave_width_car }}</div>
                        <div>{{ car.compounding_sheaves.max_sheave_width_cwt }}</div>
                    </div>
                    <div class="proj-cc">
                        <div>{{ car.compounding_sheaves.shaft_type_car }}</div>
                        <div>{{ car.compounding_sheaves.shaft_type_cwt }}</div>
                    </div>
                    <div class="proj-cc">
                        <div>{{ car.compounding_sheaves.qty_car }}</div>
                        <div>{{ car.compounding_sheaves.qty_cwt }}</div>
                    </div>
                    <div class="proj-cc">
                        <div>{{ car.compounding_sheaves.l1_car }}</div>
                        <div>{{ car.compounding_sheaves.l1_cwt }}</div>
                    </div>
                    <div class="proj-cc">
                        <div>{{ car.compounding_sheaves.l2_car }}</div>
                        <div>{{ car.compounding_sheaves.l2_cwt }}</div>
                    </div>
                    <div class="proj-cc">
                        <div>{{ car.compounding_sheaves.l3_car }}</div>
                        <div>{{ car.compounding_sheaves.l3_cwt }}</div>
                    </div>
                    <div class="proj-cc">
                        <div>{{ car.compounding_sheaves.l4_car }}</div>
                        <div>{{ car.compounding_sheaves.l4_cwt }}</div>
                    </div>
                    <div class="proj-cc">
                        <div>{{ car.compounding_sheaves.l5_car }}</div>
                        <div>{{ car.compounding_sheaves.l5_cwt }}</div>
                    </div>
                    <div class="proj-cc">
                        <div>{{ car.compounding_sheaves.l6_car }}</div>
                        <div>{{ car.compounding_sheaves.l6_cwt }}</div>
                    </div>
                </div>
            </div></div>
        </section>

        <div v-if="false">
        <div class="datasheets" v-for="(car,group) in datasheets" :key="group">
            <h3>Type: {{ group.toUpperCase() }} </h3>
            <h3>Application Information</h3>
            <table v-if="car">
            <tbody>
                <tr>
                <th>Car ID Number</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].car_id_number }}</td>
                </tr>
                <tr>
                <th>Capacity</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].capacity }}</td>
                </tr>
                <tr>
                <th>Speed</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].speed }}</td>
                </tr>
                <tr>
                <th>Acceleration</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].acceleration }}</td>
                </tr>
                <tr>
                <th>Car Weight  </th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].empty_car_weight }}</td>
                </tr>
                <tr>
                <th>Wrap  </th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].wrap }}</td>
                </tr>
                <tr>
                <th>Drive Output Voltage</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].vac }}</td>
                </tr>
                <tr>
                <th>Compensation</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].compensation }}</td>
                </tr>
                <tr>
                <th>Suspended Load</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].suspended_load }}</td>
                </tr>
                <tr>
                <th>Full Load Mass</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].full_load_mass }}</td>
                </tr>
                <tr>
                <th>SSL</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].ssl }}</td>
                </tr>
            </tbody>
            </table>

            <br>
            <br>

            <h3>Machine Selection Information</h3>
            <table v-if="car">
            <tbody>
                <tr>
                <th>Machine Number</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].machine_number }}</td>
                </tr>
                <tr>
                <th>Motor Voltage</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].motor_rated_voltage }}</td>
                </tr>
                <tr>
                <th>Motor RPM</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].motor_rpm_app_rated }}</td>
                </tr>
                <tr>
                <th>Motor Freq</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].motor_frequency_app_rated }}</td>
                </tr>
                <tr>
                <th>Motor Power</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].motor_power_app_rated }}</td>
                </tr>
                <tr>
                <th>FL Current</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].fl_current_app_rated }}</td>
                </tr>
                <tr>
                <th>Accel Current</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].accel_current_app_rated }}</td>
                </tr>
                <tr>
                <th>Application Torque</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].application_torque }}</td>
                </tr>
                <tr>
                <th>Application Accel Torque</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].app_accel_torque }}</td>
                </tr>
                <tr>
                <th>Motor Rated Torque</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].motor_rated_torque }}</td>
                </tr>
                <tr>
                <th>Motor Accel Torque</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].motor_accel_torque }}</td>
                </tr>
                <tr>
                <th>Gear Ratio</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].gear_ratio }}</td>
                </tr>
                <tr>
                <th>Brake Model</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].brake_model }}</td>
                </tr>
                <tr>
                <th>Pick/Hold Voltage</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].pick_hold_voltage }}</td>
                </tr>
                <tr>
                <th>Pick/Hold Current</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].pick_hold_current }}</td>
                </tr>
                <tr>
                <th>Coil Resistance</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].coil_resistance }}</td>
                </tr>
                <tr>
                <th>Em Brake Model</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].em_brake_model }}</td>
                </tr>
                <tr>
                <th>Em Pick/Hold Voltage</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].em_pick_hold_voltage }}</td>
                </tr>
                <tr>
                <th>Em Pick/Hold Current</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].em_pick_hold_current }}</td>
                </tr>
                <tr>
                <th>Em Coil Resistance</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].em_coil_resistance }}</td>
                </tr>
                <tr>
                <th>Recom. Encoder Voltage</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].recommended_encoder_voltage }}</td>
                </tr>
                <tr>
                <th>Motor Encoder Resolution</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].motor_encoder_resolution }}</td>
                </tr>
                <tr>
                <th># of Ropes</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].number_of_ropes }}</td>
                </tr>
                <tr>
                <th>Rope Breaking Strength</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].rope_strength }}</td>
                </tr>
                <tr>
                <th>Hoist Rope Dia.</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].hoist_rope_diameter }}</td>
                </tr>
                <tr>
                <th>Sheave Dia.</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].sheave_diameter }}</td>
                </tr>
                <tr>
                <th>Groove Profile</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].sheave_groove }}</td>
                </tr>
                <tr>
                <th>Gamma</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].gamma }}</td>
                </tr>
                <tr>
                <th>Beta</th>
                <td v-for="cn in 3" :key="cn">{{ !car[cn] ? '' : car[cn].beta }}</td>
                </tr>
            </tbody>
            </table>
            <br>
            <br>
            <br>
            <br>
            <br>
        </div>
        </div>
    </div>
    </div>
    <ControllerFloorInfo :floordata="floorCTRL" @saveinfo="saveCTRLInfo" @closeinfo="closeCTRLInfo"></ControllerFloorInfo>
    <DoorFloorInfo :floordata="floorDS" @saveinfo="saveDSInfo" @closeinfo="closeDSInfo"></DoorFloorInfo>
    <SellingPoint :spinfo="spinfo" @saveinfo="saveSPInfo"></SellingPoint>
  </div>
</template>
<script>
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import MaskedInput from 'vue-masked-input';
    import ControllerFloorInfo from '../../components/Modals/ControllerFloorInfo';
    import DoorFloorInfo from '../../components/Modals/DoorFloorInfo';
    import SellingPoint from '../../components/Modals/SellingPoint';

  export default {
    name: 'tables',
    components: { DatePicker, MaskedInput, ControllerFloorInfo , DoorFloorInfo, SellingPoint },
    props: {
      type: {
        type: String
      },
      title: String
    },
    data() {
        var isCon = this.$attrs.rtype == 'construction',
            date = new Date(),
            lead = 14 * 7; //weeks to days
        date.setDate(date.getDate() + lead);
        var blank_cssv = {
            dura_lift_sheave: '',
            sheave_type : '',
            location : '',
            rope_size : '',
            groove_number : '',
            pitch_in : '',
            sheave_diameter : '',
            max_sheave_width : '',
            shaft_type : '',
            qty : '',
            l1 : '',
            l2 : '',
            l3 : '',
            l4 : '',
            l5 : '',
            l6 : '',
        };
        const hideMachineDisables = {
            'machine_shape': false, 'basement_layout': false, 'tpm_flat_mount': false, 'encoder_cable': false,
            'weight_comp_sheave': false, 'right_left_machine': false, 'onsite_assembly': false, 'pads_on_floors': false,
            'rope_drop_distance': false, 'rope_to_machine_wall': false, 'machine_room_height_clearance': false,
            'existing_machine_beam_location': false, 'ct': false, 'wf_beam_width': false, 'ww_beam_height': false,
            'z1': false, 'z2': false, 'existing_deflector_sheave': false, 'deflector_sheave_diameter': false,
            'number_of_ropes': false, 'groove_pitch': false, 'ys': false, 'angled_bedplate': false,
            'angle_profile': false, 'car_rope_x1': false, 'car_rope_x2': false, 'car_rope_x3': false,
            'basement_config': false, 'basement_pattern': false, 'basement_anchor': false, 'basement_thread': false,
            'basement_sheave_diameter': false, 'basement_rope_diameter': false, 'basement_rope_number': false,
            'basement_pitch': false, 'basement_mr1': false, 'basement_mr2': false, 'basement_mr3': false,
            'basement_rdb': false, 'basement_df4c': false, 'basement_mr1b': false, 'basement_mr2b': false,
            'basement_mr3b': false, 'basement_df1b': false, 'basement_df2b': false, 'basement_mr1c': false, 'basement_mr2c': false,
            'basement_mr3c': false, 'basement_df1c': false, 'basement_df2c': false, 'basement_df3c': false, 'basement_mr4': false,
            'deflector_in_overhead': false, 'rope_diameter_required': false
        };
        const hideHoistwayDisables = {
            'capacitysel': false, 'empty_car_weight': false, 'counterweight': false, 'governor_type': false,
            'governor_rope_length': false, 'governor_position': false, 'dbg': false, 'oil_buffer_car_side_qty': false,
            'oil_buffer_cwt_side_qty': false, 'capacity': false
        };
        const hideWireRopeDisables = {
            'governor_rope_length': false, 'rope_size': false, 'rope_type': false, 'hoist_rope_length': false,
            'hoist_rope_number': false, 'dw': false
        };
        const hideSheaveDisables = {
            'sheave_type': false, 'location': false, 'rope_size': false, 'groove_number': false, 'pitch_in': false,
            'sheave_diameter': false, 'max_sheave_width': false, 'shaft_type': false, 'qty': false, 'l1': false,
            'l2': false, 'l3': false, 'l4': false, 'l5': false, 'l6': false, 'dura_lift_sheave': false
        };
        const hideHydraulicDisables = {
            'existing_fl_pressure': false, 'capacitysel': false, 'capacity': false, 'copper_tubing': false,
            'distance': false, 'car_weight': false
        };
      return {
        defaultHideDisables: hideMachineDisables,
        defaultHideDisablesHoist: hideHoistwayDisables,
        defaultHideDisablesWire: hideWireRopeDisables,
        defaultHideDisablesSheave: hideSheaveDisables,
        defaultHideDisablesHydrau: hideHydraulicDisables,
        hidableRows: hideMachineDisables,
        hidableRowsHoist: hideHoistwayDisables,
        hidableRowsWire: hideWireRopeDisables,
        hidableRowsSheave: hideSheaveDisables,
        hidableRowsHydraulic: hideHydraulicDisables,
        user       : {},
        customers  : [],
        step       : 'selection',
        lead       : lead,
        lead_st    : 4 * 7,
        lead_stw   : 4,
        no_alert   : false,
        isedit     : false,
        num_cars   : 1,
        steps      : { machine_system : 1 },
        next_cn    : 1,
        formtype   : 'survey_form',
        showDS     : false,
        showLD     : false,
        datasheets : false,
        aletmsg    : false,
        loading : false,
        nextloading : false,
        floorCTRL  : false,
        floorDS  : false,
        reseter    : { counter : 1 },
        errors    : {},
        constants  : {},
        settings   : [],
        enc_cables : [],
        hropes : [],
        disabledBefore : date,
        carweightx : [1500,2000,2500,3000,3500,4000,4500,5000,5500,6000,8000,10000,12000],
        carweights : [2250,3000,3750,4500,5250,6000,6750,7500,8250,9000,12000,15000,18000],
        fsub : false,
        cars       : [
            { items: [], selection: '' }
        ],
        machine_subs: ['Machine','Bedplate','Deflector','Rope Guard'],
        selections : [
            {
                key: 'machine_system',
                label: 'Traction Machine System',
                icon: 'machine.jpg',
                doc: '/api/sp/view/WebsiteAsset/Standard Catalog Final.pdf?dir=Brochure/Machines',
                subs: ['Machine','Bedplate','Deflector','Rope Guard'],
                order: 1,
                selectable: isCon,
                hidden : true,
            },
            {
                key: 'door_system',
                label: 'Door System',
                icon: 'door.jpg',
                doc: [
                    { name: 'Catalog', path: '/api/sp/view/WebsiteAsset/Catalog.pdf?dir=Brochure/Door Operator' },
                    { name: 'Light Curtain', path: '/api/sp/view/WebsiteAsset/Light Curtain.pdf?dir=Brochure/Door Operator' }
                ],
                subs: ['Door Operator','Landing Equipment','Entrance'],
                order: 2,
                selectable: true,
                hidden : true,
            },
            {
                key: 'controller',
                label: 'Controller',
                icon: 'controller.jpg',
                doc: [
                    { name: 'Claddagh_Series15_2015_04_08', path: '/api/sp/view/WebsiteAsset/Claddagh_Series15_2015_04_08.pdf?dir=Brochure/Controller' },
                    { name: 'ESI-Single page sell sheet', path: '/api/sp/view/WebsiteAsset/ESI-Single page sell sheet.pdf?dir=Brochure/Controller' }
                ],
                subs: ['Controller','Load Weighing'],
                order: 3,
                selectable: true,
            },
            {
                key: 'guide_rails',
                label: 'Guide Rail',
                icon: 'guide-rail.jpg',
                doc: [
                    { name: 'GR Guide Rail', path: '/api/sp/view/WebsiteAsset/GR Guide Rail.pdf?dir=Drawings/Elevator Components/Guide Rails' },
                    { name: 'FP Standard Fishplate', path: '/api/sp/view/WebsiteAsset/FP Standard Fishplate.pdf?dir=Drawings/Elevator Components/Guide Rails' },
                    { name: 'SFP Seismic T-type Fishplate', path: '/api/sp/view/WebsiteAsset/SFP Seismic T-type Fishplate.pdf?dir=Drawings/Elevator Components/Guide Rails' },
                    { name: 'MFP Low Profile Seismic Fishplate', path: '/api/sp/view/WebsiteAsset/MFP Low Profile Seismic Fishplate.pdf?dir=Drawings/Elevator Components/Guide Rails' },
                    { name: 'FST Hardware Kit', path: '/api/sp/view/WebsiteAsset/FST Hardware Kit.pdf?dir=Drawings/Elevator Components/Guide Rails' }
                ],
                subs: ['Rail','Fish Plate','Rail Clip'],
                order: 4,
                selectable: false,
            },
            {
                key: 'hoistway_components',
                label: 'Hoistway Components',
                icon: 'hoistway.jpg',
                doc: [
                    { name: 'GOV10', path: '/api/sp/view/WebsiteAsset/GOV10.pdf?dir=Drawings/Elevator Components/Governors' },
                    { name: 'GOV20', path: '/api/sp/view/WebsiteAsset/GOV20.pdf?dir=Drawings/Elevator Components/Governors' },
                    { name: 'LSB10', path: '/api/sp/view/WebsiteAsset/LSB10.pdf?dir=Drawings/Elevator Components/Oil Buffer' },
                    { name: 'SEB SERIES', path: '/api/sp/view/WebsiteAsset/SEB SERIES.pdf?dir=Drawings/Elevator Components/Oil Buffer' },
                    { name: 'SAF10-Q13', path: '/api/sp/view/WebsiteAsset/SAF10-Q13.pdf?dir=Drawings/Elevator Components/Safety Gear' },
                    { name: 'SAF10-Q24', path: '/api/sp/view/WebsiteAsset/SAF10-Q24.pdf?dir=Drawings/Elevator Components/Safety Gear' },
                    { name: 'ZRG-3', path: '/api/sp/view/WebsiteAsset/ZRG-3.pdf?dir=Drawings/Elevator Components/Roller Guides' },
                    { name: 'ZRG-6', path: '/api/sp/view/WebsiteAsset/ZRG-6.pdf?dir=Drawings/Elevator Components/Roller Guides' }
                ],
                subs: ['Governor','Roller Guide','Safety','Oil Buffer'],
                order: 5,
                selectable: true,
            },
            {
                key: 'hydraulics',
                label: 'Hydraulic Power Unit',
                icon: 'hydraulic.jpg',
                doc: '/api/sp/view/WebsiteAsset/DEM_Power_Unit_Cutout.pdf?dir=Brochure/Elevator Components/Hydraulic Power Unit',
                subs: false,
                order: 6,
                selectable: isCon,
                hidden : true,
            },
            {
                key: 'wire_ropes',
                label: 'Wire Rope',
                icon: 'wirerope.jpg',
                doc: [
                    { name: 'SRP-6 REEL', path: '/api/sp/view/WebsiteAsset/SRP-6 REEL.pdf?dir=Drawings/Elevator Components/Wire Rope' },
                    { name: 'SRP-9 REEL', path: '/api/sp/view/WebsiteAsset/SRP-9 REEL.pdf?dir=Drawings/Elevator Components/Wire Rope' },
                    { name: 'Rope', path: '/api/sp/view/WebsiteAsset/Rope.pdf?dir=Brochure/Elevator Components/Wire Rope' },
                    { name: 'Wire-Rope', path: '/api/sp/view/WebsiteAsset/Wire-Rope.pdf?dir=Brochure/Elevator Components/Wire Rope' }
                ],
                subs: ['Wire Rope','Wedge Socket','Rope Lubricator'],
                order: 7,
                selectable: true,
            },
            {
                key: 'compensations',
                label: 'Compensation',
                icon: 'comp.jpg',
                doc: [
                    { name: 'SWF', path: '/api/sp/view/WebsiteAsset/SWF.pdf?dir=Drawings/Elevator Components/Compensation Chain' },
                    { name: 'SWF-HDW', path: '/api/sp/view/WebsiteAsset/SWF-HDW.pdf?dir=Drawings/Elevator Components/Compensation Chain' },
                    { name: 'SWF-Switch-Kit', path: '/api/sp/view/WebsiteAsset/SWF-Switch-Kit.pdf?dir=Drawings/Elevator Components/Compensation Chain' },
                    { name: 'SWF-SWLS', path: '/api/sp/view/WebsiteAsset/SWF-SWLS.pdf?dir=Drawings/Elevator Components/Compensation Chain' },
                    { name: 'SWF-SWLS-Stand', path: '/api/sp/view/WebsiteAsset/SWF-SWLS-Stand.pdf?dir=Drawings/Elevator Components/Compensation Chain' },
                    { name: 'Compensation-Chain', path: '/api/sp/view/WebsiteAsset/Compensation-Chain.pdf?dir=Brochure/Elevator Components/Compensation Chain' }
                ],
                subs: ['Comp. Chain','Comp. Rope','Comp. Sheave'],
                order: 8,
                selectable: true,
            },
            {
                key: 'compounding_sheaves',
                label: 'Other Sheave',
                icon: 'compsheave.jpg',
                doc: [
                    { name: 'CSSV-CAR-CWT-340', path: '/api/sp/view/WebsiteAsset/CSSV-CAR-CWT-340.pdf?dir=Drawings/Systems/Compounding Sheaves' },
                    { name: 'CSSV-CAR-CWT-400', path: '/api/sp/view/WebsiteAsset/CSSV-CAR-CWT-400.pdf?dir=Drawings/Systems/Compounding Sheaves' },
                    { name: 'CSSV-CAR-CWT-520', path: '/api/sp/view/WebsiteAsset/CSSV-CAR-CWT-520.pdf?dir=Drawings/Systems/Compounding Sheaves' },
                    { name: 'CSSV-CAR-CWT-640', path: '/api/sp/view/WebsiteAsset/CSSV-CAR-CWT-640.pdf?dir=Drawings/Systems/Compounding Sheaves' },
                    { name: 'CSSV-CAR-CWT-762', path: '/api/sp/view/WebsiteAsset/CSSV-CAR-CWT-762.pdf?dir=Drawings/Systems/Compounding Sheaves' }
                ],
                subs: ['Sheave','Ubolt','Pillow Block'],
                order: 9,
                selectable: true,
            },
        ],
        model      : {
          go_custom: '',
          project: {
            project_name    : '',
            company_name    : 'RipeConcepts Inc.',
            customer_name   : '',
            customer_email  : '',
            customer_phone  : '',
            consultant_name : '',
            use_stock       : 'no',
            // is_final        : isCon ? 'yes' : 'no',
            is_final        : 'no',
            country         : '',
            city            : '',
            state           : '',
            reassembly      : 0,
            phase           : isCon ? 'construction' : 'modernization',
            form_type       : 'survey_form',
            machine_type    : 'traction',
          },
          cars: {
            1 : {}
          }
        },
        deff : {
          car_id_number     : '1',
          machine_location  : 'OHMR',
          gear              : 'TRUE',
          vac               : '480',
          capacity          : '2500',
          speed             : '350',
          rope_diameter     : '1/2',
          roping            : '1',
          empty_car_weight  : '6400',
          counterweight     : '45',
          travel            : '40',
          compensation      : '0',
          weight_comp_sheave: '0',
          machine           : 'TRUE',
          bedplate          : 'TRUE',
          rope_guard        : 'FALSE',
          deflector         : 'FALSE', 
          sheave            : 'FALSE', 
          tdi_emergency_brake : 'TRUE', 
          draka_rope_brake  : 'FALSE', 
          hw_rope_gripper   : 'FALSE', 
          ses_rope_brake    : 'FALSE', 
          drive_manufacturer: 'KEB', 
          encoder_cable     : '50',
          /* SECTION 2 */
          right_left_machine : 'LEFT',
          rope_drop_distance : '42',
          rope_to_machine_wall : '80',
          machine_room_height_clearance : '120',
          wf_beam_width : '8',
          ww_beam_height : '12',
          z1 : '12',
          z2 : '12',
          existing_machine_beam_location : 'A',
          ct : '4',
          existing_deflector_sheave : 'NO',
        },
        blank_cssv : blank_cssv,
        blank : {
            car_id_number     : '1',
            roping            : '1',
            compensation      : '0',
            weight_comp_sheave: '0',
            machine           : 'TRUE',
            bedplate          : 'TRUE',
            rope_guard        : 'TRUE',
            deflector         : 'TRUE', 
            encoder           : 'TRUE', 
            sheave            : 'FALSE', 
            tdi_emergency_brake : 'TRUE', 
            draka_rope_brake  : 'FALSE', 
            hw_rope_gripper   : 'FALSE',
            ses_rope_brake    : 'FALSE', 
            machine_location  : 'OHMR', 
            gear              : '', 
            vac               : '', 
            encoder_cable     : '', 
            rope_diameter     : '', 
            drive_manufacturer: '', 
            speedsel          : '', 
            ecwsel            : '', 
            speed             : '', 
            acceleration      : '', 
            capacitysel       : '', 
            capacity          : '',
            controller        : { freq_loop : 'Yes' }, 
            door_system       : { landing : 'TRUE', door_op : 'TRUE' },
            guide_rails       : {},
            hoistway_components : {},
            hydraulics        : {},
            wire_ropes        : {},
            compensations     : {},
            compounding_sheaves : { type_number : 1, types : [blank_cssv], no_sheave: 0, sheaveTypes: [] },
            z1: isCon ? 12 : '',
            z2: isCon ? 12 : '',
            rope_diameter_required: '',
            existing_deflector_sheave: '',
            deflector_in_overhead: '',
            angled_bedplate: '',
        },
        rtype : 'modernization',
        states : ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'District of Columbia', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'],
        provinces : ['Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland and Labrador', 'Nova Scotia', 'Ontario', 'Prince Edward Island', 'Quebec', 'Saskatchewan', 'Northwest Territories', 'Nunavut', 'Yukon'],
        phone: { code: '+01', number: '' },
        customer: '',
        start_date: '',
        accelerationConditions: [],
        showPadsOnFloors: false,
        backupGoCustom: '',
        showDuraLiftSheave: false,
        disabledCssvInput: ['CSSV-DUR-1', 'CSSV-DUR-2', 'CSSV-DUR-3', 'CSSV-DUR-4'],
        customerNoStock: -1,
        datasheetSystem: {},
        forceOtherSheaveChecked: false, // if bedplate unchecked and deflector is checked, true, false,
        isOtherSheaveCheckedDefault: false,
        blankDefaultMachine: {
            drive_manufacturer: { value: 'None Selected', initialOnly: true },
            vac: { value: 'Unknown', initialOnly: true },
            rope_diameter_required: { value: 'N', initialOnly: false },
            rope_diameter: { value: 'Unknown', initialOnly: false },
            encoder_cable: { value: '', initialOnly: false }
        },
        defaultPostFix: '_is_default',
        defaultValuePostFix: '_default_value'
      }
    },
    preventClick(e) {
        e.preventDefault();
    },
    computed: {
        requiredRowsSpan: function () {
            let rowspan = 6
            if (!this.hidableRows.machine_shape) rowspan++
            if (!this.hidableRows.basement_layout) rowspan++
            if (!this.hidableRows.tpm_flat_mount) rowspan++
            return rowspan
        },
        hasNonOHMR: function () {
            return !this.hidableRows.machine_shape || !this.hidableRows.basement_layout || !this.hidableRows.tpm_flat_mount
        }
    },
    created() {
        var user = localStorage.getItem('user');
        if ( !user ) this.$router.push('login');
        this.user = JSON.parse(user);
        this.customerNoStock = this.user.no_stock

        this.me();
        this.loadSettings();
        this.loadCables();
        this.loadCustomers();


        if ( this.user.wire_rope ) this.steps.wire_ropes = this.stepOrder('wire_ropes');
        if ( this.user.wire_rope ) this.steps.compensations = this.stepOrder('compensations');

        if ( this.user.functions && !this.user.functions.includes('project_add') ) this.$router.push('/projects');

        const project_id = this.$route.params.id;
        this.getNow();
        this.rtype = this.$attrs.rtype ? this.$attrs.rtype : 'modernization';
        if ( project_id !== undefined ) {
            console.log('go', this.$attrs.ftype);
            this.isedit = this.$attrs.ftype != 'duplicate';
            this.getProject(project_id);
        } else {
            this.isedit = false;
            this.model.cars[1] = this.blank;
            // this.model.project.is_final = (this.$attrs.ftype == 'final' || this.rtype == 'construction') ? 'yes' : 'no';
            this.model.project.is_final = this.$attrs.ftype == 'final' ? 'yes' : 'no';
            this.model.project.company_name = this.user.company;
            if (!this.isSU()) {
                this.model.project.country = this.user.country;
                this.model.project.state = this.user.state;
            }
            this.machChange();
        }
        if ( this.rtype == 'construction' ) {
            this.initConstruction();
        }
        
        this.checkCustomerCanPadsOnFloors()
        this.checkCustomerCanDuraLiftSheave()

        window.addEventListener('resize', this.onFormResize)
    },
    mounted() {
        if (document.querySelector('.phone_code')) document.querySelector('.phone_code').addEventListener('click', (e) => { this.onPhoneClick(e, '.phone_code') })
        if (document.querySelector('.phone_number')) document.querySelector('.phone_number').addEventListener('click', (e) => { this.onPhoneClick(e, '.phone_number') })
        this.getAccelerationConditions();
    },
    watch: {
        step() {
            setTimeout(() => {
                this.onFormResize()
                let phone_code = document.querySelector('.phone_code')
                let phone_number = document.querySelector('.phone_number')
                if(phone_code) phone_code.addEventListener('click', (e) => { this.onPhoneClick(e, '.phone_code') });
                if(phone_number) phone_number.addEventListener('click', (e) => { this.onPhoneClick(e, '.phone_number') });

                let top_scroll_body = document.querySelector('.top-scroll-body')

                if(top_scroll_body) {
                    let num_cars = Object.keys(this.model.cars).length
                    top_scroll_body.style.width = (parseInt(num_cars) * 200) + 'px'

                    document.querySelector('.proj-cars').addEventListener('scroll', (e) => {
                        document.querySelector('.top-scroll').scrollLeft = e.target.scrollLeft
                    })
                    
                    document.querySelector('.top-scroll').addEventListener('scroll', (e) => {
                        document.querySelector('.proj-cars').scrollLeft = e.target.scrollLeft
                    })
                }
            }, 600)
        }
    },
    methods: {
        me() {
            this.$http.get('/api/me').then((r) => { 
                localStorage.setItem('user', JSON.stringify(r.data));
                this.user = r.data;

                let date = new Date();
                let lead = parseInt(this.user.lead_time) * 7; //weeks to days
                date.setDate(date.getDate() + lead);

                this.lead = lead;
                this.disabledBefore = date;
            });
        },
        nameSelect(username) {
          const user = this.user.other_names.find(u => u.name === username)
          if ( user ) this.set_name(user);
          console.log('nameSelect', { user });
        },
        changingName(e) {
          if (!e.inputType) {
            this.nameSelect(this.model.project.customer_name)
          }
        },
        customerSelect(username) {
          const user = this.customers.find(u => u.username === username)
          if ( user ) {
            this.model.project.customer_id = user.id;
            this.handleItemsListByCustomer()
          } else {
            this.customer = '';
            this.model.project.customer_id = null;
          }
          console.log('customerSelect', user);
        },
        changingCustomer(e) {
          if (!e.inputType) {
            this.customerSelect(this.customer)
          }
        },
        isSU() {
            return this.user.role == 'super-user';
        },
        isPM() {
            return this.user.role == 'project-manager';
        },
        loadCustomers() {
            if ( this.isSU() ) {
                this.$http.get('/api/data/customers').then((r) => {
                    this.customers = r.data;
                    if ( this.customers && this.model.project.customer_id ) {
                        const user = this.customers.find(u => u.id == this.model.project.customer_id)
                        if( user ) this.customer = user.username
                    }
                });
            }
        },
        loadSettings() {
            this.$http.get('/api/data/settings').then((r) => {
                this.settings = r.data;

                if ( this.settings['stock_leadtime'] && this.settings['stock_leadtime'] > 0 ) {
                    this.lead_stw = this.settings['stock_leadtime'];
                    this.lead_st = this.lead_stw * 7;
                }
            });
        },
        loadCables() {
            this.$http.get('/api/data/encoder-cables').then((r) => {
                this.enc_cables = r.data;
            });
            this.$http.get('/api/data/hoist-ropes').then((r) => {
                this.hropes = r.data;
            });
            this.$http.get('/api/data/constants').then((r) => {
                this.constants = r.data;
            });
        },
        machChange(){
            if ( this.model.project.machine_type == 'traction' ) {
                this.selections[0].selectable = this.model.project.phase == 'construction' ? true : false;
                this.selections[1].selectable = true;
                this.selections[2].selectable = true;
                this.selections[3].selectable = false;
                this.selections[4].selectable = true;
                this.selections[5].selectable = false;
                this.selections[6].selectable = true;
                this.selections[7].selectable = true;
                this.selections[8].selectable = true;
                if (parseInt(this.$route.params.id) > 0) {
                    if ( this.model.proj_steps.step_wire_ropes )          this.steps.wire_ropes          = this.stepOrder('wire_ropes');
                    if ( this.model.proj_steps.step_compensations )       this.steps.compensations       = this.stepOrder('compensations');
                } else {
                    this.steps.machine_system = this.stepOrder('machine_system');
                    if ( this.user.wire_rope ) this.steps.wire_ropes = this.stepOrder('wire_ropes');
                    if ( this.user.wire_rope ) this.steps.compensations = this.stepOrder('compensations');
                }
                // this.steps.compounding_sheaves = this.stepOrder('compounding_sheaves');
                this.checkCustomerCanPadsOnFloors()
                this.checkCustomerCanDuraLiftSheave()
                delete this.steps.hydraulics;
            } else {
                this.selections[0].selectable = false;
                this.selections[1].selectable = true;
                this.selections[2].selectable = false;
                this.selections[3].selectable = false;
                this.selections[4].selectable = false;
                this.selections[5].selectable = this.model.project.phase == 'construction' ? true : false;
                this.selections[6].selectable = false;
                this.selections[7].selectable = false;
                this.selections[8].selectable = false;
                this.checkCustomerCanPadsOnFloors()
                this.checkCustomerCanDuraLiftSheave()
                delete this.steps.machine_system;
                delete this.steps.controller;
                delete this.steps.guide_rails;
                delete this.steps.hoistway_components;
                delete this.steps.wire_ropes;
                delete this.steps.compensations;
                delete this.steps.compounding_sheaves;
                
                this.steps.hydraulics = this.stepOrder('hydraulics');
            }
            console.log('machine_type',this.model.project.machine_type);
            this.stateChange();
        },
        formChange(){
            if ( this.model.project.form_type == 'selection' ) {
                this.steps = { 'machine_system' : 1 };
                if ( this.user.wire_rope ) this.steps.wire_ropes = 7;
                if ( this.user.wire_rope ) this.steps.compensations = 8;
                this.num_cars = 1;
                for ( var cnx in this.model.cars ) {
                    if ( cnx == 1 ) {
                        this.model.cars[cnx].car_id_number = 'NA';
                    } else {
                        delete this.model.cars[cnx];
                    }
                }
                if (this.model.project.customer_id > 0) {
                    this.initConstruction()
                }
            } else {    
                for ( var cn in this.model.cars ) this.model.cars[cn].car_id_number = '';
            }
        },
        initConstruction(){
            let params = {}
            if (this.model.project.customer_id > 0) params = { customer_id: this.model.project.customer_id }
            this.$http.get('/api/items', { params: params }).then((response) => {
                this.items = response.data;
            });
        },
        handleItemsListByCustomer() {
            this.checkCustomerCanPadsOnFloors()
            this.checkCustomerCanDuraLiftSheave()
            if (
                this.model.project.customer_id > 0
                && this.model.project.form_type === 'selection'
                && this.$attrs.rtype === 'construction'
            ) {
                this.initConstruction()
            }
            this.checkNoStockBySUCustomer()
        },
        checkNoStockBySUCustomer() {
            let params = { customer_id: this.user.id }
            if (this.isSU() || this.isPM()) params = { customer_id: this.model.project.customer_id }
            this.$http.post('/api/customer-no-stock', params)
                .then((response) => {
                    this.customerNoStock = response.data.no_stock
                    if (this.customerNoStock === 1) {
                        this.model.project.use_stock = 'no'
                    }
                }).catch(error => {
                console.log(error)
            })
        },
        saveCTRLInfo({cn,ctrl}){
            console.log(cn,ctrl);
            this.model.cars[cn].controller = ctrl;
            this.floorCTRL = false;
            this.subReset();
        },
        closeCTRLInfo(){
            this.floorCTRL = false;
            this.subReset();
        },
        saveDSInfo({cn,door}){
            this.model.cars[cn].door_system = door;
            this.floorDS = false;
            this.subReset();
        },
        showSP(){
            if ( 'machine_system' in this.steps && this.step == 'machine_system' ) this.checkBlankInputMachine();
            if ( !this.checkData() || this.loading ) return false;
            
            if ( this.rtype == 'modernization' && this.step == 'machine_system'  && this.model.project.machine_type != 'hydraulic' ) {
                var minfo = this.model.project.more_info;
                var linfo = this.model.project.liftnet_info;
                this.spinfo = {
                    guide_rails : this.steps.guide_rails ? true : false,
                    hoistway_components : this.steps.hoistway_components ? true : false,
                    more_info : minfo == 'TRUE' ? true : false,
                    liftnet_info : linfo == 'TRUE' ? true : false,
                };
                this.subReset();
            } else {
                this.calculate()
            }
        },
        nextSP(){
            if ( this.rtype == 'modernization' && this.step == 'machine_system' && this.model.project.machine_type != 'hydraulic' ) {
                this.showSP();
            } else {
                this.nextStep()
            }
        },
        saveSPInfo(data){
            console.log('saveSPInfo',data);
            this.spinfo = false;

            if ( data.guide_rails ) {
                this.steps.guide_rails = this.stepOrder('guide_rails');
                // gotNext = true;
            } else delete this.steps.guide_rails;

            if ( data.hoistway_components ) {
                this.steps.hoistway_components = this.stepOrder('hoistway_components');
                // gotNext = true;
            } else delete this.steps.hoistway_components;

            this.model.project.more_info = data.more_info ? 'TRUE' : 'FALSE';
            this.model.project.liftnet_info = data.liftnet_info ? 'TRUE' : 'FALSE';

            this.subReset();

            var maxstep = 1;
            if ( this.steps.wire_ropes ) ++maxstep;
            if ( this.steps.compensations ) ++maxstep;

            if ( Object.keys(this.steps).length > maxstep ) this.nextStep();
            else this.calculate();
        },
        closeDSInfo(){
            this.floorDS = false;
            this.subReset();
        },
        formatSearch(search){
            return search ? search.replace(/[‐-]/g).toLowerCase() : ''
        },
        searchItems(car){
            var items = [],
                s = car.search,
                sf = this.formatSearch(car.search)
            for (var i in this.items ) {
                var o = this.items[i];
                if ( o.item_group == car.category ) {
                    if ( sf && this.formatSearch(o.item).indexOf(sf) != -1 ) items.push(o);
                    else if ( !sf ) items.push(o);
                }
            }
            car.list = items;
            this.$set(car,'search',s+'a');
            this.$set(car,'search',s);
            this.subReset();

            return false;
        },
        typeChange(){
            var date = new Date(),
                add = this.model.project.use_stock == 'yes' ? this.lead_st : this.lead;
            date.setDate(date.getDate() + add);
            this.disabledBefore = date;

            if ( this.model.project.use_stock != 'yes' ) {
                this.model.project.start_date = '';
                this.start_date = '';
            }

            this.subReset();
        },
        startDateChange() {
            this.model.project.start_date = this.start_date;
            this.subReset();
        },
        stateChange(){
            var state = this.model.project.state,
                states_ctrl = ['Florida', 'New York', 'Pennsylvania', 'Connecticut', 'Massachusetts', 'New Jersey'];
            if ( !states_ctrl.includes(state) ) {
                this.selections[2].selectable = false;
                if ( this.steps.controller ) alert('Controller is not available for this State.');
                delete this.steps.controller;
            } else if ( !this.steps.hydraulics ) {
                this.selections[2].selectable = true;
            }
            this.subReset();
            return false;
        },
        strExt(){
            return this.model.project.phase == 'construction' ? '' : 'Existing';
        },
        addCar(){
            this.cars.push({ items: [], selection: '' });
            return false;
        },
        controllerIT(cn,ctrl){
            if ( ctrl && !ctrl.no_of_floors ) {
                alert('Please fill the number of floors first!');
                return false;
            }
            this.floorCTRL = {
                cn : cn,
                ctrl : ctrl
            };
        },
        doorIT(cn,door){
            if ( door && door.entrance != 'TRUE' ) {
                alert('No need to fill if not ordering entrances!');
                return false;
            }
            if ( door && !door.no_of_floors ) {
                alert('Please fill the number of floors first!');
                return false;
            }
            this.floorDS = {
                cn : cn,
                door : door
            };
        },
        addItem(cn,item){
            if ( !this.model.cars[cn].items ) this.model.cars[cn].items = [];
            var nqty = false,
                items = this.model.cars[cn].items;
            for ( var i in items ) {
                if ( items[i].item == item.item ) {
                    this.model.cars[cn].items[i].qty = parseInt(items[i].qty) + 1;
                    nqty = true;
                }
            }
            if ( !nqty ) {
                this.model.cars[cn].items.push({
                    item : item.item,
                    price : item.price,
                    qty : 1,
                    group_type : item.item_group,
                    item_group : item.item_group
                });
            }
            this.subReset();
        },
        removeItem(cn,i){
            this.$delete(this.model.cars[cn].items,i);
            this.subReset();
            return false;
        },
        nextStep(){
            console.log('st3p',this.step);

            var nsteps = Object.entries(this.steps).sort((a,b)=>a[1]-b[1]), // sorting
                steps = {};
            for ( var ns in nsteps ) steps[nsteps[ns][0]] = nsteps[ns][1]; // assigning the sorted
            this.steps = steps;

            var keys = Object.keys(this.steps),
                laststep = 0,
                hasMS = this.steps.machine_system ? true : false;
            for ( var k in keys ) {
                if ( k > laststep && ((this.steps[keys[k]] != 7 && this.steps[keys[k]] != 8) || !this.steps.machine_system) ) laststep = k;
            }
            this.laststep = Object.keys(this.steps)[laststep];

            var nextstep = '' 

            if ( !this.checkData() ) return false;
            if ( !this.steps || !Object.keys(this.steps).length ) {
                alert('Please Select at least 1 of the boxes.');
                return false;
            }

            if ( this.step == 'selection' ) {
                this.step = Object.keys(this.steps)[0];
                if (this.step == 'compounding_sheaves') {
                    this.handleCompoundingTypeNumbers()
                }
                this.$http.get('/api/data/constants').then(() => {
                    for(var i in this.$refs) {
                        const _el = this.$refs[i];
                        if ( Array.isArray(_el) && _el[0] ) {
                            var item = _el[0];
                            if ( !item.disabled && item.blur ) {
                                this.no_alert = true;
                                item.focus();
                                item.blur();
                            }
                        }
                    }
                });
            } else {
                var currstep = this.steps[this.step],
                    st = 0;
                for ( var s in this.steps ) {
                    console.log('stepp',this.steps[s]);
                    st = this.steps[s];
                    if ( st > currstep && (!hasMS || (hasMS && st != 7 && st != 8)) && (!nextstep || nextstep > st) ) nextstep = s;
                }


                if ( nextstep ) {
                    if ( this.step == 'machine_system' && (this.steps.controller || this.steps.compounding_sheaves) ) {
                        const api = '/api/subcalculate/machine_system';

                        this.nextloading = true;
                        this.$http
                            .post(api, this.model.cars)
                            .then((response) => {
                                console.log(response);
                                // var pit = 0;
                                if ( response.data.dsystem ) {
                                    this.datasheetSystem = Object.assign({}, response.data.dsystem)
                                    for ( var dscn in response.data.dsystem ) {
                                        var ds = response.data.dsystem[dscn];
                                        if ( this.steps.controller && this.model.cars[dscn] ) {
                                            if ( this.model.cars[dscn].ses_rope_brake == 'TRUE' ) {
                                                this.model.cars[dscn].controller.rp_mfg = ds.rope_brake_model && ds.rope_brake_model != 'NA' ? 'SES' : 'HW';
                                                this.model.cars[dscn].controller.rp_voltage = ds.rope_brake_voltage && ds.rope_brake_voltage != 'NA' ? ds.rope_brake_voltage : '';
                                            } else if ( this.model.cars[dscn].hw_rope_gripper == 'TRUE' ) {
                                                this.model.cars[dscn].controller.rp_mfg = 'HW';
                                                this.model.cars[dscn].controller.rp_voltage = '24VDC';
                                            } else {
                                                this.model.cars[dscn].controller.rp_mfg = '';
                                                this.model.cars[dscn].controller.rp_voltage = '';
                                            }
                                            this.model.cars[dscn].controller.motor_rated_voltage = ds.motor_rated_voltage;
                                            this.model.cars[dscn].controller.motor_rpm_app_rated = ds.motor_rpm_app_rated;
                                            this.model.cars[dscn].controller.motor_frequency_app_rated = ds.motor_frequency_app_rated;
                                            this.model.cars[dscn].controller.motor_power_app_rated = ds.motor_power_app_rated;
                                            this.model.cars[dscn].controller.fl_current_app_rated = ds.fl_current_app_rated;
                                            this.model.cars[dscn].controller.accel_current_app_rated = ds.accel_current_app_rated;
                                            this.model.cars[dscn].controller.pick_hold_voltage = ds.pick_hold_voltage;
                                            this.model.cars[dscn].controller.coil_resistance = ds.coil_resistance;
                                            this.model.cars[dscn].controller.em_pick_hold_voltage = ds.em_pick_hold_voltage;
                                            this.model.cars[dscn].controller.em_coil_resistance = ds.em_coil_resistance;
                                            this.model.cars[dscn].controller.number_of_ropes = ds.number_of_ropes;
                                            this.model.cars[dscn].controller.rope_size = ds.hoist_rope_diameter;
                                            this.model.cars[dscn].controller.total_travel = ds.travel;

                                            if ( ds.machine_number.includes('TSM') || ds.machine_number.includes('TMGL') ) {
                                                this.model.cars[dscn].controller.ups_lowering = 'Yes';
                                            }
                                        } else if ( this.steps.compounding_sheaves ) {
                                            if (ds.wrap === 'Double') {
                                                this.model.cars[dscn].compounding_sheaves.sheaveTypes = ['B', 'C', 'D']
                                            } else if (ds.wrap === 'Single') {
                                                this.model.cars[dscn].compounding_sheaves.sheaveTypes = ['A', 'B', 'C']
                                            }
                                            for ( var dscncs in this.model.cars[dscn].compounding_sheaves.types ) {
                                                this.model.cars[dscn].compounding_sheaves.types[dscncs].rope_size = ds.hoist_rope_diameter.replace('"','');
                                                // this.model.cars[dscn].compounding_sheaves.types[dscncs].rope_size = this.model.cars[dscn].rope_diameter;
                                                // if ( this.model.cars[dscn].existing_deflector_sheave == 'YES' ) {
                                                //     this.model.cars[dscn].compounding_sheaves.types[dscncs].groove_number = this.model.cars[dscn].number_of_ropes / (this.model.cars[dscn].double_wrap == 'TRUE' ? 2 : 1);
                                                //     pit = this.model.cars[dscn].groove_pitch * (this.model.cars[dscn].double_wrap == 'TRUE' ? 2 : 1);
                                                //     pit = pit > 2 ? 2 : pit;
                                                //     this.model.cars[dscn].compounding_sheaves.types[dscncs].pitch_in = pit;
                                                // }
                                                // this.model.cars[dscn].compounding_sheaves.types[dscncs].groove_number = ds.number_of_ropes;
                                                // this.model.cars[dscn].compounding_sheaves.types[dscncs].pitch_in = ds.machine_pitch_in;
                                                if (this.model.cars[dscn].compounding_sheaves.types[dscncs].dura_lift_sheave === null) {
                                                    this.model.cars[dscn].compounding_sheaves.types[dscncs].dura_lift_sheave = ''
                                                }
                                                if (!this.showDuraLiftSheave) {
                                                    this.model.cars[dscn].compounding_sheaves.types[dscncs].dura_lift_sheave = ''
                                                } else {
                                                    if (this.model.cars[dscn].compounding_sheaves.types[dscncs].dura_lift_sheave !== '') {
                                                        this.model.cars[dscn].compounding_sheaves.types[dscncs].sheave_type = ''
                                                        this.model.cars[dscn].compounding_sheaves.types[dscncs].location = ''
                                                        this.model.cars[dscn].compounding_sheaves.types[dscncs].rope_size = ''
                                                        this.model.cars[dscn].compounding_sheaves.types[dscncs].groove_number = ''
                                                        this.model.cars[dscn].compounding_sheaves.types[dscncs].pitch_in = ''
                                                        this.model.cars[dscn].compounding_sheaves.types[dscncs].sheave_diameter = ''
                                                        this.model.cars[dscn].compounding_sheaves.types[dscncs].max_sheave_width = ''
                                                        this.model.cars[dscn].compounding_sheaves.types[dscncs].l1 = ''
                                                        this.model.cars[dscn].compounding_sheaves.types[dscncs].l2 = ''
                                                        this.model.cars[dscn].compounding_sheaves.types[dscncs].l3 = ''
                                                        this.model.cars[dscn].compounding_sheaves.types[dscncs].l4 = ''
                                                        this.model.cars[dscn].compounding_sheaves.types[dscncs].l5 = ''
                                                        this.model.cars[dscn].compounding_sheaves.types[dscncs].l6 = ''
                                                    }
                                                    
                                                    if (this.model.cars[dscn].compounding_sheaves.types[dscncs].dura_lift_sheave !== '' && !(['8mm', '10mm'].includes(this.model.cars[dscn].rope_diameter))) {
                                                        this.model.cars[dscn].compounding_sheaves.types[dscncs].dura_lift_sheave = ''
                                                        this.model.cars[dscn].compounding_sheaves.types[dscncs].rope_size = ds.hoist_rope_diameter.replace('"','');
                                                        // this.model.cars[dscn].compounding_sheaves.types[dscncs].groove_number = ds.number_of_ropes;
                                                        // this.model.cars[dscn].compounding_sheaves.types[dscncs].pitch_in = ds.machine_pitch_in;
                                                    }
                                                }
                                                if (this.model.cars[dscn].compounding_sheaves.no_sheave === 1) {
                                                    this.model.cars[dscn].compounding_sheaves.types[dscncs].rope_size = ''
                                                    this.model.cars[dscn].compounding_sheaves.types[dscncs].groove_number = ''
                                                    this.model.cars[dscn].compounding_sheaves.types[dscncs].pitch_in = ''
                                                } else {
                                                    if (this.model.cars[dscn].bedplate == 'FALSE' && this.model.cars[dscn].deflector == 'TRUE') {
                                                        if (ds.wrap === 'Double') {
                                                            this.model.cars[dscn].compounding_sheaves.types[dscncs].sheave_type = 'D'
                                                        } else if (ds.wrap === 'Single') {
                                                            this.model.cars[dscn].compounding_sheaves.types[dscncs].sheave_type = 'A'
                                                        }
                                                    }
                                                    this.sheaveChange(dscn, 'compounding_sheaves', 'sheave_type', dscncs)
                                                }
                                            }
                                        }
                                    }
                                }
                                this.step = nextstep;
                                this.nextloading = false;
                                this.checkIfDisabled(nextstep);
                            })
                            .catch((error) => {
                                if ( error.response && error.response.data ) {
                                    alert('ERROR: '+error.response.data.message);
                                }
                                this.step = nextstep;
                                this.nextloading = false;
                                this.checkIfDisabled(nextstep);
                            });
                            if (nextstep == 'compounding_sheaves') {
                                this.handleCompoundingTypeNumbers()
                            }
                    } else if ( nextstep == 'door_system' ) {
                        var dscar = {};
                        for( var dscnn in this.model.cars ) {
                            dscar = this.model.cars[dscnn].door_system;
                            if ( dscar.entrance != 'TRUE' && dscar.landing != 'TRUE' && dscar.door_op != 'TRUE' && dscar.light_curtain != 'TRUE' ) {
                                this.model.cars[dscnn].door_system.landing = 'TRUE';
                                this.model.cars[dscnn].door_system.door_op = 'TRUE';
                                this.subChange(dscnn,'door_system','door_op_fr_landing_qty');
                                this.subChange(dscnn,'door_system','door_op_rear_landing_qty');
                            }
                        }
                        this.step = nextstep;
                    } else if ( this.step == 'door_system' && nextstep == 'controller' ) {
                        const api = '/api/subcalculate/door_system';

                        this.nextloading = true;
                        this.$http
                            .post(api, this.model.cars)
                            .then((response) => {
                                console.log(response);
                                if ( response.data.osystem ) {
                                    for ( var dscn in response.data.osystem ) {
                                        var ds = response.data.osystem[dscn];
                                        if ( this.model.cars[dscn] ) {
                                            this.model.cars[dscn].controller.no_of_floors = ds.no_of_floors;
                                            this.model.cars[dscn].controller.no_of_openings = ds.no_of_openings;
                                            this.model.cars[dscn].controller.door_type = 'Master Door'; //ds.door_type;
                                            this.model.cars[dscn].controller.door_cam_type = ds.door_cam_type;
                                            this.model.cars[dscn].controller.door_cam_voltage = ds.door_cam_voltage;
                                            this.model.cars[dscn].controller.door_cam_volt_type = ds.door_cam_volt_type;
                                            this.model.cars[dscn].controller.door_op_mfg = ds.door_op_mfg;
                                            this.model.cars[dscn].controller.door_motor_model = ds.door_motor_model;
                                            this.model.cars[dscn].controller.door_motor_supp_volt = ds.door_motor_supp_volt;
                                            this.model.cars[dscn].controller.door_motor_supp_acdc = ds.door_motor_supp_acdc;
                                            this.model.cars[dscn].controller.door_motor_supp_phase = ds.door_motor_supp_phase+'ph';
                                        }
                                    }
                                }
                                this.step = nextstep;
                                this.nextloading = false;
                            })
                            .catch((error) => {
                                alert('ERROR: '+error.response.data.message);
                                this.step = nextstep;
                                this.nextloading = false;
                            });
                    } else if ( nextstep == 'machine_system' && this.model.project.is_final == 'yes' ) {
                        this.typeChange();
                        this.step = nextstep;
                        this.checkIfDisabled(nextstep);
                    } else if ( nextstep == 'compounding_sheaves' ) {
                        this.step = nextstep;
                        for ( var ccn in this.model.cars ) {
                            this.subChange(ccn, 'compounding_sheaves', 'type_number');
                        }
                        this.checkIfDisabled(nextstep);
                    } else {
                        this.step = nextstep;
                        this.checkIfDisabled(nextstep);
                    }
                    if ( 'machine_system' in this.steps && 'hoistway_components' in this.steps && nextstep == 'hoistway_components' ) {
                        console.log('hoistway nextstep', nextstep)
                        for ( var hwcn in this.model.cars ) {
                            this.model.cars[hwcn].hoistway_components.speed = this.model.cars[hwcn].speed;
                            this.model.cars[hwcn].hoistway_components.capacity = this.model.cars[hwcn].capacity;
                            this.model.cars[hwcn].hoistway_components.empty_car_weight = this.model.cars[hwcn].empty_car_weight;
                            this.model.cars[hwcn].hoistway_components.counterweight = this.model.cars[hwcn].counterweight;
                        }
                    }
                } else {
                    console.log('no next step');
                    // this.checkIfDisabled();
                }
            }

            console.log( 'obj', Object.keys(this.steps)[0] );
            console.log('st3p2',this.step);
            console.log( 'nextstep', nextstep );
            console.log( this.step, nextstep );
            console.log( 'steps', this.steps );
            console.log( 'laststep', this.laststep );

            this.checkIfDisabled(nextstep);
        },
        backStep(){
            this.showDS = false;
            this.$emit('modChange',false);
            var currstep = this.steps[this.step],
                prevstep = 0;
            console.log('currstep',currstep);
            for ( var s in this.steps ) {
                if ( this.steps[s] <= currstep - 1 ) {
                    if ( this.steps['machine_system'] ) {
                        if ( this.steps[s] < 7 ) prevstep = s;
                    } else {
                        prevstep = s;
                    }
                }
            }
            if ( prevstep ) {
                this.step = prevstep;
                this.checkIfDisabled(prevstep);
            } else if ( !currstep ) {
                this.step = this.laststep;
                this.checkIfDisabled(this.laststep);
            } else this.step = 'selection';

        },
        stepOrder(stepkey){
            for ( var s in this.selections ) {
                if ( this.selections[s].key == stepkey ) return this.selections[s].order;
            }
            return 0;
        },
        fReset(){
            var pname = this.model.project.project_name;
            this.$set(this.model.project,'project_name',pname+'w');
            this.$set(this.model.project,'project_name',pname);
        },
        stepChange(stepkey, event){
            if ( event.target.checked ) {
                this.steps[stepkey] = this.stepOrder(stepkey);
                if ( this.rtype == 'modernization' && this.model.project.machine_type != 'hydraulic' ) this.steps['machine_system'] = this.stepOrder('machine_system');
                if (stepkey === 'compounding_sheaves') this.isOtherSheaveCheckedDefault = true
                switch(stepkey) {

                    case 'controller':
                    case 'machine_system':
                        if (this.rtype === 'construction') {
                            if ( this.model.project.machine_type === 'hydraulic' ) {
                                this.model.project.machine_type = 'traction';
                                this.machChange()
                            }
                        }
                        if ( this.user.wire_rope ) this.steps['wire_ropes'] = this.stepOrder('wire_ropes');
                        this.selections[6].selectable = true;
                        if ( this.user.wire_rope ) this.steps['compensations'] = this.stepOrder('compensations');
                        this.selections[7].selectable = true;
                        // this.steps['compounding_sheaves'] = this.stepOrder('compounding_sheaves');
                        // this.selections[8].selectable = false;

                        this.steps['machine_system'] = this.stepOrder('machine_system');
                        this.checkCustomerCanPadsOnFloors()
                        this.checkCustomerCanDuraLiftSheave()
                        // delete this.steps['hydraulics'];
                        // this.selections[5].selectable = false;

                        break;

                    case 'hydraulics':
                        // this.selections[0].selectable = false;
                        // this.selections[2].selectable = false;
                        // this.selections[6].selectable = true;
                        // this.selections[7].selectable = true;
                        // this.selections[8].selectable = true;
                        // delete this.steps['machine_system'];
                        // delete this.steps['controller'];
                        break;
                }
            } else {
                if (stepkey === 'compounding_sheaves') this.isOtherSheaveCheckedDefault = false
                switch(stepkey) {

                    case 'machine_system':
                        // this.selections[5].selectable = true;
                        this.selections[6].selectable = true;
                        this.selections[7].selectable = true;
                        this.selections[8].selectable = true;
                        this.checkCustomerCanPadsOnFloors()
                        this.checkCustomerCanDuraLiftSheave()
                        delete this.steps['controller'];
                        break;

                    case 'hydraulics':
                        // this.selections[0].selectable = true;
                        // this.selections[2].selectable = true;
                        // this.stateChange();
                        break;

                    default:
                        break;
                }

                delete this.steps[stepkey];
            }
            
            var nsteps = Object.entries(this.steps).sort((a,b)=>a[1]-b[1]), // sorting
                steps = {};
            for ( var s in nsteps ) steps[nsteps[s][0]] = nsteps[s][1]; // assigning the sorted

            this.steps = steps;

            this.fReset();
            return false;
        },
        selectAll(){
            if ( this.select_all ) {
                var steps = { machine_system : 1, wire_ropes : 7 , compensations : 8 };
                for ( var s in this.selections ) {
                    const key = this.selections[s].key,
                        order = this.selections[s].order;
                    if ( this.selections[s].selectable ) steps[key] = order;
                }
                this.steps = steps;
            } else {
                this.steps = this.rtype == 'construction' ? {} : { machine_system : 1, wire_ropes : 7 , compensations : 8 };
            }
            this.fReset();
        },
        getNow(){
            const today = new Date();
            const m = today.getMonth()+1;
            const month = m < 10 ? '0'+m : m;
            const d = today.getDate();
            const day = d < 10 ? '0'+d : d;
            const date = today.getFullYear()+'-'+month+'-'+day;
            
            this.model.cars[1] = this.blank;
            this.model.project.date_of_survey = date;
        },
        fsubChange(key,cn,v){
            var _car = this.model.cars[cn];
            _car[key] = v;
            this.carChange(key,cn);
        },
        carChange(key,cn, onGetProject = false){
            var _car = this.model.cars[cn];
                    console.log(key, _car[key]);

            let acceleration;

            switch(key) {
                case 'vac': {
                    _car[`vac${this.defaultPostFix}`] = false;
                    break;
                }
                case 'encoder_cable': {
                    _car[`encoder_cable${this.defaultPostFix}`] = false;
                    break;
                }
                case 'bedplate':
                    if ( _car[key] == 'FALSE' ) {
                        var goEmpty = [
                            'rope_drop_distance',
                            'rope_to_machine_wall',
                            'machine_room_height_clearance',
                            'wf_beam_width',
                            'ww_beam_height',
                            'z1',
                            'z2',
                            'angled_bedplate',
                            'existing_machine_beam_location',
                            'ct',
                            'existing_deflector_sheave'
                        ];

                        _car.rope_guard = 'FALSE';
                        if (this.showPadsOnFloors) _car.pads_on_floors = 'FALSE';
                        // _car.deflector = 'FALSE';

                        if ( _car.machine_location == 'BASEMENT') {
                            _car.basement_bedplate = 'no';
                        } else _car.basement_bedplate = '';

                        _car.basement_layout = '';
                        _car.basement_config = '';
                        _car.basement_pattern = '';
                        _car.basement_anchor = '';
                        _car.basement_thread = '';
                        _car.basement_sheave_diameter = '';
                        _car.basement_rope_diameter = '';
                        _car.basement_rope_number = '';
                        _car.basement_pitch = '';
                        _car.basement_bedplate = '';
                        _car.basement_rd = '';
                        _car.basement_df1 = '';
                        _car.basement_df2 = '';
                        _car.basement_df3 = '';
                        _car.basement_df4 = '';
                        _car.basement_mr1 = '';
                        _car.basement_mr2 = '';
                        _car.basement_mr3 = '';
                        _car.basement_mr4 = '';

                        if ( _car.machine_location == 'MRL') goEmpty.push('right_left_machine');
                        for(var i in goEmpty ) _car[goEmpty[i]] = '';
                        this.carChange('angled_bedplate',cn);
                        this.carChange('existing_deflector_sheave',cn, onGetProject);
                        if (this.showPadsOnFloors) this.carChange('pads_on_floors',cn);
                    } else {
                        if ( _car.machine_location == 'BASEMENT') _car.basement_bedplate = 'yes';
                        else _car.basement_bedplate = '';
                    }
                    this.carChange('deflector',cn, onGetProject);
                    break;

                case 'basement_bedplate':
                    _car.bedplate = _car[key] == 'yes' ? 'TRUE' : 'FALSE';
                    break;

                case 'drive_manufacturer':
                    if ( _car.drive_manufacturer && _car.drive_manufacturer.includes('No Cable Supplied') ) {
                        _car.encoder = 'FALSE';
                        _car.encoder_cable = '';
                    }
                    if ( _car.gear && _car.drive_manufacturer && this.enc_cables && this.enc_cables[_car.gear] ) {
                        if ( !this.enc_cables[_car.gear]['All'] && !this.enc_cables[_car.gear][_car.drive_manufacturer] ) {
                            _car.encoder_cable = '';
                            // _car.encoder = 'FALSE';
                        }
                        if (_car.gear == 'TRUE' && this.enc_cables[_car.gear]['All'] && !onGetProject && _car.encoder == 'TRUE') {
                            if ( _car.drive_manufacturer !== 'Schindler') _car['encoder_cable'] = this.enc_cables[_car.gear]['All'][0];
                            if ( _car.drive_manufacturer === 'Schindler') _car['encoder_cable'] = '';
                        } else if (_car.gear == 'FALSE' && this.enc_cables[_car.gear][_car.drive_manufacturer] && !onGetProject && _car.encoder == 'TRUE') {
                            _car['encoder_cable'] = this.enc_cables[_car.gear][_car.drive_manufacturer][0];
                        } else if (_car.gear == 'FALSE' && _car.drive_manufacturer == 'None Selected' && this.enc_cables[_car.gear]['KEB'] && !onGetProject && _car.encoder == 'TRUE') {
                            // if drive manufacturer is None Selected, use KEB logic
                            _car['encoder_cable'] = this.enc_cables[_car.gear]['KEB'][0];
                        }
                    }
                    if (_car.gear && !_car.drive_manufacturer && this.model.project.is_final == 'no' && !onGetProject) {
                        _car[`encoder_cable${this.defaultValuePostFix}`] = this.enc_cables['FALSE']['KEB'][0];
                        // this.hidableRows.encoder_cable = false
                        // if ( _car['gear'] == 'FALSE' ) _car[`encoder_cable${this.defaultValuePostFix}`] = this.enc_cables[_car.gear]['KEB'][0];
                        // if ( _car['gear'] != 'FALSE' ) _car[`encoder_cable${this.defaultValuePostFix}`] = this.enc_cables[_car.gear]['All'][0];
                    }
                    if (_car.drive_manufacturer && this.model.project.is_final == 'no' && !onGetProject) {
                        delete _car[`encoder_cable${this.defaultValuePostFix}`]
                    }
                    _car[`drive_manufacturer${this.defaultPostFix}`] = false;
                    break;

                case 'gear':
                    if ( _car[key] != 'FALSE' || _car.machine_location != 'OHMR' ) {
                        if (!onGetProject) {
                            _car.onsite_assembly = '';
                        }
                    }
                    if ( _car[key] != 'FALSE' ) {
                        _car.double_wrap = 'FALSE';
                    }
                    if ( _car[key] == 'FALSE' ) {
                        _car.counterweight = _car.machine_location == 'MRL' ? '50' : '45';
                        _car[`counterweight${this.defaultValuePostFix}`] = _car.counterweight;
                        _car[`counterweight${this.defaultPostFix}`] = false;
                    } else if ( _car[key] == 'TRUE' ) {
                        _car.counterweight = '40';
                        _car[`counterweight${this.defaultValuePostFix}`] = _car.counterweight;
                        _car[`counterweight${this.defaultPostFix}`] = false;
                    }
                    if ( _car.gear && _car.drive_manufacturer ) {
                        if ( !this.enc_cables[_car.gear]['All'] && !this.enc_cables[_car.gear][_car.drive_manufacturer] ) {
                            // _car.encoder = 'FALSE';
                            _car.encoder_cable = '';
                        }
                        if (this.enc_cables[_car.gear] && !onGetProject && _car.encoder == 'TRUE') {
                            if (_car[key] == 'TRUE' && this.enc_cables[_car[key]]['All']) {
                                if (_car.drive_manufacturer !== 'Schindler') _car['encoder_cable'] = this.enc_cables[_car[key]]['All'][0];
                                if (_car.drive_manufacturer === 'Schindler') _car['encoder_cable'] = '';
                            } else if (_car[key] == 'FALSE' && this.enc_cables[_car[key]][_car.drive_manufacturer]) {
                                _car['encoder_cable'] = this.enc_cables[_car[key]][_car.drive_manufacturer][0];
                            } else if (_car[key] == 'FALSE' && this.enc_cables[_car[key]]['KEB'] && _car.drive_manufacturer == 'None Selected') {
                                // if drive manufacturer is None Selected, use KEB logic
                                _car['encoder_cable'] = this.enc_cables[_car[key]]['KEB'][0];
                            }
                        }
                    } else if (_car.gear && !_car.drive_manufacturer && this.model.project.is_final == 'no' && !onGetProject) {
                        _car[`encoder_cable${this.defaultValuePostFix}`] = this.enc_cables['FALSE']['KEB'][0];
                        // if ( _car[key] == 'FALSE' ) _car[`encoder_cable${this.defaultValuePostFix}`] = this.enc_cables[_car[key]]['KEB'][0];
                        // if ( _car[key] != 'FALSE' ) _car[`encoder_cable${this.defaultValuePostFix}`] = this.enc_cables[_car[key]]['All'][0];
                    }
                    if (_car.drive_manufacturer && this.model.project.is_final == 'no' && !onGetProject) {
                        delete _car[`encoder_cable${this.defaultValuePostFix}`]
                    }
                    break;

                case 'angled_bedplate':
                    if ( _car[key] != 'No' ) {
                        _car.angle_profile = '';
                        _car.car_rope_x1 = '';
                        _car.car_rope_x2 = '';
                        _car.car_rope_x3 = '';
                    } 
                    // else {
                    // _car.existing_deflector_sheave = 'NO';
                    // this.carChange('existing_deflector_sheave',cn);
                    // }
                    break;

                case 'deflector':
                    if ( _car[key] == 'TRUE' && _car.existing_deflector_sheave == 'YES' ) {
                        if ( this.step == 'machine_system' ) {
                            _car.existing_deflector_sheave = 'NO';
                            alert('"Keep Existing Deflector or Replace with New?" has set to "Replace Deflector".');
                            this.carChange('existing_deflector_sheave',cn, onGetProject);
                        } else {
                            _car.deflector = 'FALSE';
                        }
                    }
                    if (_car[key] == 'FALSE' && _car['machine_location'] == 'OHMR' && _car['bedplate'] == 'TRUE') {
                        // _car.existing_deflector_sheave = 'YES'; // Retain
                        // if (!onGetProject) _car.deflector_in_overhead = 'Yes';
                        if (!onGetProject && this.model.project.is_final == 'yes') _car.existing_deflector_sheave = 'YES'; // Retain
                        if (!onGetProject && this.model.project.is_final == 'yes') _car.deflector_in_overhead = 'Yes';
                    } else if (_car[key] == 'TRUE' && _car['machine_location'] == 'OHMR' && _car['bedplate'] == 'TRUE') {
                        // _car.existing_deflector_sheave = 'NO'; // Replace
                        // if (!onGetProject) _car.deflector_in_overhead = 'No';
                        if (!onGetProject && this.model.project.is_final == 'yes') _car.deflector_in_overhead = '';
                    }
                    if (this.selections[0].key in this.steps) {
                        let stepReset = false;
                        let shouldCheckSheave = [];
                        for (let carCn in this.model.cars) {
                            if (
                                this.model.cars[carCn].machine_location == 'OHMR' &&
                                this.model.cars[carCn].deflector == 'TRUE' &&
                                this.model.cars[carCn].bedplate == 'FALSE'
                                ) {
                                    shouldCheckSheave.push(true)
                                    this.forceOtherSheaveChecked = true
                                    this.selections[8].selectable = false
                                    break;
                            } else shouldCheckSheave.push(false)
                        }
                        if (!(shouldCheckSheave.includes(true))) {
                            this.selections[8].selectable = true
                            this.forceOtherSheaveChecked = false
                        }
                        if (_car[key] === 'TRUE' && _car['bedplate']  === 'FALSE') {
                            _car['sheave'] = 'TRUE';
                            this.steps.compounding_sheaves = this.stepOrder('compounding_sheaves');
                            stepReset = true;
                            this.laststep = this.selections[8].key;
                        } else if (_car[key] === 'TRUE' && _car['bedplate']  === 'TRUE') {
                            _car['sheave'] = 'FALSE';
                            if (!(this.isOtherSheaveCheckedDefault) && !(this.forceOtherSheaveChecked) && this.selections[8].key in this.steps) {
                                delete this.steps.compounding_sheaves;
                                stepReset = true;
                                this.laststep = this.selections[0].key;
                            }
                        } else if (_car[key] === 'FALSE' && _car['bedplate']  === 'FALSE') {
                            _car['sheave'] = 'FALSE';
                            if (!(this.isOtherSheaveCheckedDefault) && !(this.forceOtherSheaveChecked) && this.selections[8].key in this.steps) {
                                delete this.steps.compounding_sheaves;
                                stepReset = true;
                                this.laststep = this.selections[0].key;
                            }
                        }
                        if (stepReset) {
                            var nsteps = Object.entries(this.steps).sort((a,b)=>a[1]-b[1]), // sorting
                                stepss = {};
                            for ( var s in nsteps ) {
                                stepss[nsteps[s][0]] = nsteps[s][1]; // assigning the sorted
                            }
                            this.steps = stepss;
                        }
                    }
                    
                    break;

                case 'existing_deflector_sheave':
                    // YES = Retain Deflector, NO = Replace Deflector
                    if ( _car[key] != 'YES' ) {
                        _car.deflector_sheave_diameter = '';
                        _car.number_of_ropes = '';
                        _car.groove_pitch = '';
                        _car.ys = '';
                    } else if ( _car[key] == 'YES' && _car.deflector == 'TRUE') {
                        alert('Deflector has been removed.');
                        _car.deflector = 'FALSE';
                    }
                    if ( _car['machine_location'] == 'OHMR' && _car[key] == 'NO') {
                        _car.deflector = 'TRUE';
                        // if (!onGetProject) _car.deflector_in_overhead = '';
                    } else if ( _car['machine_location'] == 'OHMR' &&  _car[key] == 'YES') {
                        if (!onGetProject) _car.deflector = 'FALSE';
                        // if (!onGetProject) _car.deflector_in_overhead = 'Yes';
                        if (!onGetProject && this.model.project.is_final == 'yes') _car.deflector_in_overhead = 'Yes';
                    }
                    break;

                case 'machine_location':
                    if ( _car[key] == 'MRL' ) {
                        _car.gear = 'FALSE';

                        _car.bedplate = 'FALSE';
                        _car.deflector = 'FALSE';
                        _car.rope_guard = 'FALSE';
                        _car.encoder = 'TRUE';
                        _car.sheave = 'TRUE';

                        if (!this.$route.params.id) {
                            _car.roping = 2;
                        }
                        _car.hw_rope_gripper = 'FALSE';
                        _car.hw_rope_gripper_model = '';
                        _car.ses_rope_brake = 'FALSE';
                        _car.right_left_machine = '';
                        _car.outside_rope = '';
                        _car.noS2 = true;
                        if (!onGetProject) {
                            _car.encoder_cable = '';
                            // _car[`encoder_cable${this.defaultValuePostFix}`] = _car.encoder_cable;
                        }

                        if ( _car['gear'] == 'FALSE' && (!onGetProject)) {
                            _car.counterweight = '50';
                            _car[`counterweight${this.defaultValuePostFix}`] = _car.counterweight;
                            _car[`counterweight${this.defaultPostFix}`] = false;
                        } else if ( _car['gear'] == 'TRUE' && (!onGetProject)) {
                            _car.counterweight = '40';
                            _car[`counterweight${this.defaultValuePostFix}`] = _car.counterweight;
                            _car[`counterweight${this.defaultPostFix}`] = false;
                        }

                        this.carChange('bedplate',cn);
                    } else if ( _car[key] == 'BASEMENT' ) {
                        if (!onGetProject) {
                            // _car.bedplate = this.model.project.phase != 'construction' ? 'TRUE' : 'FALSE';
                            _car.bedplate = 'FALSE';
                        }
                        _car.encoder = 'TRUE';
                        _car.rope_guard = 'FALSE';
                        _car.deflector = 'FALSE';
                        _car.sheave = 'FALSE';
                        _car.noS2 = true;

                        
                        if (!onGetProject) {
                            _car.basement_layout = '';
                        }
                        _car.machine_shape = '';
                        _car.tpm_flat_mount = '';
                        
                        this.carChange('sheave',cn);
                    } else {
                        if (!onGetProject) {
                          _car.bedplate = 'TRUE';
                          _car.rope_guard = 'TRUE';
                          _car.deflector = 'TRUE';
                          _car.encoder = 'TRUE';
                          _car.existing_deflector_sheave = '';
                          _car.deflector_in_overhead = '';
                          _car.angled_bedplate = '';
                            // this.carChange('deflector',cn);
                        }

                        _car.sheave = 'FALSE';
                        _car.outside_rope = '';
                        _car.noS2 = false;
                        _car.machine_shape = '';
                        _car.tpm_flat_mount = '';
                        _car.basement_layout = '';

                        this.carChange('sheave',cn);
                    }
                    if ( _car[key] != 'BASEMENT' ) {
                        _car.basement_layout = '';
                        _car.basement_config = '';
                        _car.basement_pattern = '';
                        _car.basement_anchor = '';
                        _car.basement_thread = '';
                        _car.basement_sheave_diameter = '';
                        _car.basement_rope_diameter = '';
                        _car.basement_rope_number = '';
                        _car.basement_pitch = '';
                        _car.basement_bedplate = '';
                        _car.basement_rd = '';
                        _car.basement_df1 = '';
                        _car.basement_df2 = '';
                        _car.basement_df3 = '';
                        _car.basement_df4 = '';
                        _car.basement_mr1 = '';
                        _car.basement_mr2 = '';
                        _car.basement_mr3 = '';
                        _car.basement_mr4 = '';
                    }
                    if ( _car[key] != 'OHMR' ) {
                        _car.rope_drop_distance = '';
                        _car.rope_to_machine_wall = '';
                        _car.machine_room_height_clearance = '';
                        _car.wf_beam_width = '0';
                        _car.ww_beam_height = '0';
                        _car.z1 = '0';
                        _car.z2 = '0';
                        _car.angled_bedplate = '';
                        _car.angle_profile = '';
                        _car.car_rope_x1 = '';
                        _car.car_rope_x2 = '';
                        _car.car_rope_x3 = '';
                        _car.existing_machine_beam_location = '';
                        _car.ct = '';
                        _car.existing_deflector_sheave = '';
                        _car.deflector_in_overhead = '';
                        _car.deflector_sheave_diameter = '';
                        _car.number_of_ropes = '';
                        _car.groove_pitch = '';
                        _car.ys = '';
                        _car.double_wrap = 'FALSE';
                    }

                    if ( _car[key] != 'FALSE' || _car.machine_location != 'OHMR' ) {
                        if (!onGetProject) {
                            _car.onsite_assembly = '';
                        }
                    }
                    break;

                case 'rope_diameter':
                    if ( _car.bedplate == 'TRUE' && _car.machine_location == 'BASEMENT' ) {
                        _car.basement_rope_diameter = _car[key];
                    }
                    if (_car[key] === 'Unknown') {
                        _car.rope_diameter_required = 'N';
                    }
                    _car[`rope_diameter${this.defaultPostFix}`] = false;
                    break;

                case 'basement_rope_diameter':
                    _car.rope_diameter = _car[key];
                    break;

                case 'encoder':
                    if ( _car[key] != 'TRUE' ) _car.encoder_cable = '';
                    else if (_car[key] == 'TRUE') this.carChange('drive_manufacturer', cn);
                    break;

                case 'existing_machine_beam_location':
                    if ( _car[key] == 'E' ) {
                        _car.wf_beam_width = '0';
                        _car.ww_beam_height = '0';
                        _car.z1 = '0';
                        _car.z2 = '0';
                    }
                    break;

                case 'double_wrap':
                    if ( _car[key] == 'TRUE' ) _car.gear = 'FALSE';
                    _car[`double_wrap${this.defaultPostFix}`] = false;
                    break;

                case 'sheave':
                    if ( _car.sheave != 'TRUE' ) {
                        _car.ss_car_side = '';
                        _car.ss_cwt_side = '';
                        _car.ss_car_side_qty = '';
                        _car.ss_cwt_side_qty = '';

                        _car.appendix_car_shaft = '';
                        _car.appendix_cwt_shaft = '';
                        _car.appendix_car_l1 = '';
                        _car.appendix_car_l2 = '';
                        _car.appendix_car_l3 = '';
                        _car.appendix_car_l4 = '';
                        _car.appendix_car_l5 = '';
                        _car.appendix_car_l6 = '';
                        _car.appendix_cwt_l1 = '';
                        _car.appendix_cwt_l2 = '';
                        _car.appendix_cwt_l3 = '';
                        _car.appendix_cwt_l4 = '';
                        _car.appendix_cwt_l5 = '';
                        _car.appendix_cwt_l6 = '';
                        _car.appendix_car_max_allow_sheave_width = '';
                        _car.appendix_cwt_max_allow_sheave_width = '';
                    }
                    break;

                case 'capacity':
                    if ( _car.ecwsel != 'Other' && _car[key] !== 'Other') {
                        // _car.ecwsel = _car.ecwsel != 'Other' && _car.ecwsel != _car.capacity*1.5 ? 'Other' : _car.ecwsel;
                        _car.ecwsel = _car.ecwsel != _car.capacity*1.5 ? _car.capacity*1.5 : 'Other';
                        this.carChange('ecwsel',cn);
                    }
                    break;

                case 'capacitysel':
                    _car.capacity = _car[key] === 'Other' ? '' : _car[key];
                    this.carChange('capacity',cn);
                    break;

                case 'speedsel':
                    _car.speed = _car[key] === 'Other' ? '' : _car[key];
                    this.carChange('speed',cn);
                    break;

                case 'ecwsel':
                    _car.empty_car_weight = _car[key] === 'Other' ? '' : _car[key];
                    this.carChange('empty_car_weight',cn);
                    break;

                case 'speed':
                    acceleration = this.getAcceleration(_car[key]);

                    if(acceleration) {
                        _car.acceleration = acceleration;
                        _car[`acceleration${this.defaultValuePostFix}`] = acceleration;
                    }

                    break;

                case 'acceleration':
                    // if ( _car[key] < 2 ) _car.acceleration = 2;
                    // if ( _car[key] > 5 ) _car.acceleration = 5;
                    _car[`acceleration${this.defaultPostFix}`] = false;
                    break;

                case 'travel':
                    if ( _car[key] > 300 ) {
                        _car.double_wrap = 'TRUE';
                        this.carChange('double_wrap',cn);
                    }
                    break;

                case 'compensation':
                    if ( _car[key] < 0 ) _car[key] = 0;
                    if ( _car[key] > 20 ) _car[key] = 20;
                    break;
                case 'weight_comp_sheave':
                    _car[`weight_comp_sheave${this.defaultPostFix}`] = false;
                    break;

                case 'ss_car_side_qty':
                case 'ss_cwt_side_qty':
                    if ( _car[key] < 1 ) _car[key] = 1;
                    if ( _car[key] > 9 ) _car[key] = 9;
                    break;

                case 'empty_car_weight':
                    // if ( _car[key] < 1000 ) _car[key] = 1000;
                    // if ( _car[key] > 50000 ) _car[key] = 50000;
                    _car[`empty_car_weight${this.defaultValuePostFix}`] = _car['capacity'] * 1.5;
                    _car[`empty_car_weight${this.defaultPostFix}`] = false;
                    break;

                // case 'outside_rope':
                //     if ( _car[key] < 0 ) _car[key] = 0;
                //     if ( _car[key] > 99 ) _car[key] = 99;
                //     break;

                case 'rope_drop_distance':
                    if ( parseFloat(_car['car_rope_x1']) > 0 && parseFloat(_car['car_rope_x1']) <= parseFloat(_car['rope_drop_distance']) ) {
                        alert('Car Rope Wall (X1) must be larger than Rope Drop Distance');
                        _car[key] = '';
                    }
                    break;

                case 'car_rope_x1':
                    if ( parseFloat(_car['rope_drop_distance']) > 0 && parseFloat(_car['car_rope_x1']) <= parseFloat(_car['rope_drop_distance']) ) {
                        alert('Car Rope Wall (X1) must be larger than Rope Drop Distance');
                        _car[key] = '';
                    }
                    break;

                // case 'rope_to_machine_wall':
                //     if ( _car[key] < 0 ) _car[key] = 0;
                //     if ( _car[key] > 99 ) _car[key] = 99;
                //     break;

                // case 'machine_room_height_clearance':
                //     if ( _car[key] < 0 ) _car[key] = 0;
                //     if ( _car[key] > 300 ) _car[key] = 300;
                //     break;

                // case 'wf_beam_width':
                //     if ( _car[key] < 0 ) _car[key] = 0;
                //     if ( _car[key] > 20 ) _car[key] = 20;
                //     break;

                // case 'ww_beam_height':
                //     if ( _car[key] < 0 ) _car[key] = 0;
                //     if ( _car[key] > 20 ) _car[key] = 20;
                //     break;

                // case 'z1':
                //     if ( _car[key] < 0 ) _car[key] = 0;
                //     if ( _car[key] > 50 ) _car[key] = 50;
                //     break;

                // case 'z2':
                    // if ( _car[key] < 0 ) _car[key] = 0;
                    // if ( _car[key] > 50 ) _car[key] = 50;
                    // if ( _car[key] > 72 - _car.z1 ) _car[key] = 72 - _car.z1;
                    // break;

                case 'counterweight':
                    // if ( _car[key] < 40 ) _car[key] = 40;
                    // if ( _car[key] > 50 ) _car[key] = 50;
                    _car[`counterweight${this.defaultPostFix}`] = false;
                    break;

                // case 'car_rope_x1':
                case 'appendix_car_max_allow_sheave_width':
                case 'appendix_cwt_max_allow_sheave_width':
                case 'appendix_car_shaft':
                    if(_car[key] != 'B') {
                        _car.appendix_car_l5 = '';
                        _car.appendix_car_l6 = '';
                    }
                    break;
                case 'appendix_cwt_shaft':
                    if(_car[key] != 'B') {
                        _car.appendix_cwt_l5 = '';
                        _car.appendix_cwt_l6 = '';
                    }
                    break;
                case 'appendix_car_l1':
                case 'appendix_cwt_l1':
                case 'appendix_car_l2':
                case 'appendix_cwt_l2':
                case 'appendix_car_l3':
                case 'appendix_cwt_l3':
                case 'appendix_car_l4':
                case 'appendix_cwt_l4':
                case 'appendix_car_l5':
                case 'appendix_cwt_l5':
                case 'appendix_car_l6':
                case 'appendix_cwt_l6':
                case 'deflector_sheave_diameter':
                    // if ( _car[key] < 0 ) _car[key] = 0;
                    // if ( _car[key] > 99 ) _car[key] = 99;
                    break;

                // case 'number_of_ropes':
                // case 'ys':
                // case 'ct':
                //     if ( _car[key] < 0 ) _car[key] = 0;
                //     if ( _car[key] > 20 ) _car[key] = 20;
                //     break;

                // case 'groove_pitch':
                //     if ( _car[key] < 0 ) _car[key] = 0;
                //     if ( _car[key] > 9 ) _car[key] = 9;
                //     break;

                case 'tdi_emergency_brake':
                    if ( _car[key] == 'TRUE' && (_car['ses_rope_brake'] == 'TRUE' || _car['hw_rope_gripper'] == 'TRUE') )
                        alert('Two emergency brakes are selected');
                    break;
                case 'ses_rope_brake':
                    if ( _car[key] == 'TRUE' ) {
                        _car.controller.rp_mfg = 'SES';
                        _car.hw_rope_gripper = 'FALSE';
                        if ( _car['tdi_emergency_brake'] == 'TRUE' )
                            alert('Two emergency brakes are selected');
                    } else if ( _car.hw_rope_gripper == 'FALSE' ) {
                        _car.controller.rp_mfg = '';
                        _car.hw_rope_gripper_model = '';
                    }
                    break;

                case 'hw_rope_gripper':
                    if ( _car[key] == 'TRUE' ) {
                        _car.controller.rp_mfg = 'HW';
                        _car.ses_rope_brake = 'FALSE';
                        if ( _car['tdi_emergency_brake'] == 'TRUE' )
                            alert('Two emergency brakes are selected');
                    } else if ( _car.ses_rope_brake == 'FALSE' ) {
                        _car.controller.rp_mfg = '';
                        _car.hw_rope_gripper_model = '';
                    }
                    break;

                case 'basement_layout':
                case 'basement_config':
                    _car.basement_layout = _car[key];
                    _car.basement_config = _car.bedplate == 'TRUE' ? _car[key] : '';
                    _car.basement_mr1 = '';
                    _car.basement_mr2 = '';
                    _car.basement_mr3 = '';
                    _car.basement_mr4 = '';
                    _car.basement_df1 = '';
                    _car.basement_df2 = '';
                    _car.basement_df3 = '';
                    _car.basement_df4 = '';
                    _car.basement_rd = '';
                    break;
                case 'angle_profile':
                    if(_car[key] != 'C' && _car[key] != 'D') {
                        _car.car_rope_x3 = ''
                    }
                    break;
                case 'rope_diameter_required': {
                    // if(_car[key] === 'Y') {
                    //     _car.rope_diameter = ''
                    // }
                    _car[`rope_diameter_required${this.defaultPostFix}`] = false;
                    break;
                }
            }
            this.fsub=false;
            this.subReset();
            this.checkIfDisabled();
        },
        countryChange(){
            let states = []
            if(this.model.project.country == 'USA') {
                states = this.states
            } else if(this.model.project.country == 'Canada') {
                states = this.provinces
            }

            if(states != undefined) {
                let cur_state = this.model.project.state
                this.model.project.state = ''
                
                for(let key in states) {
                    if(states[key].toLowerCase() == cur_state.toLowerCase()) {
                        this.model.project.state = states[key]
                        break
                    }
                }
            }
        },
        getProject(id){
            // console.log(this.model.cars);
            const api = '/api/project/'+id
            this.$http
                .get(api)
                .then((response) => {
                    this.model = response.data;
                    this.model.go_custom = '';
                    this.num_cars =  Object.keys(this.model.cars).length;
                    var d_encoder_cable = '';
                    const isFinalOriginal = response.data.project.is_final;
                    if ( this.$attrs.ftype == 'duplicate' ) {
                        this.model.project.project_name = '';
                        // delete this.steps.compounding_sheaves
                        // delete this.model.proj_steps.step_compounding_sheaves
                        this.$refs.project_name.focus();
                        delete this.model.project.id;
                    } else if ( this.$attrs.ftype == 'final' ) {
                        this.model.project.id = id;
                        this.model.project.is_final = 'yes';
                    } else if (this.$attrs.ftype == 'initial') {
                        this.model.project.id = id;
                        this.model.project.is_final = 'no';
                    }
                    if ( this.customers && this.model.project.customer_id ) {
                        const user = this.customers.find(u => u.id == this.model.project.customer_id)
                        if( user ) this.customer = user.username
                    }
                    if ( this.customerNoStock === 1 && (this.user.id == this.model.project.customer_id)) {
                        this.model.project.use_stock = 'no';
                    }
                    if ( this.model.project.customer_phone ) {
                        this.phone = this.formatPhone(this.model.project.customer_phone);
                    }
                    if ( this.num_cars ) {
                        for ( var cn in this.model.cars ) {
                            d_encoder_cable = this.model.cars[cn].encoder_cable;
                            this.model.cars[cn].no_of_floors = ''
                            this.carChange('machine_location',cn, true);
                            this.carChange('drive_manufacturer',cn, true);
                            this.carChange('bedplate',cn, true);
                            this.carChange('sheave',cn, true);
                            this.carChange('encoder',cn, true);
                            if ( this.model.project.is_final != 'yes' ) {
                                this.model.cars[cn].chains = 2;
                            } else if (this.model.proj_steps.step_machine_system && this.model.project.is_final == 'yes') {
                                if (this.model.cars[cn].vac == 'Unknown') this.model.cars[cn].vac = '';
                                if (this.model.cars[cn].drive_manufacturer == 'None Selected') this.model.cars[cn].drive_manufacturer == '';
                                if (isFinalOriginal == 'no') {
                                     this.model.cars[cn].deflector_in_overhead = ''
                                     this.model.cars[cn].existing_deflector_sheave = ''
                                     this.model.cars[cn].angled_bedplate = ''
                                }
                            }
                            this.model.cars[cn].encoder_cable = d_encoder_cable;
                        }
                    }
                    this.rtype = this.model.project.phase ? this.model.project.phase : 'modernization';
                    if ( this.rtype == 'construction' ) {
                        this.selections[0].selectable = true;
                        this.selections[6].selectable = true;
                        this.selections[7].selectable = true;
                        this.selections[8].selectable = true;

                        this.steps = {};

                        if ( this.model.proj_steps.step_wire_ropes )          this.steps.wire_ropes          = this.stepOrder('wire_ropes');
                        if ( this.model.proj_steps.step_compensations )       this.steps.compensations       = this.stepOrder('compensations');
                        if ( this.model.proj_steps.step_compounding_sheaves ) this.steps.compounding_sheaves = this.stepOrder('compounding_sheaves');

                        this.initConstruction();
                    } else {
                        this.steps = { machine_system : 1 };

                        if ( this.model.proj_steps.step_wire_ropes )          this.steps.wire_ropes          = this.stepOrder('wire_ropes');
                        if ( this.model.proj_steps.step_compensations )       this.steps.compensations       = this.stepOrder('compensations');

                        this.selections[6].selectable = true;
                        this.selections[7].selectable = true;
                    }
                    if ( this.model.proj_steps.step_machine_system ) {
                        // this.steps.machine_system      = this.stepOrder('machine_system');
                        this.steps = { machine_system : 1 };

                        if ( this.model.proj_steps.step_wire_ropes )          this.steps.wire_ropes          = this.stepOrder('wire_ropes');
                        if ( this.model.proj_steps.step_compensations )       this.steps.compensations       = this.stepOrder('compensations');

                        this.selections[5].selectable = false;
                        this.selections[6].selectable = true;
                        this.selections[7].selectable = true;
                        this.selections[8].selectable = true;

                        this.model.project.machine_type = 'traction';
                        this.machChange();
                    } else if ( this.model.proj_steps.step_hydraulics ) {
                        this.model.project.machine_type = 'hydraulic';

                        this.steps.hydraulics = this.stepOrder('hydraulics');

                        this.selections[0].selectable = false;
                        this.selections[2].selectable = false;

                        this.machChange();

                    } else {
                        this.model.project.machine_type = 'traction';
                        this.selections[5].selectable = false;
                    }

                    if ( this.model.proj_steps.step_compounding_sheaves ) this.steps.compounding_sheaves = this.stepOrder('compounding_sheaves');

                    if (this.$attrs.ftype == 'duplicate') {
                        this.clearDefaultSteps()
                        this.checkIfNewOtherSheave(this.model)
                    }
                    if (this.forceOtherSheaveChecked && ('compounding_sheaves' in this.steps) && ('machine_system' in this.steps)) {
                        this.selections[8].selectable = false
                    }

                    // if ( this.model.proj_steps.step_door_system )         this.steps.door_system         = this.stepOrder('door_system');
                    if ( this.model.proj_steps.step_controller )          this.steps.controller          = this.stepOrder('controller');
                    if ( this.model.proj_steps.step_guide_rails )         this.steps.guide_rails         = this.stepOrder('guide_rails');
                    if ( this.model.proj_steps.step_hoistway_components ) this.steps.hoistway_components = this.stepOrder('hoistway_components');

                    if (this.steps.compounding_sheaves) {
                        this.isOtherSheaveCheckedDefault = true
                    } else {
                        this.isOtherSheaveCheckedDefault = false
                    }
                    
                    this.checkNoStockBySUCustomer();
                    // this.machChange();
                    this.typeChange();
                    this.stateChange();
                })
                .catch((error) => {
                    console.log(error)
                });

            return false;
        },
        checkIfNewOtherSheave(currentProject) {
            const isOtherSheave = currentProject.proj_steps.step_compounding_sheaves === true;
            if (isOtherSheave) {
                for (let srow in currentProject.cars) {
                    const srowData = currentProject.cars[srow].compounding_sheaves.types;
                    if (srowData.length > 0 && !('ID' in srowData[0])) {
                        delete this.steps.compounding_sheaves;
                        break;
                    }
                }
            }
        },
        cpyFlrInfor(cn,key){
            const data = this.model.cars[cn][key].floor_info;
            return data;
        },
        clearDefaultSteps() {
            delete this.steps.machine_system
            delete this.steps.wire_ropes
            delete this.steps.compensations
            delete this.steps.compounding_sheaves
            if ( this.model.proj_steps.step_machine_system )      this.steps.machine_system      = this.stepOrder('machine_system');
            if ( this.model.proj_steps.step_wire_ropes )          this.steps.wire_ropes          = this.stepOrder('wire_ropes');
            if ( this.model.proj_steps.step_compensations )       this.steps.compensations       = this.stepOrder('compensations');
            if ( this.model.proj_steps.step_compounding_sheaves ) this.steps.compounding_sheaves = this.stepOrder('compounding_sheaves');
        },
        copyInput(from,to,key){
            if ( !key ) {
                var ncar = { 
                    ...{}, 
                    ...this.model.cars[from], 
                    ...{
                        car_id_number : this.model.cars[to].car_id_number,
                        copier : '',
                        controller : this.model.cars[to].controller,
                        door_system : this.model.cars[to].door_system,
                        guide_rails : this.model.cars[to].guide_rails,
                        hoistway_components : this.model.cars[to].hoistway_components,
                        hydraulics : this.model.cars[to].hydraulics,
                        wire_ropes : this.model.cars[to].wire_ropes,
                        compensations : this.model.cars[to].compensations,
                        compounding_sheaves : {
                            types: [],
                            type_number: 1,
                            type_width: 200,
                            no_sheave: 0
                        },
                    }
                };
                for( var ci in this.model.cars[from].compounding_sheaves.types ) {
                    ncar.compounding_sheaves.types[ci] = {};
                    for( var cx in this.model.cars[from].compounding_sheaves.types[ci] ) {
                        ncar.compounding_sheaves.types[ci][cx] = this.model.cars[from].compounding_sheaves.types[ci][cx];
                        ncar.compounding_sheaves.type_number = this.model.cars[from].compounding_sheaves.type_number;
                        ncar.compounding_sheaves.type_width = this.model.cars[from].compounding_sheaves.type_width;
                    }
                    ncar.compounding_sheaves.no_sheave = this.model.cars[from].compounding_sheaves.no_sheave
                }
                this.model.cars[to] = ncar;
            } else {
                var floor_info = this.model.cars[to][key].floor_info ? this.model.cars[to][key].floor_info : false;
                const floor_info_to = floor_info ? { ...{}, ...floor_info} : {};
                if ( this.model.cars[from][key].floor_info ) {
                    const fromflr = this.cpyFlrInfor(from,key);
                    floor_info = {
                        ...{},
                        ...floor_info_to,
                        ...fromflr,
                    };
                }
                var cs = { types: [], type_number: 1, type_width: 200, no_sheave: 0 },
                    nkcar = {};
                if ( key == 'compounding_sheaves' ) {
                    for( var cii in this.model.cars[from].compounding_sheaves.types ) {
                        cs.types[cii] = {};
                        for( var cxi in this.model.cars[from].compounding_sheaves.types[cii] ) {
                            cs.types[cii][cxi] = this.model.cars[from].compounding_sheaves.types[cii][cxi];
                            cs.type_number = this.model.cars[from].compounding_sheaves.type_number;
                            cs.type_width = this.model.cars[from].compounding_sheaves.type_width;
                        }
                        cs.no_sheave = this.model.cars[from].compounding_sheaves.no_sheave
                    }
                    nkcar = cs;
                } else if ( key == 'door_system' ) {
                    cs = {};
                    for( var fi in this.model.cars[from].door_system.floor_info ) {
                        cs.floor_info[fi] = {};
                        for( var fx in this.model.cars[from].door_system.floor_info[fi] ) {
                            cs.floor_info[fi][fx] = this.model.cars[from].door_system.floor_info[fi][fx];
                        }
                    }
                    nkcar = {
                        ...{}, 
                        ...this.model.cars[from][key], 
                        ...cs
                    };
                } else {
                    nkcar = { 
                        ...{}, 
                        ...this.model.cars[from][key], 
                        ...{
                            copier : '',
                            floor_info : false
                        }
                    };
                }
                this.model.cars[to].copier = '';
                this.model.cars[to][key] = nkcar;
            }

            this.subReset();

            this.checkIfDisabled();
        },
        getAcceleration(speed) {
            for(let i = 0; i < this.accelerationConditions.length; i++) {
                const condition = this.accelerationConditions[i];
                const condSign = condition.Cond_Sign;
                const parameter = parseInt(condition.Parameter);
                let match = false;
                switch(condSign) {
                    case '<': match = (speed < parameter); break;
                    case '<=': match = (speed <= parameter); break;
                    case '>=': match = (speed >= parameter); break;
                    case '>': match = (speed > parameter); break;
                    default: match = (speed == parameter); break;
                }
                if(match) {
                    return condition.C_Value;
                }
            }
            return 0;
        },
        getAccelerationConditions() {
            this.$http.get('/api/constants/conditions', {
                params: {
                    'category': 'Acceleration'
                }
            }).then(response => {
                this.accelerationConditions = response.data;
            })
        },
        duplicate(cn){
            var toDup = Object.assign({},this.model.cars[cn]),
                lastKey = Object.keys(this.model.cars).length,
                newKey = parseInt(cn) + 1;
            toDup.car_id_number = '';
            if ( lastKey > cn ) {
                for (var i = lastKey; i > cn; i--) {
                    const newData = Object.assign({},this.model.cars[i]),
                        changedKey = parseInt(i) + 1;
                        console.log(changedKey,i);
                    this.$set(this.model.cars,changedKey,newData);
                }
            }
            this.$set(this.model.cars,newKey,toDup);

            console.log(this.model.cars);

            return false;
        },
        setCars(){
            if ( this.num_cars != '' && this.num_cars < 1 ) this.num_cars = 1;
            if ( this.num_cars > 26 ) this.num_cars = 26;
            var toDup = {},
                cn = 1,
                num_cars = parseInt(this.num_cars),
                carnum = this.model.cars ? Object.keys(this.model.cars).length : 1,
                cin = '';
            for (cn = carnum + 1; cn <= num_cars; cn++) {
                // toDup[cn] = Object.assign({},this.blank,{car_id_number:'',cn:cn});
                // this.$set(this.model.cars,cn,{});
                // this.model.cars[cn] = toDup[cn];
                cin = this.model.project.form_type == 'selection' ? cn : cn;
                toDup[cn] = {
                    ...{},
                    ...this.blank,
                    ...{
                        car_id_number: cin,
                        controller : {},
                        door_system : { landing : 'TRUE', door_op : 'TRUE' },
                        guide_rails : {},
                        hoistway_components : {},
                        hydraulics : {},
                        wire_ropes : {},
                        compensations : {},
                        compounding_sheaves : { type_number : 1, types : [this.blank_cssv] },
                    }
                };
                this.model.cars[cn] = toDup[cn];
            }
            for (cn = num_cars + 1; cn <= carnum; cn++) {
                console.log('delete',cn);
                delete this.model.cars[cn];
            }

            this.subReset();
            return false;
        },
        newCar(cn){
            this.next_cn = cn;
            var toDup = Object.assign({},this.blank),
                lastKey = Object.keys(this.model.cars).length,
                newKey = parseInt(cn) + 1;
            toDup.car_id_number = '';
            if ( lastKey > cn ) {
                for (var i = lastKey; i > cn; i--) {
                    const newData = Object.assign({},this.model.cars[i]),
                        changedKey = parseInt(i) + 1;
                        console.log(changedKey,i);
                    this.$set(this.model.cars,changedKey,newData);
                }
            }
            this.$set(this.model.cars,newKey,toDup);

            return false;
        },
        remove(cn){
            this.$delete(this.model.cars,cn);

            return false;
        },
        adjustCarKeys(){

        },
        checkData(){
            var hasEmpty = false,
                firstEl = false,
                item = false,
                cn = false,
                car = false;
            this.errors = {};

            for(var i in this.$refs) {
                if ((`${i}` in this.blankDefaultMachine)) {
                    if (this.model.project.is_final == 'yes') {
                        if (!(this.blankDefaultMachine[`${i}`].initialOnly)) continue;
                    } else {
                        continue;
                    }
                }
                const _el = this.$refs[i];
                if ( Array.isArray(_el) ) {
                    for (var x in _el) {
                        item = _el[x];
                        if ( item && item.required && !item.disabled && (item.value == '' || item.value == undefined || (item.value.trim && item.value.trim() == '')) ) {
                            hasEmpty = true;
                            if ( !firstEl ) firstEl = item;
                            this.errors[x+'-'+i] = true;
                        }
                    }
                } else {
                    item = _el;
                    if ( item && item.required && !item.disabled && (item.value == '' || item.value == undefined || (item.value.trim && item.value.trim() == '')) ) {
                        hasEmpty = true;
                        if ( !firstEl ) firstEl = item;
                        this.errors[i] = true;
                        console.log(item);
                    }
                }
            }

            Array.from(document.querySelectorAll('.has-error')).forEach(function(el) { 
                el.classList.remove('has-error');
            });

            if ( hasEmpty ) {
                alert('Please fill all required data.');
                firstEl.focus();
                firstEl.classList.add('has-error');
                this.subReset();
                return false;
            } else if ( this.step == 'selection' ) {
                this.model.project.customer_phone = this.phone.code + ' ' + this.phone.number;
                if ( !this.phone.code || this.phone.code.includes('_') ) {
                    document.querySelector('.phone_code').focus();
                    document.querySelector('.phone_code').classList.add('has-error');
                    alert('Please fill a valid Phone Number.');
                    return false;
                }
                if ( !this.phone.number || this.phone.number.includes('_') ) {
                    document.querySelector('.phone_number').focus();
                    document.querySelector('.phone_number').classList.add('has-error');
                    alert('Please fill a valid Phone Number.');
                    return false;
                }
            } else if ( this.step == 'machine_system' && this.model.project.form_type == 'selection' ) {
                for ( var ci in this.model.cars ) {
                    if ( !this.model.cars[ci].items || !this.model.cars[ci].items[0] ) {
                        alert('Please add at least 1 item per car.');
                        return false;
                    }
                }
            } else if ( this.steps.machine_system && this.step == 'machine_system' ) {
                if ( this.model.project.is_final == 'yes' && this.model.project.phase == 'modernization' && !this.model.project.start_date ) {
                    document.querySelector('.start_date_wrap').scrollIntoView({ block: 'center' });
                    document.querySelector('.start_date_wrap').classList.add('has-error');
                    alert('Please fill Estimated Project Start Date.');
                    return false;
                }
            } else if ( this.steps.controller && this.step == 'controller' ) {
                console.log(this.steps.controller);
                for (cn in this.model.cars) {
                    car = this.model.cars[cn];
                console.log(car);
                    if ( !car.controller.floor_info || !car.controller.floor_info.length ) {
                        alert('Please fill Floor Information data.');
                        this.controllerIT(cn,car.controller);
                        return false;
                    }
                }
            } else if ( this.steps.door_system && this.step == 'door_system' ) {
                for (cn in this.model.cars) {
                    car = this.model.cars[cn];
                    if ( car.door_system.entrance == 'TRUE' && (!car.door_system.floor_info || !car.door_system.floor_info.length) ) {
                        alert('Please fill Floor Information data.');
                        this.doorIT(cn,car.door_system);
                        return false;
                    }
                    if ( car.door_system.entrance != 'TRUE' && car.door_system.landing != 'TRUE' && car.door_system.door_op != 'TRUE' && car.door_system.light_curtain != 'TRUE' ) {
                        alert('Please check at least 1 Product.');
                        return false;
                    }
                }
            }
            return true;
        },
        sesCurr(val) {
            return this.formatMoney(val, 2, '.', ',');
        },
        formatMoney(number, decPlaces, decSep, thouSep) {
            decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
            decSep = typeof decSep === "undefined" ? "." : decSep;
            thouSep = typeof thouSep === "undefined" ? "," : thouSep;
            var sign = number < 0 ? "-" : "";
            var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
            var j = (j = i.length) > 3 ? j % 3 : 0;

            return sign +
                (j ? i.substr(0, j) + thouSep : "") +
                i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
                (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
        },
        checkCustomerCanPadsOnFloors() {
            if (!('machine_system' in this.steps) || this.model.project.form_type !== 'survey_form' || this.model.project.machine_type !== 'traction') {
                this.showPadsOnFloors = false
                return false
            }
            let params = { customer_id: this.user.id }
            if (this.isSU() || this.isPM()) params = { customer_id: this.model.project.customer_id }
            this.$http.post('/api/user-pads-floors', params)
            .then((response) => {
                this.showPadsOnFloors = response.data.can
            }).catch(error => {
                console.log(error)
            })
        },
        checkCustomerCanDuraLiftSheave() {
            if (this.model.project.form_type !== 'survey_form' || this.model.project.machine_type !== 'traction') {
                this.showDuraLiftSheave = false
                return false
            }
            let params = { customer_id: this.user.id }
            if (this.isSU() || this.isPM()) params = { customer_id: this.model.project.customer_id }
            this.$http.post('/api/user-dura-lift', params)
                .then((response) => {
                    this.showDuraLiftSheave = response.data.can
                }).catch(error => {
                console.log(error)
            })
        },
        checkPadsOnFloorsChecked() {
            let hasPadsOnFloorsChecked = false
            for ( let cnxx in this.model.cars ) {
                if (this.model.cars[cnxx].pads_on_floors === 'TRUE' && this.showPadsOnFloors) {
                    hasPadsOnFloorsChecked = true
                } else if (this.model.cars[cnxx].pads_on_floors !== 'TRUE' && this.showPadsOnFloors) {
                    this.model.cars[cnxx].pads_on_floors = 'FALSE'
                } else if (!this.showPadsOnFloors) {
                    this.model.cars[cnxx].pads_on_floors = null
                }
            }
            if (hasPadsOnFloorsChecked && this.model.go_custom !== 'CUSTOM') {
                this.model.go_custom = 'CUSTOM'
            }
            this.model.has_pads_on_floors = hasPadsOnFloorsChecked
            if (!hasPadsOnFloorsChecked && this.backupGoCustom !== 'CUSTOM') {
                this.model.go_custom = ''
            }
        },
        handleStatusChange(event) {
            console.log(event)
            this.backupGoCustom = event.target.value
        },
        calculate(){
            // console.log('cars', this.model.cars);
            if ( 'machine_system' in this.steps && this.step == 'machine_system' ) this.checkBlankInputMachine();
            if ( !this.checkData() || this.loading ) return false;
            if ( !this.steps.machine_system || this.model.project.form_type == 'selection' ) {
                this.showDS = true;
                this.showLD = true;
                this.$emit('modChange',true);
            }
            this.checkPadsOnFloorsChecked()

            const api = '/api/calculate';
            this.model.steps = this.steps;
            if (this.steps.machine_system) this.model.hidableRows = Object.assign({}, this.hidableRows);
            if (this.steps.hoistway_components) this.model.hidableRowsHoist = Object.assign({}, this.hidableRowsHoist);
            if (!this.steps.machine_system && this.steps.wire_ropes) this.model.hidableRowsWire = Object.assign({}, this.hidableRowsWire);
            if (this.steps.compounding_sheaves) this.model.hidableRowsSheave = Object.assign({}, this.hidableRowsSheave);
            if (this.steps.hydraulics) this.model.hidableRowsHydraulic = Object.assign({}, this.hidableRowsHydraulic);
            this.aletmsg = false;
            // var model = this.model;
            /*var cs = { types: [] };

            for ( var cn in this.model.cars ) {
                cs = { types: this.model.cars[cn].compounding_sheaves.types };
                model.cars[cn].compounding_sheaves.types = cs;
            }*/

            this.loading = true;
            this.$http
                .post(api, this.model)
                .then((response) => {
                    this.model.project.id = response.data.project.id;
                    this.datasheets = response.data.datasheets;
                    this.showDS = true;
                    this.loading = false;
                    this.aletmsg = false;
                    this.$emit('modChange',true);

                    if ( !this.steps.machine_system || this.model.project.form_type == 'selection' ) {
                        this.$router.push('/projects');
                        this.showDS = false;
                        this.showLD = false;
                        // console.log(response);
                        this.$emit('modChange',false);

                        if( response.data.status == 'CUSTOM' ) {
                            localStorage.setItem('alertmsg', 'Your selection is not one of our standard applications. Your TDNA Project Manager has been notified and will provide you with a custom quotation within two business days.');
                            setTimeout(function(){
                                alert(localStorage.getItem('alertmsg'));
                                localStorage.setItem('alertmsg', false);
                            }, 500);
                        }
                    }
                })
                .catch((error) => {
                    // console.log('errorm',error.response.data.message);
                    alert('ERROR: '+error.response.data.message);
                    this.showDS = false;
                    this.showLD = false;
                    this.loading = false;
                    this.$emit('modChange',false);
                });

            return false;
        },
        checkBlankInputMachine() {
            let _cars = this.model.cars;
            for (let carNum in _cars) {
                if (this.model.project.is_final != 'yes') {
                    if (['', undefined, null].includes(_cars[carNum].counterweight)) {
                        _cars[carNum][`counterweight${this.defaultPostFix}`] = true;
                    }
                    if (['', undefined, null].includes(_cars[carNum].weight_comp_sheave) && _cars[carNum].counterweight > 0) {
                        _cars[carNum][`weight_comp_sheave${this.defaultPostFix}`] = true;
                    }
                    if (['', undefined, null].includes(_cars[carNum].empty_car_weight)) {
                        _cars[carNum][`empty_car_weight${this.defaultPostFix}`] = true;
                    }
                    if (['', undefined, null].includes(_cars[carNum].acceleration)) {
                        _cars[carNum][`acceleration${this.defaultPostFix}`] = true;
                    }
                    if (['', undefined, null].includes(_cars[carNum].double_wrap)) {
                        _cars[carNum][`double_wrap${this.defaultPostFix}`] = true;
                    }
                    if (['', undefined, null].includes(_cars[carNum].compensation)) {
                        _cars[carNum][`compensation${this.defaultPostFix}`] = true;
                    }
                    if (['', undefined, null].includes(_cars[carNum].vac)) {
                        // _cars[carNum].vac = this.blankDefaultMachine.vac.value;
                        _cars[carNum][`vac${this.defaultPostFix}`] = true;
                    }
                    if (['', undefined, null].includes(_cars[carNum].drive_manufacturer)) {
                        // _cars[carNum].drive_manufacturer = this.blankDefaultMachine.drive_manufacturer.value;
                        // this.carChange('drive_manufacturer', carNum);
                        _cars[carNum][`drive_manufacturer${this.defaultPostFix}`] = true;
                        _cars[carNum][`encoder_cable${this.defaultPostFix}`] = true;
                        this.hidableRows.encoder_cable = false
                    }
                }
                if (['', undefined, null].includes(_cars[carNum].rope_diameter)) {
                    // _cars[carNum].rope_diameter = this.blankDefaultMachine.rope_diameter.value;
                    // this.carChange('rope_diameter', carNum);
                    _cars[carNum][`rope_diameter${this.defaultPostFix}`] = true;
                    _cars[carNum][`rope_diameter_required${this.defaultPostFix}`] = true;
                }
                if (['', undefined, null].includes(_cars[carNum].encoder_cable) && !this.hidableRows.encoder_cable) {
                    // this.carChange('drive_manufacturer', carNum);
                    _cars[carNum][`encoder_cable${this.defaultPostFix}`] = true;
                }
                if (this.model.project.is_final != 'yes') continue;
                const isOHMR =  ['OHMR'].includes(_cars[carNum].machine_location);
                const isBASEMENT =  ['BASEMENT'].includes(_cars[carNum].machine_location);
                const isBedplate = _cars[carNum].bedplate == 'TRUE';
                if (['', undefined, null].includes(_cars[carNum].pads_on_floors) && (isOHMR || isBASEMENT)) {
                    if (this.showPadsOnFloors) _cars[carNum].pads_on_floors = 'FALSE';
                    else _cars[carNum].pads_on_floors = null;
                }
                if (['', undefined, null].includes(_cars[carNum].deflector_in_overhead)) {
                    // _cars[carNum].deflector_in_overhead = (isOHMR) ? 'No' : '' ;
                    // this.carChange('deflector_in_overhead', carNum);
                    _cars[carNum][`deflector_in_overhead${this.defaultPostFix}`] = (isOHMR) ? true : false;
                    // _cars[`deflector_in_overhead${this.defaultValuePostFix}`] = (isOHMR) ? ;
                }
                if (['', undefined, null].includes(_cars[carNum].existing_deflector_sheave)) {
                    // _cars[carNum].existing_deflector_sheave = (isOHMR) ? 'NO' : '' ;
                    // this.carChange('existing_deflector_sheave', carNum);
                    _cars[carNum][`existing_deflector_sheave${this.defaultPostFix}`] = (isOHMR && isBedplate) ? true : false;
                }
                if (['', undefined, null].includes(_cars[carNum].angled_bedplate)) {
                    // _cars[carNum].angled_bedplate = (isOHMR) ? 'Yes' : '' ;
                    // this.carChange('angled_bedplate', carNum);
                    _cars[carNum][`angled_bedplate${this.defaultPostFix}`] = (isOHMR && isBedplate) ? true : false;
                }
            }
        },
        bolToggle(cn,key){
            const data = this.model.cars[cn][key];
            this.model.cars[cn][key] = data == 'TRUE' ? 'FALSE' : 'TRUE';

            this.carChange(key,cn);
        },
        ropeDiameterToggle(cn, key) {
            const data = this.model.cars[cn][key];
            this.model.cars[cn][key] = data == 'Y' ? 'N' : 'Y';

            this.carChange(key, cn);
        },
        noSheaveToggle(cn, key, subkey) {
            const data = this.model.cars[cn][key][subkey];
            this.model.cars[cn][key][subkey] = data == 0 ? 1 : 0;

            this.sheaveChange(cn, 'compounding_sheaves', 'no_sheave')
        },
        subReset(){
            var ctr = this.reseter.counter;
            this.$set(this.reseter,'counter',ctr+2);
            this.$set(this.reseter,'counter',ctr+1);
        },
        subToggle(cn, sub, key, event){
            this.model.cars[cn][sub][key] = event.target.checked ? 'TRUE' : 'FALSE';

            this.subReset();
            this.subChange(cn, sub, key);
        },
        subYToggle(cn, sub, key, event){
            this.model.cars[cn][sub][key] = event.target.checked ? 'Y' : 'N';

            this.subReset();
            this.subChange(cn, sub, key);
        },
        rangeCalc(cn,sub,key,min,max,val){
            var out_of_range = false;

            if ( val != '' && val < min ) {
                out_of_range = true;
            }
            if ( val > parseFloat(max) ) {
                out_of_range = true;
            }
            
            if ( out_of_range ) {
                alert('Number you entered is Out of Range.'+val);

                if ( this.$refs[key] && this.$refs[key][cn-1] ) this.$refs[key][cn-1].focus();

                if ( sub ) this.model.cars[cn][sub][key] = '';
                else this.model.cars[cn][key] = '';
            }

            this.subReset();
        },
        addSheave(cn){
            var _sub = this.model.cars[cn].compounding_sheaves;
            if ( !_sub.type_number ) _sub.type_number = 1;
            if ( _sub.type_number <= 5 ) _sub.type_number += 1;
            this.subChange(cn, 'compounding_sheaves', 'type_number');
            return false
        },
        removeSheave(cn){
            var _sub = this.model.cars[cn].compounding_sheaves;
            if ( !_sub.type_number ) _sub.type_number = 1;
            if ( _sub.type_number > 1 ) _sub.type_number -= 1;
            this.subChange(cn, 'compounding_sheaves', 'type_number');
            return false
        },
        rangeSub(cn,sub,key,min,max){
            var _item = sub ? this.model.cars[cn][sub][key] : this.model.cars[cn][key],
                out_of_range = false;

            if ( _item != '' && _item < min ) {
                _item = min;
                out_of_range = true;
            }
            if ( _item > parseFloat(max) ) {
                _item = max;
                out_of_range = true;
            }
            
            if ( out_of_range ) {
                console.log('rsubtrig',this.no_alert);
                if ( !this.no_alert ) {
                    alert('Number you entered is Out of Range.');
                    if ( this.$refs[key] && this.$refs[key][cn-1] ) this.$refs[key][cn-1].focus();
                }
                this.no_alert = false;

                if ( sub ) this.model.cars[cn][sub][key] = '';
                else this.model.cars[cn][key] = '';
            }

            this.subReset();
        },
        sheaveChange(cn, sub, key, tn = -1) {
            var _subSheave = this.model.cars[cn][sub].types[tn];
            var _sub = this.model.cars[cn][sub];
            const _subKey = this.model.cars[cn][sub][key]
            switch(key) {
                case 'dura_lift_sheave': {
                    if (_subSheave[key] !== '') {
                        _subSheave['sheave_type'] = '';
                        _subSheave['location'] = '';
                        _subSheave['rope_size'] = '';
                        _subSheave['groove_number'] = '';
                        _subSheave['pitch_in'] = '';
                        _subSheave['sheave_diameter'] = '';
                        _subSheave['max_sheave_width'] = '';
                        _subSheave['shaft_type'] = '';
                        _subSheave['l1'] = '';
                        _subSheave['l2'] = '';
                        _subSheave['l3'] = '';
                        _subSheave['l4'] = '';
                        _subSheave['l5'] = '';
                        _subSheave['l6'] = '';
                    }
                    break;
                }
                case 'no_sheave': {
                    if (_subKey === 1) {
                        const reset_cssv = {
                            no_sheave: 1,
                            dura_lift_sheave: '',
                            sheave_type : '',
                            location : '',
                            rope_size : '',
                            groove_number : '',
                            pitch_in : '',
                            sheave_diameter : '',
                            max_sheave_width : '',
                            shaft_type : '',
                            qty : '',
                            l1 : '',
                            l2 : '',
                            l3 : '',
                            l4 : '',
                            l5 : '',
                            l6 : ''
                        }
                        _sub.types = [reset_cssv]
                        _sub.type_number = 1
                        _sub.type_width = 2 * 100;
                    }
                    break;
                }
                case 'sheave_type': {
                    if (this.steps.machine_system && this.steps.compounding_sheaves) {
                        const wraps = {'Single': 1, 'Double': 2}
                        if (['A', 'D'].includes(_subSheave[key])) { // Deflector
                            const dsn = this.datasheetSystem[cn];
                            const wrap = wraps[dsn.wrap]
                            if (wrap === undefined || Number.isNaN(parseInt(dsn.number_of_ropes))) {
                                this.model.cars[cn].compounding_sheaves.types[tn].groove_number = ''
                                this.model.cars[cn].compounding_sheaves.types[tn].pitch_in = ''
                            } else {
                                this.model.cars[cn].compounding_sheaves.types[tn].groove_number = wrap * parseInt(dsn.number_of_ropes)
                                this.model.cars[cn].compounding_sheaves.types[tn].pitch_in = dsn.machine_pitch_in;
                            }
                        } else if (['B', 'C'].includes(_subSheave[key])) { // CSSV
                            const dsn = this.datasheetSystem[cn];
                            const wrap = wraps[dsn.wrap]
                            if (wrap === undefined || Number.isNaN(parseInt(dsn.number_of_ropes)) || Number.isNaN(parseFloat(dsn.machine_pitch_in))) {
                                this.model.cars[cn].compounding_sheaves.types[tn].groove_number = ''
                                this.model.cars[cn].compounding_sheaves.types[tn].pitch_in = ''
                            } else {
                                this.model.cars[cn].compounding_sheaves.types[tn].groove_number = parseInt(dsn.number_of_ropes)
                                this.model.cars[cn].compounding_sheaves.types[tn].pitch_in = parseFloat(dsn.machine_pitch_in) * wrap
                            }
                        }
                    }
                    break;
                }
            }
            this.subReset();
            this.checkIfDisabled('compounding_sheaves');
        },
        subChange(cn, sub, key){
            var _sub = this.model.cars[cn][sub],
                subkey = sub+'.'+key;
            switch(subkey) {

                case 'door_system.no_of_floors':
                    _sub['door_op_fr_landing_qty'] = _sub[key]+'';
                    if ( _sub['door_op_rear_w'] != 'N/A' ) _sub['door_op_rear_landing_qty'] = _sub[key]+'';
                    if ( _sub['light_curtain'] == 'TRUE' ) _sub['light_curtain_qty'] = _sub[key]*2;
                    break;

                case 'door_system.door_op_fr_landing_qty':
                    if ( _sub[key] == 0 && _sub[key] == '' ) {
                        _sub['door_op_fr_w'] = '';
                        _sub['door_op_fr_opening'] = '';
                        _sub['door_op_fr_speed'] = '';
                    }
                    if ( _sub['light_curtain'] == 'TRUE' ) _sub['light_curtain_qty'] = _sub[key] + _sub['door_op_rear_landing_qty'];
                    break;

                case 'door_system.door_op_rear_landing_qty':
                    if ( _sub[key] == 0 && _sub[key] == '' ) {
                        _sub['door_op_rear_w'] = '';
                        _sub['door_op_rear_opening'] = '';
                        _sub['door_op_rear_speed'] = '';
                    }
                    if ( _sub['light_curtain'] == 'TRUE' ) _sub['light_curtain_qty'] = _sub[key] + _sub['door_op_fr_landing_qty'];
                    break;

                case 'door_system.entrance':
                    if ( _sub[key] != 'TRUE' ) {
                        _sub['entrance_fr_opening_w'] = '';
                        _sub['entrance_fr_opening_h'] = '';
                        _sub['entrance_fr_hoistway_w'] = '';
                        _sub['entrance_rear_opening_w'] = '';
                        _sub['entrance_rear_opening_h'] = '';
                        _sub['entrance_rear_hoistway_w'] = '';
                        _sub['entrance_sill_finish'] = '';
                        _sub['entrance_keyhole'] = '';

                        _sub['centerline_to_hatch'] = '';
                        _sub['centerline_to_edge'] = '';
                        _sub['centerline_to_transom'] = '';
                        _sub['running_clearance'] = '';
                        _sub['door_combined_weight'] = '';
                        _sub['entrance_manufacturer'] = '';
                    }
                    break;

                case 'door_system.landing':
                case 'door_system.door_op':
                    if ( _sub[key] == 'TRUE' ) {
                        _sub['landing'] = 'TRUE';
                        _sub['door_op'] = 'TRUE';
                    } else {
                        _sub['landing'] = 'FALSE';
                        _sub['door_op'] = 'FALSE';
                    }
                    if ( _sub['landing'] != 'TRUE' || _sub['door_op'] != 'TRUE' ) {
                        _sub['door_op_vac'] = '';
                        _sub['door_op_fr_w'] = '';
                        _sub['door_op_fr_opening'] = '';
                        _sub['door_op_fr_speed'] = '';
                        _sub['door_op_fr_landing_qty'] = '';
                        _sub['door_op_rear_w'] = '';
                        _sub['door_op_rear_opening'] = '';
                        _sub['door_op_rear_speed'] = '';
                        _sub['door_op_rear_landing_qty'] = '';
                    }
                    this.subChange(cn, sub, 'door_op_fr_landing_qty');
                    this.subChange(cn, sub, 'door_op_rear_landing_qty');
                    break;

                case 'door_system.door_op_fr_w':
                case 'door_system.entrance_fr_opening_w':
                    if ( _sub['entrance'] == 'TRUE' ) _sub['entrance_fr_opening_w'] = _sub[key]+'';
                    _sub['door_op_fr_w'] = _sub[key]+'';
                    if ( _sub[key] == '48' ) _sub['door_op_fr_opening'] = 'Center';
                    break;

                case 'door_system.door_op_rear_w':
                    if ( _sub[key] == 'N/A' ) {
                        _sub['door_op_rear_speed'] = '';
                        _sub['door_op_rear_opening'] = '';
                    }
                    break;
                case 'door_system.entrance_rear_opening_w':
                    if ( _sub['entrance'] == 'TRUE' ) _sub['entrance_rear_opening_w'] = _sub[key]+'';
                    _sub['door_op_rear_w'] = _sub[key]+'';
                    if ( _sub[key] == '48' ) _sub['door_op_rear_opening'] = 'Center';
                    if ( _sub[key] == 'N/A' ) {
                        _sub['entrance_rear_opening_h'] = '';
                        _sub['entrance_rear_hoistway_w'] = '';
                    }
                    break;

                case 'door_system.entrance_fr_opening_h':
                    if ( _sub[key] < 72 ) _sub[key] = 72;
                    if ( _sub[key] > 96 ) _sub[key] = 96;
                    break;

                case 'door_system.entrance_fr_hoistway_w':
                    if ( _sub[key] < 30 ) _sub[key] = 30;
                    if ( _sub[key] > 200 ) _sub[key] = 200;
                    break;

                case 'door_system.entrance_rear_opening_h':
                    if ( _sub[key] < 72 ) _sub[key] = 72;
                    if ( _sub[key] > 96 ) _sub[key] = 96;
                    break;

                case 'door_system.entrance_rear_hoistway_w':
                    if ( _sub[key] < 30 ) _sub[key] = 30;
                    if ( _sub[key] > 200 ) _sub[key] = 200;
                    break;

                case 'door_system.light_curtain':
                    if ( _sub[key] != 'TRUE' ) _sub['light_curtain_qty'] = '';
                    break;

                case 'wire_ropes.governor_rope':
                    if ( _sub[key] == 'Y' ) {
                        alert('DO NOT check if Governor Rope is already ordered with the Governor.');
                    } else {
                        _sub['governor_rope_length'] = '';
                    }
                    break;
                case 'wire_ropes.hoist_rope':
                    if ( _sub[key] == 'N' ) {
                        _sub['rope_size'] = '';
                        _sub['rope_type'] = '';
                        _sub['hoist_rope_length'] = '';
                        _sub['hoist_rope_number'] = '';
                        _sub['dw'] = '';
                    }
                    break;
                case 'hydraulics.existing_fl_pressure':
                    if ( _sub[key] > 0 ) {
                        _sub['capacitysel'] = '';
                        _sub['capacity'] = '';
                        _sub['car_weight'] = '';
                    }
                    break;
                case 'hydraulics.capacity':
                case 'hydraulics.car_weight':
                    if ( _sub[key] > 0 ) {
                        _sub['existing_fl_pressure'] = '';
                    }
                    break;
                case 'hoistway_components.governor':
                    if(_sub[key] != 'Y') {
                        _sub['governor_type'] = '';
                    } else {
                        _sub['governor_type'] = 'Standard';
                    }
                    break;
                case 'hoistway_components.governor_rope':
                    if(_sub[key] != 'Y') {
                        _sub['governor_rope_length'] = '';
                    } else {
                        if ( this.steps.machine_system ) {
                            _sub['governor_rope_length'] = this.constants['C36.1'] ? (parseFloat(this.model.cars[cn].travel) + parseFloat(this.constants['C36.1']) ) * 2 : parseFloat(this.model.cars[cn].travel) * 2;
                        }
                    }
                    break;
                case 'hoistway_components.safety':
                    if(_sub[key] != 'Y') {
                        _sub['governor_position'] = '';
                        _sub['dbg'] = '';
                    }
                    break;
                case 'hoistway_components.oil_buffer':
                    if(_sub[key] != 'Y') {
                        _sub['oil_buffer_car_side_qty'] = '';
                        _sub['oil_buffer_cwt_side_qty'] = '';
                    }
                    break;
                case 'hydraulics.machine_room_location':
                    if(_sub[key] == 'Adjacent') {
                        _sub['distance'] = '';
                    }
                    break;
                case 'hydraulics.scavenger_pump':
                    if(_sub[key] != 'Y') {
                        _sub['copper_tubing'] = '';
                    }
                    break;
                case 'compounding_sheaves.shaft_type_car':
                    if(_sub[key] != 'B') {
                        _sub['l5_car'] = '';
                        _sub['l6_car'] = '';
                    }
                    break;
                case 'compounding_sheaves.shaft_type_cwt':
                    if(_sub[key] != 'B') {
                        _sub['l5_cwt'] = '';
                        _sub['l6_cwt'] = '';
                    }
                    break;
                case 'compounding_sheaves.type_number':
                    var types = [];
                    // _sub['type_number'] = _sub['type_number'] ? _sub['type_number'] : 1;
                    _sub['type_number'] = _sub['type_number'] ? _sub['type_number'] : _sub['types'].length;
                    _sub['type_number'] = _sub['type_number'] <= 5 ? _sub['type_number'] : 5;
                    if ( _sub['type_number'] <= 5 ) {
                        for( var tn = 0; tn < _sub['type_number']; tn++ ) {
                            types[tn] = _sub['types'] && _sub['types'][tn] ? _sub['types'][tn] : {
                                dura_lift_sheave: '',
                                location : '',
                                rope_size : '',
                                groove_number : '',
                                pitch_in : '',
                                sheave_diameter : '',
                                max_sheave_width : '',
                                shaft_type : '',
                                qty : '',
                                l1 : '',
                                l2 : '',
                                l3 : '',
                                l4 : '',
                                l5 : '',
                                l6 : '',
                            };
                        }
                        _sub['type_width'] = (_sub['type_number'] > 2 ? _sub['type_number'] - 1 : 2) * 100;
                        _sub['types'] = types;
                    } else {
                        _sub['type_width'] = 200;
                        _sub['types'] = types;
                    }
                    break;
                case 'controller.door_type':
                    if(_sub[key] != 'Swing Door' && _sub[key] != 'Peelle/Freight Door') {
                        _sub['door_cam_type'] = 'None';
                        _sub['door_cam_volt_type'] = '';
                        _sub['door_cam_voltage'] = '';
                    }
                    break;
                case 'controller.door_cam_type':
                    if(_sub[key] != 'Electrical Cam') {
                        _sub['door_cam_volt_type'] = '';
                        _sub['door_cam_voltage'] = '';
                    }
                    break;
                case 'controller.controller_ac':
                    if(_sub[key] != 'Yes') {
                        _sub['controller_ac_material'] = '';
                    }
                    break;
                case 'controller.load_weigher':
                    if(_sub[key] != 'Yes') {
                        _sub['rope_cross_beam'] = '';
                    }
                    break;
            }

            this.subReset();
            this.checkIfDisabled(sub);
        },
        handleCompoundingTypeNumbers() {
            for ( var ccns in this.model.cars ) {
                this.subChange(ccns, 'compounding_sheaves', 'type_number');
            }
        },
        edit(){
            this.showDS = false;
            this.step = 'selection';
            this.$emit('modChange',false);
        },
        goProj(){
          this.$router.push('projects');
        },
        request(){
            if ( this.model.project.is_final == 'yes' ) {
                this.model.project.last_edit_name = prompt('Enter your first and last name to confirm your data and complete your submission.');
                if ( !this.model.project.last_edit_name ) return false;
            }

            this.showLD = true;
            this.loading = true;

            const api = '/api/save';
            this.$http
                .post(api, this.model.project)
                .then((response) => {
                    this.showLD = false;
                    this.loading = false;
                    this.subReset();
                    this.$router.push('/projects');
                    var showalert = false;
                    if( response.data.generating && response.data.status != 'CUSTOM' ) {
                        showalert = true;
                        localStorage.setItem('alertmsg', 'Your autodrawing is currently being generated. It will appear in your dashboard shortly.');
                    } else if( response.data.status == 'CUSTOM' ) {
                        showalert = true;
                        localStorage.setItem('alertmsg', 'Your selection is not one of our standard applications. Your TDNA Project Manager has been notified and will provide you with a custom quotation within two business days.');
                    }
                    if ( showalert  ) {
                        setTimeout(function(){ 
                            alert(localStorage.getItem('alertmsg'));
                            localStorage.setItem('alertmsg', false);
                        }, 500);
                    }
                    console.log(response);
                })
                .catch((error) => {
                    this.showLD = false;
                    this.loading = false;
                    console.log(error);
                    console.log('errorm',error.response.data.message);
                    alert('ERROR: '+error.response.data.message);
                });

            return false;
        },
        onFormResize() {
            let form = document.querySelector('.project-section')
            if(form) {
                Array.from(document.querySelectorAll('.proj-labels .proj-group > div.proj-h2')).forEach(function(el) { 
                    el.style.width = form.clientWidth + 'px'
                })
                Array.from(document.querySelectorAll('.proj-labels .proj-group > div.proj-h3')).forEach(function(el) { 
                    el.style.width = form.clientWidth + 'px'
                })
            }
        },
        onPhoneClick(e, element) {
            e.target.selectionStart = 1
            e.target.selectionEnd = 1
            document.querySelector(element).focus()
        },
        formatPhone(phone) {
            let obj = { code: '+01', number: '' };

            if(phone.charAt(0) == '(') {
                obj.number = phone;
            } else {
                let number = phone.split('(');
                if(number.length > 1) {
                    if(number[0]) obj.code = number[0].trim();
                    if(number[1]) obj.number = number[1];
                } else {
                    obj.number = phone;
                }
            }

            obj.number = obj.number.replaceAll(/[+\-()\s]/g, '');

            if(obj.number.length < 10) {
                obj.number = obj.number + '_';
            }

            obj.number = '(' + obj.number.slice(0, 3) + ') ' + obj.number.slice(3);
            obj.number = obj.number.slice(0, 9) + '-' + obj.number.slice(9);

            return obj;
        },
        set_name(user) {
            if(user == 'other') {
                this.model.project.customer_name = ''
                this.model.project.customer_email = ''
                this.phone = { code: '+01', number: '' }
            } else {
                this.model.project.customer_name = user.name
                this.model.project.customer_email = user.email
                this.phone = this.formatPhone(user.phone)
            }
        },
        handleClickDuraLift(cn) {
            if (this.showDuraLiftSheave && (!(['8mm', '10mm'].includes(this.model.cars[cn].rope_diameter)) && this.steps.machine_system !== undefined)) {
                alert('The rope size for Dura Lift Sheave should be 8mm or 10mm.');
            }
        },
        checkIfDisabled(currentStep = null) {
            if (!currentStep) currentStep = this.step
            if (currentStep === 'machine_system') {
                this.$nextTick(() => {
                    for(let hD in this.defaultHideDisables) {
                        let _refField = this.$refs[hD]
                        if (_refField === undefined) continue;
                        if (Array.isArray(_refField)) {
                            let allDisabled = []
                            for (let rf in _refField) {
                                allDisabled.push(_refField[rf].disabled)
                            }
                            if (allDisabled.every(element => element === true)) {
                                this.hidableRows[hD] = true
                            } else {
                                this.hidableRows[hD] = false
                            }
                        }
                    }
                })
            } else if (currentStep === 'hoistway_components') {
                this.$nextTick(() => {
                    for(let hD in this.defaultHideDisablesHoist) {
                        let _refField = this.$refs[hD]
                        if (_refField === undefined) continue;
                        if (Array.isArray(_refField)) {
                            let allDisabled = []
                            for (let rf in _refField) {
                                allDisabled.push(_refField[rf].disabled && (_refField[rf].value === '' || _refField[rf].value === null  || _refField[rf].value === undefined))
                            }
                            if (allDisabled.every(element => element === true)) {
                                this.hidableRowsHoist[hD] = true
                            } else {
                                this.hidableRowsHoist[hD] = false
                            }
                        }
                    }
                })
            } else if (currentStep === 'wire_ropes') {
                this.$nextTick(() => {
                    for(let hD in this.defaultHideDisablesWire) {
                        let _refField = this.$refs[hD]
                        if (_refField === undefined) continue;
                        if (Array.isArray(_refField)) {
                            let allDisabled = []
                            for (let rf in _refField) {
                                allDisabled.push(_refField[rf].disabled)
                            }
                            if (allDisabled.every(element => element === true)) {
                                this.hidableRowsWire[hD] = true
                            } else {
                                this.hidableRowsWire[hD] = false
                            }
                        }
                    }
                })
            } else if (currentStep === 'compounding_sheaves') {
                this.$nextTick(() => {
                    for(let hD in this.defaultHideDisablesSheave) {
                        let _refField = this.$refs[hD]
                        if (_refField === undefined) continue;
                        if (Array.isArray(_refField)) {
                            let allDisabled = []
                            for (let rf in _refField) {
                                allDisabled.push(_refField[rf].disabled)
                            }
                            if (allDisabled.every(element => element === true)) {
                                this.hidableRowsSheave[hD] = true
                            } else {
                                this.hidableRowsSheave[hD] = false
                            }
                        }
                    }
                })
            } else if (currentStep === 'hydraulics') {
                this.$nextTick(() => {
                    for(let hD in this.defaultHideDisablesHydrau) {
                        let _refField = this.$refs[hD]
                        if (_refField === undefined) continue;
                        if (Array.isArray(_refField)) {
                            let allDisabled = []
                            for (let rf in _refField) {
                                allDisabled.push(_refField[rf].disabled)
                            }
                            if (allDisabled.every(element => element === true)) {
                                this.hidableRowsHydraulic[hD] = true
                            } else {
                                this.hidableRowsHydraulic[hD] = false
                            }
                        }
                    }
                })
            }
            // this.subReset();
        }
    },
    beforeMount(){

    },
    beforeDestroy() { 
        window.removeEventListener('resize', this.onFormResize)
        if (document.querySelector('.phone_code')) {
            document.querySelector('.phone_code').removeEventListener('click', (e) => { this.onPhoneClick(e, '.phone_code') })
        }
        if (document.querySelector('.phone_number')) {
            document.querySelector('.phone_number').removeEventListener('click', (e) => { this.onPhoneClick(e, '.phone_number') })
        }
    }
  };
</script>
<style scoped>
    .f-subwrap:hover, .f-subwrap:focus { z-index: 2 !important; }
    .f-sublist { display: none; position: absolute; top: 100%; left: 0px; width: 100%; max-height: 300px; overflow: auto; margin: 0; padding: 0; }
    .f-sublist li { display: block; background: #FFF; padding: 0 4px; line-height: 14px; }
    .f-sublist li:hover { background: #0075ff; color: #fff; }
    .f-sub:focus + .f-sublist, .f-sublist.f-show { display: block !important; }
    .selform { padding: 0px 15px 15px; height: calc(100vh - 370px); }
    .selection-car { margin-top: 15px; }
    .selform .selection-car .btn { display: inline-block; width: 200px; color: #FFF;  }
    .car-items,
    .car-selection { border: 1px solid #000; height: calc(100vh - 385px); min-height: 300px; padding: 10px; background: #FFF; }
    .car-items { margin-left: -15px; }
    .car-item-list { overflow-y: auto; overflow-x: hidden; height: calc(100vh - 450px); min-height: 240px; }
    .sel-item-qty { width: 50px; margin: -3px 0 0 4px; border-radius: 0; border: 1px solid #000; }
    .car-item.car-item-head { font-weight: bold; text-transform: uppercase; font-size: 12px; margin-top: -2px; min-height: 14px; }
    .car-item-head label { display: inline-block; width: 194px; }
    .car-item-head .car-item { width: 194px; min-height: 14px; }
    .car-item-head .car-price { width: 22%; }
    .car-item-head .car-qty { width: 12%; }
    .car-items h3,
    .car-selection h3 { background: #000; color: #FFF; font-size: 13px; text-transform: uppercase; padding: 10px; margin: -10px -10px 10px; }
    .car-selection label { width: 100px; }
    .car-item label { display: inline-block; width: 174px; overflow: hidden; text-overflow: ellipsis; }
    .project-form .car-selection select, .project-form .sel-filter > input { min-width: 200px; padding: 6px; text-align: left; text-align-last: left; }
    .project-form .car-selection > select, .project-form .sel-filter > input { width: calc(50% - 5px); float: left; margin: 0 0 10px; }
    .project-form .sel-filter > input { margin-left: 10px; }
    .car-item,
    .selection_items { clear: both; height: calc(100vh - 490px); min-height: 200px; overflow: auto; list-style: none; padding: 0px; }
    .selection_items > li { padding: 4px; border: 1px solid #000; position: relative; margin-top: 6px; }
    .selection_items span { float: right; margin-right: 78px; }
    .selection_items a { background: green; color: #FFF; text-transform: uppercase; cursor: pointer; display: inline-block; padding: 4px 10px; position: absolute; top: 0px; right: 0;}
    .sel-filter > div { margin-top: 4px; }
    .car-item { margin-top: 4px; height: 16px; min-height: 16px; position: relative; overflow: visible; }
    .car-item span { float: right; margin-right: 20px; }
    .car-item a { position: absolute; top: -5px; right: -4px; padding: 0px 6px; font-size: 20px; line-height: 26px; cursor: pointer; opacity: 0; }
    .car-item:hover a { opacity: 1; }
    .car-item a:hover { color: red; }

    .ses-content .form-control { color: #333; }
    .ses-content .fx-datasheet { z-index: 1000; padding-bottom: 90px; }
    .ses-content .fx-datasheet.is_loading { z-index: 99999; }
    table { width: 1000px; margin: 0 auto; }
    table th,
    table td { width: 25%; border: 1px solid #333; }
    .form-wrap { margin-bottom: 40px; color: #000; max-width: 768px; }
    .project-form { font-family: "Arial", sans-serif; font-size: 12px; font-weight: 300; }
    .project-details { width: 880px; }
    .project-form input[type="text"], .project-form input[type="number"], .project-form input[type="email"],
    .project-form select { text-align: center; text-align-last: center; }
    .proj-set {float: left;border: 1px solid #333;width: 400px;box-sizing: border-box;margin-top: -1px;}
    .proj-set-lg { width: 481px; margin-right: -1px; }
    .proj-set-location,
    .proj-set-full { width: 880px; }
    .proj-set label strong { font-size: 13px; text-transform: uppercase; }
    .proj-set label,
    .proj-set input,
    .proj-set select { width: 198px; padding-left: 3px; display: block; float: left; height: 27px; line-height: 27px; margin: 0px; box-sizing: border-box; border: none !important; outline: 1px solid #333; outline-offset: 0px; background: #FFF; }
    .proj-car input[type=number], .proj-car input[type=text], .proj-car select { background: #FFF; }
    .proj-set label { font-weight: 300; width: 200px; margin-right: -1px; }
    .proj-set-full label,
    .proj-set-location label,
    .proj-set-lg label { width: 280px; }
    .proj-set-lg input { width: 199px; }
    .proj-set select { width: 198px; }
    .project-form [disabled],
    .project-form [readonly] { background: #eee !important; opacity: 1; }
    .proj-set-full input { width: 598px; }
    .proj-set-full .select-full { width: 598px; }
    .form_type { margin-left: -1px; }
    .form_type input { width: 14px; margin-right: 10px; outline: none; }
    .form_type label { border: none; outline: none; width: auto; margin-right: 30px; }
    .project-details:after,
    .project-section:after,
    .proj-cars:after,
    .proj-split:after,
    .proj-set:after,
    .top-scroll:after { content: " "; display: block; clear: both; }
    .ind { display: inline-block; width: 10px; height: 13px; }

    .project-section { width: 880px; white-space: nowrap; border: 1px solid #333; }
    .project-form .project-section h2 { font-size: 14px; font-weight: bold; height: 27px; line-height: 27px; margin: 0px; width: 100%; text-align: center; text-transform: none; }
    .project-section label { font-weight: 300; margin: 0px; }
    .proj-labels { background: #FFF; }
    .proj-labels,
    .proj-car { width: 280px; float: left; white-space: normal; }
    .proj-cars { white-space: nowrap; overflow: auto; margin-left: 281px; border-top: 1px solid #333; letter-spacing: 0px; background: #EEE; }
    .top-scroll { white-space: nowrap; overflow: auto; margin-left: 281px; border: 0; letter-spacing: 0px; }
    .proj-car { width: 200px; margin-top: -1px; float: none; display: inline-block; position: relative; z-index: 1; background: #FFF; }
    .proj-car .btn-primary { color: #fff; background: #337ab7; border-color: #2e6da4; }
    .proj-car .btn-success { color: #fff; background: #5cb85c; border-color: #5cb85c; }
    .proj-car .btn-danger { color: #fff; background: #d9534f; border-color: #d9534f; }
    .proj-car .proj-group > div,
    .proj-labels .proj-group > div { display: block; display: flex; box-sizing: border-box; outline: 1px solid #333; outline-offset: 0px; height: 27px; margin-top: 1px; width: 100%; line-height: 27px; }
    .proj-labels .proj-group > div.proj-r2 { height:  55px; height: calc(28px * 2px - 1px); }
    .proj-labels .proj-group > div.proj-r3 { height:  83px; height: calc(28px * 3px - 1px); }
    .proj-labels .proj-group > div.proj-r4 { height: 111px; height: calc(28px * 4px - 1px); }
    .proj-labels .proj-group > div.proj-r5 { height: 139px; height: calc(28px * 5px - 1px); }
    .proj-labels .proj-group > div.proj-r6 { height: 167px; height: calc(28px * 6px - 1px); }
    .proj-labels .proj-group > div.proj-r7 { height: 195px; height: calc(28px * 6px - 1px); }
    .proj-labels .proj-group > div.proj-r8 { height: 223px; height: calc(28px * 6px - 1px); }
    .proj-labels .proj-group > div.proj-r9 { height: 251px; height: calc(28px * 6px - 1px); }
    .proj-labels .proj-group > div.proj-h2 {width: 878px;text-align: center;background: #FFF;z-index: 10;position: relative;}
    .proj-labels .proj-group > div.proj-h3 {width: 878px;text-align: left;background: #FFF;z-index: 10;position: relative;}
    .proj-labels .proj-group > div.proj-h2 label {width:100%;}
    .proj-labels .proj-group > div.proj-h2-field {padding:0px;}
    .proj-labels .proj-group > div.proj-h2-field label {padding-left:3px;width:281px;text-align:left;outline: 1px solid #333; outline-offset: 0px;height:27px;line-height:27px;}
    .proj-labels .proj-group > div.proj-h2-field select,
    .proj-labels .proj-group > div.proj-h2-field input {width:calc(100% - 280px);outline: 1px solid #333; outline-offset: 0px;border:0px;}
    .project-form label { background: #FFF; }
    .proj-car label,
    .proj-labels .proj-group > div { padding-left: 3px; }
    .proj-car label { font-size: 11px; margin: 0px; }
    .proj-car label input[type="checkbox"]{ float: left; margin: 0 3px 0 0; }
    .proj-labels .proj-group > div { position: relative; }
    .proj-car label,
    .proj-labels .proj-group > div label { line-height: 12px; place-self: center; }
    .proj-car input[type="text"], .proj-car input[type="number"],
    .proj-car select { width: 100%; display: block; height: 27px; line-height: 27px; margin: 0px; box-sizing: border-box; border: none !important; outline: 1px solid #333; outline-offset: 0px; padding-left: 3px; place-self: center; text-align: center; text-align-last: center; }
    .proj-car .proj-split { width: 100%; display: flex; }
    .proj-car .proj-split > select,
    .proj-car .proj-split > label,
    .proj-car .proj-split > div,
    .proj-car .proj-split > input { float: left; width: 50%; place-self: center; text-align: center; }
    .proj-car .proj-split.split-2-1 > div { width: 60%; text-align: left; }
    .proj-car .proj-split.split-2-1 > div label { display: block; text-align: left; }
    .proj-car .proj-split.split-2-1 > select { width: 47%; }
    .proj-car .proj-split.dyna > * { flex-basis: 100%; }
    .proj-car .btn-fl,
    .proj-labels .proj-split-lbl { width: 100%; display: flex; }
    .proj-labels .proj-split-lbl > label,
    .proj-labels .proj-split-lbl > div { float: left; width: 50%; place-self: center; text-align: center; }
    .proj-labels .proj-split-lbl > div.vertical-text { width: 7%; }
    .proj-labels .proj-split-lbl > div.split-labels { width: 93%; }
    .proj-labels .proj-split-lbl .split-left-align {
        text-align: left;
    }
    .proj-labels .proj-split-lbl .split-left-align .bb {
        border-bottom: 1px solid black;
    }
    .proj-labels .proj-split-lbl .split-left-align .bl {
        border-left: 1px solid black;
        padding-left: 2px;
    }
    .no-pt {
        padding-top: 0;
        padding-bottom: 0;
    }
    .no-pl {
        padding-left: 0 !important; 
    }
    .proj-split .btn { width: 33.33%; border-radius: 0px; text-transform: uppercase; line-height: 27px; padding: 0px 0px; font-size: 11px; display: inline-block; margin: 0px; }
    .proj-car .btn-fl { width: 100%; color: #337ab7 !important; }
    .proj-car .proj-split > label.proj-chk { text-align: left; line-height: 14px; font-size: 10px; }
    .proj-car .proj-group>div, .proj-labels .proj-group>div { z-index: 1; position: relative; background: #FFF; }
    .proj-labels .proj-group>div { border-right: 1px solid #000; }
    .proj-labels .proj-group>div:hover { z-index: 9999; }

    .checkbox-list { border-left: 1px solid #000; }
    .checkbox-list label { display: block; clear: both; margin: 8px 0; }

    .ie-wrap .proj-split .btn { float: left; margin-right: -1px; height: 27px; }
    .ie-wrap .proj-labels .proj-group > div.proj-h2-field label { float: left; }
    .ie-wrap .proj-labels .proj-group > div.proj-h2-field select { margin-left: 280px; display: block; height: 27px; line-height: 27px; box-sizing: border-box;width:calc(100% - 282px); border-left: none; }

    .hide-copy .js-copy-col1,
    [data-cn="1"] .js-copy-col1 { display: none; }

    .static-cover-wrap { position: relative; }
    .static-cover { position: absolute; top: 0px; left: 0px; width: 100%; height: 100%; background: transparent; z-index: 2; display: block; }

    .proj-labels .mx-datepicker { width: calc(100% - 280px); }
    .proj-labels .mx-datepicker .mx-input-wrapper .mx-input { width: 100%; padding: 0px; height: 27px; border-radius: 0; }

    .proj-set-full { position: relative; }
    .ses-content .btn-remove { position: absolute; top: 2px; right: 2px; cursor: pointer; background: red; color: #FFF; padding: 0px 9px; font-size: 20px; line-height: 21px; }
    .ses-content .btn-caradd { padding: 4px 16px; margin: 10px 0 0; }
    .project-cars-wrap { width: 880px; }
    .proj-set-full .col { padding: 0px; }
    
    .proj-error,
    .proj-car input:focus,
    .proj-set input:focus { outline-color: blue; z-index: 1; position: relative; }
    .proj-car select:focus,
    .proj-set select:focus { outline-color: blue; z-index: 1; }
    .project-form .has-error{ outline: 1px solid red !important; z-index: 2 !important; background: #ffe9e9 !important; border-color: red !important; }
    .proj-error { outline: 1px solid red !important; }
    .proj-set { white-space: nowrap; }
    .proj-set .proj-address { width: 400px; }
    .proj-set .proj-zip { width: 199px; margin-left: 2px; }
    .proj-set-location .proj-label-lg { height: 54px; line-height: 54px; }
    .proj-flex { white-space: nowrap; }
    .proj-flex > div { display: inline-flex; }

    .proj-controls {position: fixed; width: 100%; height: 50px; line-height: 50px; text-align: center;bottom: 0px;left: 0px;z-index: 10000;background: #FFF;box-shadow: 0px 0px 15px #000;}
    .proj-controls .btn { border-radius: 0; min-width: 126px; border: 1px solid #000 !important; padding: 7px 20px; border: 0; background-color: #000; margin-top: 15px; margin-bottom: 15px; color: #fff; font-size: 14px; text-transform: uppercase; margin: 0px 4px; }
    .proj-controls .btn:hover { background: #FFF; color: #000; }
    .proj-controls .progress { position: absolute; bottom: 100%; width: 100%; height: 7px; border-radius: 0; margin: 0; }
    .proj-controls .progress.hidden { display: none; }
    .proj-controls .progress-bar { width: 100%; transform: rotate(180deg); }
    .progress-bar-animated { -webkit-animation: progress-bar-stripes 1s linear infinite; animation: progress-bar-stripes 1s linear infinite; }
    .proj-controls .alert.reqerror { position: absolute; bottom: 100%; margin: 0; padding: 0 10px; line-height: 30px; width: 100%; }

    .show-datasheet { overflow: hidden; }
    .show-datasheet .btn-clc,
    .btn-rqt { display: none !important; }
    .show-datasheet .btn-rqt { display: inline-block !important; }
    .show-datasheet.show-review-1 .js-calculate { display: inline-block !important; }
    .show-datasheet.show-review-1 .js-request { display: none !important; }

    .warning { color: red; padding: 10px 20px 0px; font-size: 14px; }
    .hlight {  }
    .hlight label { color: #F00 !important; }

    .sform .mx-datepicker input { border-radius: 0; height: 27px; box-sizing: border-box; border: none!important; outline: 1px solid #333; outline-offset: 0; }

    .proj-datasheet {position: fixed;width: 100%;background: #FFF;z-index: 10;height: calc(100% - 50px);top: 0px;left: 0px;display: none; overflow: auto; padding: 0 0 10px;}
    .proj-datasheet h3 { text-align: center; margin: 10px 0px; }
    .show-datasheet .proj-datasheet {display: block;}
    .proj-datasheet .content { width: 880px; margin: 0 auto 20px; }
    .proj-datasheet .proj-sheet { width: 100%; margin: 0px; }
    .proj-datasheet .proj-sheet.template { display: none; }
    .proj-datasheet .proj-sheet td { font-size: 12px; font-weight: normal; }
    .proj-datasheet .ds-data td { width: 192px; text-align: center; }
    .proj-datasheet .proj-sheet td:first-child { width: 220px; text-align: right; }
    .proj-datasheet .ds-data tr:first-child td { text-align: center; font-weight: bold; padding: 3px; }
    .proj-datasheet .ds-data td:nth-child(2) { width: 80px; text-align: left; }
    .proj-datasheet .ds-data select { width: 100%; }
    .proj-datasheet .ds-data .dc-acceleration { width: 100%; }

    .project-selections { padding: 0px 14px; width: 880px; border: 1px solid #000; margin-top: -2px; border-left-width: 2px; }
    .selection { padding-top: 4px; padding-bottom: 10px; border: 1px solid #000; position: relative; height: 140px; }
    .selection:after { display: block; clear: both; }

    .selection .doc-wrap { position: absolute; top: 3px; right: 3px; }
    .selection .doc-wrap .dropdown::v-deep .dropdown-toggle,
    .selection .doc-wrap .link { padding: 0; z-index: 12; position: relative; }
    .selection .doc-wrap .dropdown-menu { background: #fff; border: 1px solid #ccc; border-radius: 4px; height: fit-content; min-height: 14px; }
    .selection .doc-wrap .dropdown-menu .dropdown-item { color: #000; padding: 4px 8px; font-size: 12px; white-space: normal; }
    .selection .doc-wrap .dropdown-menu .dropdown-item:not(:last-child) { border-bottom: 1px solid #f2f2f2; }

    input:-webkit-autofill, select:-webkit-autofill { background-color: #FFF !important; }

    .selection label { position: absolute; top: 0; left: 0; width: 100%; height: 100%; padding: 7px 10px; background: url('/api/public/img/form/machine.jpg') no-repeat 10px 15px #FFF; background-size: auto 130px; font-weight: bold; font-size: 14px; filter: grayscale(100%); }
    .selection input { float: left; margin: 0 6px 0 0; width: 16px; height: 16px; }
    .selection ul { position: absolute; bottom: 4px; right: 0px; font-size: 12px; width: 108px; }
    .project-selections .hblack { margin: 0 -15px; width: 880px; }
    .hblack { background: #000; color: #FFF; padding: 0px 9px; font-size: 14px; font-weight: 700; height: 27px; line-height: 27px; margin: 0; width: 100%; }
    .hblack { background: #000; color: #FFF; padding: 0px 9px; font-size: 14px; font-weight: 700; height: 27px; line-height: 27px; margin: 0; width: 100%; }
    .hblack label{ background: transparent; color: #FFF; display: inline-block; margin-left: 20px; }
    .hblack label input { float: left; margin: 6px 5px 0px 0; }
    .proj-labels .proj-group>div.proj-h2-field label.rb2 { border-right: 2px solid #000; width: 282px; }

    .ses-project { border: 2px solid #000; width: 880px; }
    .ses-project .static { background: #eee; text-align: center; }
    .ses-project td { padding: 3px 3px; }
    .ses-project strong { text-transform: uppercase; }
    .ses-project input,
    .ses-project select { width: 100%; margin: -4px -4px; height: 17px; display: block; box-sizing: content-box; }
    .ses-project select { padding: 2px 3px; }
    .ses-project .ses-flex-wrap { padding: 0px; }
    .ses-flex { display: flex; width: 100%; flex-wrap: wrap; overflow: hidden; width: calc(100% + 1px); }
    .ses-col { -ms-flex-preferred-size: 0; flex-basis: 0; -webkit-box-flex: 1; -ms-flex-positive: 1; flex-grow: 1; padding: 3px 0 3px 0px; overflow: hidden; border-right: 1px solid #000; }
    .ses-col input { padding: 1px; }
    .ses-project label { margin: 0 20px 0 0; padding: 0px 8px; }
    .ses-project input[type="radio"] { width: 14px; height: 14px; display: inline-block; margin: 0px 4px 0 0; border: none; float: left; }

    .invi-cover { position: absolute; top: 0px; left: 0px; width: 100%; height: 100%; z-index: 10; background: #000; opacity: .2; }

    .fx-datasheet .project-section { font-size: 12px; text-align: left; margin: 0 auto; }
    .fx-datasheet .proj-car .proj-group > div { text-align: center !important; text-align-last: center; display: block; overflow: hidden; }
    .fx-datasheet .proj-car .proj-group > div label { float: left; margin: 5px 0 0 2px; }
    .fx-datasheet h2 { margin: 0; font-size: 15px; text-align: center; margin: 0 auto; max-width: 880px; }
    .fx-datasheet h2.text-left {
        text-align: left;
        margin-top: 15px;
        font-size: 14px;
        text-transform: uppercase;
        background: #333;
        color: #FFF;
        font-weight: normal;
        padding: 3px 4px 1px;
    }
    @media (max-width: 768px) {
        .form-wrap {
            overflow-y: auto;
        }
        .project-section, .sform {
            min-width: 620px;
        }
    }
    @media (max-width: 1220px) {
        .form-wrap {
            overflow-y: hidden;
        }
        .project-section, .sform {
            width: 100%;
        }
    }

    .phone-wrap {
        display: flex;
        align-items: center;
    }
    .phone-wrap::v-deep input {
        border: 0;
    }
    .phone-wrap::v-deep input:first-child {
        margin-right: 5px;
        text-align: right;
        width: 50%;
    }

    .start_date_wrap {
        width: calc(100% - 280px);
    }
    .start_date_wrap .mx-datepicker {
        width: 100%;
    }
    .start_date_wrap.has-error .mx-datepicker::v-deep .mx-input {
        outline: 1px solid red !important; z-index: 2 !important; background: #ffe9e9 !important; border-color: red !important;
    }

    .name-wrap {
        display: flex;
        align-items: center;
        margin: -4px 0;
    }
    .name-wrap .dropdown {
        width: 22px;
    }
    .name-wrap::v-deep .dropdown .nav-link {
        padding-left: 8px !important;
    }
    .name-wrap::v-deep .dropdown .dropdown-menu {
        max-height: 200px;
        overflow: auto;
    }
    .name-wrap::v-deep .dropdown .dropdown-menu .dropdown-item {
        font-size: 14px;
        padding: .3rem 0.5rem;
        cursor: pointer;
    }
    .top-scroll-body {
        height: 1px;
    }
    .proj-car .proj-split.split-rope-diameter > div.proj-rope-diameter-select { width: 66.5%; }
    .proj-car .proj-split.split-rope-diameter > div.proj-rope-diameter-required { width: 33%; text-align: center; }
    .proj-car .proj-split.split-rope-diameter > div.proj-rope-diameter-required label { text-align: center; }
    .proj-car .proj-split.split-rope-diameter > div.proj-rope-diameter-required label.default-label-mt { margin-top: 7px !important; }
    .proj-car .proj-split.split-rope-diameter > div.proj-rope-diameter-required label.prdr-label { margin: 0 !important; }
    .pads-on-floors { justify-content: center; }
    .fx-datasheet .pads-on-floors > label { float: none !important; margin: 0 !important; }
    .fx-datasheet .pads-on-floors.pf-review > label.mbt-3 { margin-bottom: -3px !important; }
    .capitalize { text-transform: capitalize; }
    .no-sheave-option { justify-content: center; }
    .j-center { justify-content: center; }
    .fx-datasheet .check-input label { float: none !important; }
    .mbt-3 { margin-bottom: -3px !important; }
    /* .vertical-text { transform: rotate(270deg); } */
    .vertical-text { position: relative; overflow: visible; }
    .vertical-text label { font-weight: bold !important; }
    .text-bold label,
    .text-bold label > small { font-weight: bold;}
    .v-required::after {
        overflow: visible;
        font-weight: bold;
        content: "Required";
        transform: rotate(270deg);
        transform-origin: center center;
        position: absolute;
        left: -16px;
        top: -14px;
    }
</style>
